<template>
    <div class="inner-wrapper" v-if="order != null">
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <div
            v-if="commonErrors.length != 0"
            class="alert alert-danger alert-dismissible"
        >
            <a href="#" class="close" data-dismiss="alert" aria-label="close"
                >&times;</a
            >
            <ul>
                <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>

        <!--<div v-if="validationErrors && validationErrors.errors">
            {{validationErrors.errors}}
            <ul>
                <li v-for="(v, k) in validationErrors.errors" :key="k">
                    {{k}}
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </li>
            </ul>
        </div>-->
        <!-- <template v-if="dueTasks && dueTasks.length">

            <template v-for="(task, index) in dueTasks">
                <template
                    v-if="
                        compareString(
                            task.title,
                            'Send Purchase Order to vendor'
                        )
                    "
                >

                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        data-toggle="modal"
                        data-target="#sendPOToVendorModal"
                        >Send to Vendor</a
                    >
                    </div>
                     <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    
                </div>

                </template>
                <template
                    v-else-if="compareString(task.title, 'Create Air Shipment')"
                >
                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="openCreateShipment(true)"
                            >Create Air Shipment</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>

                    
                </template>
                
                <template
                    v-else-if="
                        compareString(task.title, 'Create shipment') ||
                        compareString(task.title, 'Ship remaining items')
                    "
                >

                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                        <div class="df-wrap-center">
                            <span>{{ task.title }}</span> 
                            <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="openCreateShipment(true)"
                            >Create Shipment</a>
                        </div>
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    </div>
                    
                </template>

                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Get a ready date and set a follow up date'
                        )
                    "
                >
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 

                        <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="openGetAReadyDate(task, 'eta')"
                            >Get a ready date</a
                        >
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                </template>
                <template
                    v-else-if="compareString(task.title, 'Confirm ready date')"
                >

                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 

                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="openGetAReadyDate(task, 'confirm')"
                        >{{ task.title }}</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Get Shipping Schedule')
                    "
                >

                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 

                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="openGetAReadyDate(task, 'etd')"
                        >{{ task.title }}</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Approve PI from Vendor')
                    "
                >
                    

                    <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 

                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="artworkSampleRequiredEvent()"
                        >Open Attachment</a>
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="completeTask(task.id)"
                        >No PI provided</a>
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="completeTask(task.id)"
                        >Approve PI</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Send deposit for vendor')
                    "
                >
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="completeTask(task.id)"
                        >Deposit Sent</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                    
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Receive deposit from customer'
                        )
                    "
                >
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                       <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="completeTask(task.id)"
                        >Deposit Received</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                   
                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Customer to approve sample')
                    "
                >
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                       <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="completeTask(task.id)"
                        >Sample Approved</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Vendor Deposit required')
                    "
                >
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                       <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="completeTask(task.id)"
                        >Deposit sent</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Proceed with production')
                    "
                >
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                       <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="completeTask(task.id)"
                        >Proceed</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Sent deposit to vendor')
                    "
                >

                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                        
                    <span class="line-label">Amount</span>
                    <input
                            style="width: 70px"
                            type="text"
                            v-on:keydown="checkDecimal($event, this)"
                            v-model="order.deposit_sent_amount"
                            placeholder=""
                            class="form-control form-control-sm ms-1"
                    />
                    <a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm ms-1"
                            @click="depositSent(task)"
                            >Deposit Sent</a
                        >
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Check for Air Freight')
                    "
                >
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}</span> 
                       <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm ms-1"
                        @click="openCheckAirFreight(task)"
                        >{{ task.title }}</a>
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>

                    
                    
                </template>
                <template v-else> 
                <div class="top-alert alert alert-danger alert-dismissible fade show mb-1" role="alert">
                    <div class="df-wrap-center">
                        <span>{{ task.title }}dd</span> 
                       
                    </div>
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                </div>
                
                </template>
            </template>
        
        </template> -->
        <div class="card track-card">
            <div class="card-body">
                <div class="w-100 d-flex align-items-center">
                <span style="font-weight:bold;">Purchase Order # <span style="color:#303c66;">{{ order.po_number }}</span></span>
                    <ul class="progressbar mb-0 ps-0 flex-grow-1">
                        <li 
                        :class="{
                                done: order.po_status_id == 1,
                                done: order.po_status_id > 1,
                            }"
                        ><span>Open</span></li>
                        <li 
                        :class="{
                                done: order.po_status_id == 2,
                                done: order.po_status_id > 2,
                            }"
                        ><span>Send to customer</span></li>
                        <li 
                        :class="{
                                done: [3, 4, 5, 6, 7].includes(
                                    order.po_status_id
                                ),
                                done: order.po_status_id > 7,
                            }"
                        ><span>Artwork/Sample Approval</span></li>
                        <li 
                         :class="{
                                going: order.po_status_id == 8,
                                going: order.po_status_id > 8,
                            }"
                        
                        ><span>In production</span></li>
                        <li :class="{
                                done: [10, 12].includes(order.po_status_id),
                                done: [9, 11, 12].includes(
                                    order.po_status_id
                                ),
                            }"><span>Pending shipping</span></li>
                        <li
                        :class="{
                                done: [9, 11].includes(order.po_status_id),
                                done: [9].includes(
                                    order.po_status_id
                                ),
                            }"
                        ><span>Shipped</span></li>
                        <!-- <li><span>Shipped/Partially</span></li>
                        <li><span>Delivered</span></li> -->
                    </ul>
                    <div class="dropdown notesectioncl ms-3">

                    <template v-if="order.is_draft != 1">
                            

                            <div
                                class="btn-group customdropdown pull-right ms-1"
                            >
                                <button
                                    type="button"
                                    class="btn btn-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style="
                                        padding: 0.3rem 0.65rem;
                                        font-size: 1.1rem;
                                    "
                                >
                                    <i
                                        class="ri-settings-4-fill align-bottom"
                                    ></i>
                                </button>
                                <div class="dropdown-menu">

                                    
                                    <a
                                        href="#"
                                        class="dropdown-item"
                                        data-toggle="modal"
                                        data-target="#notesModal"
                                        ><i class="ri-sticky-note-line pe-1 align-middle"></i> Notes</a
                                    >

                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        data-toggle="modal"
                                        data-target="#actionLogModal"
                                        ><i
                                            class="ri-history-line pe-1 align-middle"
                                        ></i>
                                        History</a
                                    >
                                    <a
                                        
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        data-toggle="modal"
                                        data-target="#sendPOToVendorModal"
                                        ><i class="fas fa-paper-plane"></i> Send
                                        to Vendor</a
                                    >
                                    <a
                                        data-toggle="modal"
                                        data-target="#addShippingModal"
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        ><i
                                            class="ri-truck-line pe-1 align-middle"
                                        ></i>
                                        Create Shipments</a
                                    >
                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        ><i
                                            class="ri-file-text-line pe-1 align-middle"
                                        ></i>
                                        Create Invoice</a
                                    >
                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        v-on:click="copyPoOrder()"
                                        ><i
                                            class="ri-file-copy-2-line pe-1 align-middle"
                                        ></i>
                                        Copy Order</a
                                    >
                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        v-on:click="downloadPdf()"
                                        ><i
                                            class="ri-file-copy-2-line pe-1 align-middle"
                                        ></i>
                                        Download</a
                                    >
                                    
                                    <!--<a class="dropdown-item" href="javascript:void(0);" v-on:click="downloadPdf"><i
                                        class="ri-download-2-line pe-1 align-middle"></i> Download</a>-->
                                </div>
                            </div>
                        </template>

                        
                    </div>
                </div>
            </div>
        </div>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
            <form
                @submit.prevent="handleSubmit(submitHandler)"
                enctype="multipart/form-data"
            >

        <div class="row cus-col">
                            <div class="col-xl-9 col-xxl-10">
                                <div class="card custom-card">
                                    <div class="card-body py-25">
                                        <div class="mb-2 mt-0 d-flex justify-content-end align-items-end">
                                            <a href="javascript: void(0);" 
                                            class="rtn-edit"
                                            data-toggle="modal"
                                            data-target="#editSalesOrderDetailsModal"
                                            >
                                             <i class="ri-edit-fill me-1"></i> 
                                             Edit</a>
                                        </div>
                                        <div class="row g-0 new-des-status">
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item rounded-left-top-bottom border border-solid border-start w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Purchase Order:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">
                                                    <!-- {{
                                                        order.order
                                                            ? order.order.order_number
                                                            : ""
                                                    }} -->
                                                    {{order.po_number}}
                                                    </p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Status:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{
                                                            order.purchase_order_status
                                                                ? order
                                                                    .purchase_order_status
                                                                    .name
                                                                : ""
                                                        }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">PO date:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.order_date }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Customer PO:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.vendor_po }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Vendor Terms:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.vendor_terms }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Factory Ready Date:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc"><template
                                                v-if="
                                                    order.date_histories &&
                                                    order.date_histories.length
                                                "
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn-primary btn-sm"
                                                    data-toggle="modal"
                                                    data-target="#dateHistoriesModal"
                                                >
                                                    {{ order.eta }}
                                                </a>
                                            </template>
                                            <template v-else>{{
                                                order.eta
                                            }}</template></p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">FOB:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.vendor_fob }}</p>
                                                </div>
                                            </div><!--end col-->
                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item rounded-right-top-bottom border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Added by:</p>
                                                    <p class="text-muted fs-14 mb-0 hd-desc">{{ order.added_by ? order.added_by.name : ""}}</p>
                                                </div>
                                            </div><!--end col-->

                                            <div class="fwefds">
                                                <div class="flex-grow-1 des-status-item rounded-right-top-bottom border border-solid border-start-0 w-100">
                                                    <p class="mb-1 text-uppercase fw-bold">Quote #</p>

                                                    <template v-if="quotations.length > 0">
                                                        <template v-for="(quotation,index) in quotations">
                                                        <p class="text-muted fs-14 mb-0 hd-desc">{{quotation.quotation_number}}</p>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <p class="text-muted fs-14 mb-0 hd-desc">{{order.quote_num}}</p>
                                                    </template>
                                                    
                                                </div>
                                            </div><!--end col-->

                                        </div>
                                    </div>

                                    <div class="custom-block">
                                        <ul class="nav nav-pills nav-light mb-0 ms-3" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" data-toggle="tab" href="#arrow-overview" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-stack-line"></i></span>
                                                    <span class="d-none d-sm-block">Products</span> 
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-attach" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-attachment-2"></i></span>
                                                    <span class="d-none d-sm-block">Attachment/Artwork</span> 
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-ship" ref="shipmentRef" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-home-5-line"></i></span>
                                                    <span class="d-none d-sm-block"> Shipments</span> 
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-invoice" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-file-text-line"></i></span>
                                                    <span class="d-none d-sm-block"> Invoice</span>   
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#arrow-order" role="tab">
                                                    <span class="d-block d-sm-none"><i class="ri-shopping-cart-line"></i></span>
                                                    <span class="d-none d-sm-block"> Sales Order</span>   
                                                </a>
                                            </li>
                                        </ul>
                                        <!-- Tab panes -->
                                        <div class="tab-content card-body text-muted">
                                            <div class="d-flex justify-content-end">
                                            <a
                                                v-if="
                                                    !isEditMode &&
                                                    ((getUser != null &&
                                                        getUser.user_type == 1) ||
                                                        hasRole('Admin') ||
                                                        hasPerm('edit-purchase-order'))
                                                "
                                                style="margin-top: -5px;" 
                                                href="javascript:void(0);"
                                                class="rtn-edit mb-2 fshe"
                                                
                                                v-on:click="changeEditMode(true)"
                                                ><i class="ri-edit-fill me-1"></i>Edit</a
                                            >

                                                
                                                <div class="mb-2 text-end she" style="margin-top: -5px;">
                                                 <button
                                                    v-if="isEditMode"
                                                    type="button"
                                                    :disabled="loading"
                                                    class="btn btn-sm btn-danger me-1"
                                                    @click="
                                                        isEditMode = false;
                                                        getOrder();
                                                    "
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    v-if="isEditMode"
                                                    type="submit"
                                                    :disabled="loading"
                                                    class="btn btn-sm btn-primary"
                                                >
                                                    Save Now
                                                </button>

                                                    <!-- <button class="btn btn-sm btn-danger me-1" id="edit-cancel">Cancel</button>
                                                    <button class="btn btn-sm btn-primary">Save Now</button> -->
                                                </div>
                                            </div>  
                                            <div class="tab-pane active" id="arrow-overview" role="tabpanel">
                                                <div class="table-responsive table-card mt-0 m-0">
                                                    <table class="table table-bordered align-middle mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th scope="col" style="max-width: 110px">Item Number</th>
                                                                <th scope="col" style="min-width: 220px">Product name & Description</th>
                                                                <th scope="col">Quantity</th>
                                                                <th scope="col">
                                                                    <div class="d-flex justify-content-between align-items-center">
                                                                        <div class="me-2">UOM</div>
                                                                        <template v-if="isEditMode">
                                                                        <select  class="form-select form-select-sm she uasd" v-model="changeUnitQuantity">
                                                                            <option value="null">Select</option>
                                                                            <template v-for="(quantityUnit,index) in quantityUnits">
                                                                                <option :value="quantityUnit.id">{{quantityUnit.name}}</option>
                                                                            </template>
                                                                            
                                                                        </select>
                                                                        </template>
                                                                        <!-- <select class="form-select form-select-sm she uasd">
                                                                            <option>Select</option>
                                                                            <option>One</option>
                                                                            <option>Two</option>
                                                                        </select> -->
                                                                    </div>
                                                                </th>
                                                                <th scope="col" style="max-width: 75px;">Unit Price</th>
                                                                <th scope="col" style="max-width: 75px;">Total</th>
                                                                
                                                                <th scope="col" v-if="productExtendedView">Shipped Quantity</th>
                                                                <th scope="col" v-if="productExtendedView">Artwork Status</th>
                                                                <th scope="col" v-if="productExtendedView">Product Status</th>
                                                                <th scope="col" v-if="productExtendedView">SO Number</th>
                                                                <th scope="col" v-if="productExtendedView">Profit</th>
                                                                <th scope="col" class="text-center" style="max-width: 75px">

                                                                <a  class="text-success"
                                                                        href="javascript:void(0)"
                                                                        v-if="
                                                                            !productExtendedView
                                                                        "
                                                                        @click="
                                                                            productExtendedView = true
                                                                        "
                                                                        >Expand</a
                                                                    >
                                                                    <a
                                                                    class="text-success"
                                                                        href="javascript:void(0)"
                                                                        v-if="
                                                                            productExtendedView
                                                                        "
                                                                        @click="
                                                                            productExtendedView = false
                                                                        "
                                                                        >Hide</a
                                                                    >

                                                                    <!-- <a href="javascript: void(0);" id="flvw" class="text-success">Expand</a>
                                                                    <a href="javascript: void(0);" id="vwvw" class="text-success" style="display: none;">Hide</a> -->
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr  v-for="(product, index) in order.products" :key="'item-field-' +index">
                                                                <td class="fw-medium" style="max-width: 110px">
                                                                    <template
                                                                    v-if="
                                                                        !isEditMode &&
                                                                        product.order_product
                                                                    "
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'productsDetails',
                                                                            params: {
                                                                                id: product
                                                                                    .order_product
                                                                                    .product_id,
                                                                            },
                                                                        }"
                                                                        title="Item Detail"
                                                                        target="_blank"
                                                                    >
                                                                        {{
                                                                            product.product_num
                                                                        }}
                                                                       
                                                                        

                                                                    </router-link>
                                                                    <template v-if="product.order_product.product">
                                                                            <p v-if="product.order_product.product.customer_sku">
                                                                            Customer SKU: {{
                                                                            product.order_product.product ?  product.order_product.product.customer_sku : ""
                                                                            }}
                                                                            </p>
                                                                        
                                                                        
                                                                        </template>
                                                                        
                                                                </template>
                                                                    <div class="she" v-if="isEditMode">
                                                                    <input type="text" class="form-control" placeholder="Item#"  v-model="order.products[index].product_num" />
                                                                    </div>
                                                                </td>
                                                                <td style="min-width: 220px">
                                                                   <div class="fshe">
                                                                    <template v-if="!isEditMode">
                                                                        <p>{{product.product_name}}
                                                                        </p>
                                                                        <p v-html="product.product_desc"></p>
                                                                    </template>
                                                                    <div class="she">
                                                                    <ValidationProvider
                                                                    name="Product Name"
                                                                    rules="required"
                                                                    v-slot="{
                                                                        errors,
                                                                    }"
                                                                >
                                                                    <input
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        v-model="
                                                                            order
                                                                                .products[
                                                                                index
                                                                            ]
                                                                                .product_name
                                                                        "
                                                                        type="text"
                                                                        class="form-control form-custom mb-1"
                                                                        placeholder=""
                                                                    />
                                                                    <div
                                                                        class="error"
                                                                        v-if="
                                                                            errors.length
                                                                        "
                                                                    >
                                                                        {{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </ValidationProvider>
                                                                <ckeditor
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    v-model="
                                                                        order
                                                                            .products[
                                                                            index
                                                                        ]
                                                                            .product_desc
                                                                    "
                                                                    type="inline"
                                                                    :config="
                                                                        editorConfigMin
                                                                    "
                                                                ></ckeditor>
                                                                    </div>
                                                                </div>
                                                                   
                                                                </td>
                                                                <td style="max-width: 75px;">
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Quantity"
                                                                        immediate
                                                                        rules="required|positive|min_value:1"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                    <div class="fshe">
                                                                     <input
                                                                            type="text"
                                                                            class="form-control form-custom"
                                                                            v-on:keydown="
                                                                                checkNumber(
                                                                                    $event
                                                                                )
                                                                            "
                                                                            placeholder=""
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .quantity
                                                                            "
                                                                        />
                                                                    </div>
                                                                       
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >

                                                                <template v-if="product.qty_unit">

                                                                    <template v-if="product.qty_unit.name == 'M Bags'">
                                                                        <div class="fshe">{{numberWithCommas(product.quantity * 1000)}}</div>
                                                                    </template>
                                                                    <template v-else-if="product.qty_unit.name == 'M Impressions'">
                                                                    <div class="fshe">{{numberWithCommas(product.quantity * 1000)}}</div>
                                                                    </template>
                                                                    <template v-else>
                                                                    <div class="fshe">{{product.quantity}}</div>
                                                                    
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                <div class="fshe">{{product.quantity}}</div>
                                                                </template>

                                                                


                                                                    
                                                                </template>

                                                                    
                                                                    
                                                                </td>
                                                                <td style="max-width: 85px;">

                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Quantity unit"
                                                                        rules="required"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    ><div class="she">
                                                                        <select
                                                                            class="form-control"
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .qty_unit_id
                                                                            "
                                                                        >
                                                                            <option
                                                                                value=""
                                                                            >
                                                                                Select
                                                                            </option>
                                                                            <option
                                                                                v-for="(
                                                                                    qtyUnit,
                                                                                    unitIndex
                                                                                ) in quantityUnits"
                                                                                :value="
                                                                                    qtyUnit.id
                                                                                "
                                                                            >
                                                                                {{
                                                                                    qtyUnit.name
                                                                                }}
                                                                            </option>
                                                                        </select>
                                                                        </div>
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                <div class="fshe">{{product.qty_unit ? product.qty_unit.name : "" }}</div>
                                                                    
                                                                </template>
                                                                </td>
                                                                <td style="max-width: 75px;">
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Price"
                                                                        rules="required|positive|min_value:1"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                    <div class="she">
                                                                        <input
                                                                            type="text"
                                                                            class="form-control form-custom"
                                                                            placeholder=""
                                                                            v-on:keydown="
                                                                                checkDecimal(
                                                                                    $event,
                                                                                    this
                                                                                )
                                                                            "
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .price
                                                                            "
                                                                        />
                                                                        </div>
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                <div class="fshe">{{ numberWithCommas(product.price)}}</div>
                                                                    
                                                                </template>

                                                                    
                                                                    
                                                                </td>
                                                                <td style="max-width: 75px;">
                                                                    <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Cost"
                                                                        rules="required|positive|min_value:1"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                    <div class="she">
                                                                        <input
                                                                            type="text"
                                                                            class="form-control form-custom"
                                                                            placeholder=""
                                                                            v-on:keydown="
                                                                                checkDecimal(
                                                                                    $event,
                                                                                    this
                                                                                )
                                                                            "
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .cost
                                                                            "
                                                                        />
                                                                        </div>
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                <div class="fshe">{{ numberWithCommas(product.cost)}}</div>
                                                                    
                                                                </template>
                                                                </td>
                                                                
                                                                <td  v-if="productExtendedView">
                                                                {{  numberWithCommas(getTotalShippingQty(product)) }}
                                                                <!-- <template
                                                                    v-if="
                                                                        product.order_product &&
                                                                        product
                                                                            .order_product
                                                                            .quote_product &&
                                                                        product
                                                                            .order_product
                                                                            .quote_product
                                                                            .quotation
                                                                    "
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'viewQuote',
                                                                            params: {
                                                                                id: product
                                                                                    .order_product
                                                                                    .quote_product
                                                                                    .quotation
                                                                                    .id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                    >
                                                                        #{{
                                                                            product
                                                                                .order_product
                                                                                .quote_product
                                                                                .quotation
                                                                                .quotation_number
                                                                        }}
                                                                    </router-link>
                                                                </template> -->
                                                                
                                                                </td>
                                                                <td v-if="productExtendedView">
                                                                <template
                                                                    v-if="
                                                                        product.order_product &&
                                                                        product
                                                                            .order_product
                                                                            .artworks &&
                                                                        product
                                                                            .order_product
                                                                            .artworks
                                                                            .length
                                                                    "
                                                                >
                                                                    {{
                                                                        product
                                                                            .order_product
                                                                            .artworks[
                                                                            product
                                                                                .order_product
                                                                                .artworks
                                                                                .length -
                                                                                1
                                                                        ]
                                                                            .artwork_status
                                                                            ? product
                                                                                  .order_product
                                                                                  .artworks[
                                                                                  product
                                                                                      .order_product
                                                                                      .artworks
                                                                                      .length -
                                                                                      1
                                                                              ]
                                                                                  .artwork_status
                                                                                  .name
                                                                            : null
                                                                    }}
                                                                    <!--<div v-for="(art) in product.order_product.artworks">
                                                                    V-{{art.version_number}}: {{art.artwork_status ? art.artwork_status.name : null}}
                                                                </div>-->
                                                                </template>
                                                                </td>
                                                                <td v-if="productExtendedView">{{product.status}}</td>
                                                                <td v-if="productExtendedView">
                                                                <template
                                                                    v-if="
                                                                        order.order
                                                                    "
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'orderShow',
                                                                            params: {
                                                                                id: order.order_id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                    >
                                                                        #{{
                                                                            order
                                                                                .order
                                                                                .order_number
                                                                        }}
                                                                    </router-link>
                                                                </template>
                                                                </td>
                                                                <td v-if="productExtendedView" class="hidden fw-medium">
                                                                    {{
                                                                    numberWithCommas(
                                                                        product.calculated_profit
                                                                    )
                                                                }}
                                                                </td>
                                                                
                                                                <td class="text-center" style="max-width: 75px">
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    v-if="
                                                                        (getUser !=
                                                                            null &&
                                                                            getUser.user_type ==
                                                                                1) ||
                                                                        hasRole(
                                                                            'Admin'
                                                                        )
                                                                    "
                                                                    v-on:click="
                                                                        removeItem(
                                                                            product.id
                                                                        )
                                                                    "
                                                                    class="trashBtn text-danger me-0"
                                                                    style="font-size: 18px"
                                                                    ><i class="ri-delete-bin-6-line"></i>
                                                                    </a>
                                                                    
                                                                </td>
                                                            </tr>
                                                            
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="table-responsive">
                                                    <table class="table table-borderless mb-0">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <div class="mb-3">
                                                                        <h5 style="font-size: 14px; font-weight: 500; margin: 8px 0px;">Additional Notes</h5>
                                                                        
                                                                        
                                                                         <vue-editor  v-if="
                                                                                isEditMode
                                                                            "
                                                                            v-model="order.notes" :editorToolbar="getQuillToolbar()"></vue-editor>
                                                                        <!-- <textarea v-if="isEditMode"
                                                                            class="form-control"
                                                                            v-model="
                                                                                order.notes
                                                                            "
                                                                            placeholder=""
                                                                            rows="2"
                                                                            style="
                                                                                height: 66px;
                                                                                overflow-y: hidden;
                                                                            "
                                                                        ></textarea> -->

                                                                        <p class="fshe text-muted"
                                                                            v-if="
                                                                                !isEditMode
                                                                            "
                                                                            v-html="
                                                                                order.notes
                                                                            "
                                                                        ></p>

                                                                        
                                                                    </div>
                                                                    <div>
                                                                        <h5 style="font-size: 14px; font-weight: 500; margin: 8px 0px;">Order Notes</h5>
                                                                        <vue-editor  v-if="
                                                                                isEditMode
                                                                            "
                                                                            v-model="order.vendor_notes" :editorToolbar="getQuillToolbar()"></vue-editor>
                                                                        

                                                                        
                                                                        <!-- <textarea
                                                                            v-if="
                                                                                isEditMode
                                                                            "
                                                                            class="form-control"
                                                                            v-model="
                                                                                order.vendor_notes
                                                                            "
                                                                            placeholder=""
                                                                            rows="2"
                                                                            style="
                                                                                height: 66px;
                                                                                overflow-y: hidden;
                                                                            "
                                                                        ></textarea> -->

                                                                        <p class="fshe text-muted"
                                                                            v-if="
                                                                                !isEditMode
                                                                            "
                                                                            v-html="
                                                                                order.vendor_notes
                                                                            "
                                                                        ></p>
                                                                        
                                                                    </div>


                                                                    <div>
                                                                        <h5 style="font-size: 14px; font-weight: 500; margin: 8px 0px;">PDF Notes</h5>
                                                                        <vue-editor  v-if="
                                                                                isEditMode
                                                                            "
                                                                            v-model="order.pdf_note" :editorToolbar="getQuillToolbar()"></vue-editor>
                                                                        
                                                                        <p class="fshe text-muted"
                                                                            v-if="
                                                                                !isEditMode
                                                                            "
                                                                            v-html="
                                                                                order.pdf_note
                                                                            "
                                                                        ></p>
                                                                        
                                                                    </div>

                                                                </td>
                                                                <td style="width: 310px">
                                                                    <table class="table custom-table-price mb-0">
                                                                        <tbody>
                                                                            
                                                                            <tr>
                                                                                <td><strong>Sub Total</strong></td>
                                                                                <td class="text-end"><strong>${{
                                                                                        numberWithCommas(
                                                                                            sub_total_cost
                                                                                        )
                                                                                    }}</strong></td>
                                                                            </tr>
                                                                            <tr>
                                                                            <td>
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length ==
                                                                                        0
                                                                                    "
                                                                                    data-toggle="modal"
                                                                                    data-target="#purchaseOrderDiscountModal"
                                                                                    >Add
                                                                                    discount</a
                                                                                >
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    v-else
                                                                                    data-toggle="modal"
                                                                                    data-target="#purchaseOrderDiscountModal"
                                                                                    >Edit
                                                                                    discount</a
                                                                                >
                                                                                <p
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        order
                                                                                            .discounts[0]
                                                                                            .reason
                                                                                    }}
                                                                                </p>
                                                                            </td>
                                                                            
                                                                                
                                                                                <td class="text-end">
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    -${{
                                                                                        getDiscountAmount()
                                                                                    }}
                                                                                </template>
                                                                                <template
                                                                                    v-else
                                                                                    >-</template
                                                                                >
                                                                                </td>
                                                                            </tr>
                                                                            
                                                                            <tr>
                                                                                <td>
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .charges
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    <p
                                                                                        v-for="(
                                                                                            charge,
                                                                                            index
                                                                                        ) in order.charges"
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0);"
                                                                                            v-on:click="
                                                                                                editCharge(
                                                                                                    charge
                                                                                                )
                                                                                            "
                                                                                            >{{
                                                                                                charge.cost_type
                                                                                            }}:</a
                                                                                        >
                                                                                        <template
                                                                                            v-if="
                                                                                                charge.quantity !=
                                                                                                    null &&
                                                                                                charge.quantity >
                                                                                                    0
                                                                                            "
                                                                                        >
                                                                                            ${{
                                                                                                charge.amount
                                                                                            }}
                                                                                            x{{
                                                                                                charge.quantity
                                                                                            }}
                                                                                        </template>
                                                                                    </p>
                                                                                </template>
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    data-toggle="modal"
                                                                                    data-target="#purchaseOrderExtraChargeModal"
                                                                                    >Additional
                                                                                    charge</a
                                                                                >
                                                                            </td>
                                                                            <td
                                                                            class="text-end"
                                                                            >
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .charges
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    <p
                                                                                        v-for="(
                                                                                            charge,
                                                                                            index
                                                                                        ) in order.charges"
                                                                                    >
                                                                                    <template v-if="isNumber(charge.amount)">
                                                                                        ${{
                                                                                            charge.quantity !=
                                                                                                null &&
                                                                                            charge.quantity >
                                                                                                0
                                                                                                ? charge.amount *
                                                                                                  charge.quantity
                                                                                                : charge.amount
                                                                                        }}
                                                                                    </template>
                                                                                    <template v-else>
                                                                                    $0.00
                                                                                    </template>

                                                                                        
                                                                                    </p>
                                                                                </template>
                                                                                <template
                                                                                    v-else
                                                                                >
                                                                                    _</template
                                                                                >
                                                                            </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="border-bottom-0"><strong>Total</strong></td>
                                                                                <td class="text-end border-bottom-0"><strong>${{
                                                                                        numberWithCommas(
                                                                                            getTotal()
                                                                                        )
                                                                                    }}</strong></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <div class="tab-pane" id="arrow-attach" role="tabpanel">
                                            <template v-if="order.products.length >1">
                                                    <h5>All Artworks</h5>
                                                <div class="table-responsive table-card mt-0 m-0">
                                                    <table class="table table-bordered mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th scope="col">Original customer file</th>
                                                                <th scope="col">Artwork Proof</th>
                                                                <th scope="col">Artwork Status</th>
                                                                <th scope="col">Comments</th>
                                                                <th scope="col"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                       
                                                            <template
                            v-if="
                                order
                                    .order
                                    .artworks
                                    .length >
                                0
                            "
                        >
                            <template
                                v-for="(
                                    artwork,
                                    artworkIndex
                                ) in order
                                    .order
                                    .artworks"
                            >
                                <tr
                                    v-if="
                                        (order
                                            .order
                                            .latest_artwork &&
                                            artwork.id ==
                                                order
                                                    .order
                                                    .latest_artwork
                                                    .id) ||
                                        artwork.id ==
                                            null
                                    "
                                >
                                    <td>
                                        <div
                                            class="filetitlesec info-file mb-1"
                                        >
                                            <div
                                                class="filetitleleft"
                                                v-if="
                                                    order
                                                        .order
                                                        .original_customer_file
                                                "
                                            >
                                                <div
                                                    class="ellipsis"
                                                >
                                                    <span
                                                        :title="
                                                            order
                                                                .order
                                                                .original_customer_file
                                                        "
                                                        >{{
                                                            order
                                                                .order
                                                                .original_customer_file
                                                                | truncate(
                                                                    isEditMode
                                                                        ? 22
                                                                        : 30
                                                                )
                                                        }}</span
                                                    >
                                                </div>
                                            </div>
                                            <div
                                                class="filetitleright"
                                            >
                                                <div
                                                    class="file-attachment-wrapper"
                                                    v-if="
                                                        (getUser !=
                                                            null &&
                                                            getUser.user_type ==
                                                                1) ||
                                                        hasRole(
                                                            'Admin'
                                                        )
                                                    "
                                                >
                                                    <vue-dropzone
                                                        :options="
                                                            dropzoneOptionsOriginalFile
                                                        "
                                                        :id="
                                                            'item-original-file-' +
                                                            artworkIndex
                                                        "
                                                        :useCustomSlot="
                                                            true
                                                        "
                                                        ref="allProductsOriginalFileVueDropzone"
                                                        v-on:vdropzone-success="
                                                            (
                                                                file,
                                                                response
                                                            ) =>
                                                                afterAllProductsOriginalFileUploadComplete(
                                                                    file,
                                                                    response
                                                                )
                                                        "
                                                        v-on:vdropzone-error="
                                                            (
                                                                file,
                                                                message,
                                                                xhr
                                                            ) =>
                                                                allProductsOriginalFileUploadError(
                                                                    file,
                                                                    message,
                                                                    xhr
                                                                )
                                                        "
                                                    >
                                                        <div
                                                            class="dropzone-custom-content"
                                                        >
                                                            <h3
                                                                class="dropzone-custom-title"
                                                                v-if="
                                                                    order
                                                                        .order
                                                                        .original_customer_file !=
                                                                    null
                                                                "
                                                            >
                                                                <i
                                                                    class="fa fa-upload"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                Replace
                                                            </h3>
                                                            <h3
                                                                class="dropzone-custom-title"
                                                                v-else
                                                            >
                                                                <i
                                                                    class="fa fa-upload"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                Drag
                                                                and
                                                                drop
                                                                to
                                                                upload
                                                                content!
                                                            </h3>
                                                        </div>
                                                    </vue-dropzone>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class="orderbtnsec2 d-file"
                                            v-if="
                                                order
                                                    .order
                                                    .original_customer_file
                                            "
                                        >
                                            <div
                                                class="filetitlesec"
                                            >
                                                <div
                                                    class="filetitleleft"
                                                >
                                                    <span
                                                        class="orderbtnsec"
                                                    >
                                                        <a
                                                            href="javascript:void(0)"
                                                            v-on:click="
                                                                downloadOriginalArtwork(
                                                                    order
                                                                        .order
                                                                        .original_customer_file
                                                                )
                                                            "
                                                            class="downlodbtn"
                                                            >Download</a
                                                        >
                                                    </span>
                                                </div>
                                                <div
                                                    class="filetitleright"
                                                >
                                                    <span
                                                        class="orderbtnsec"
                                                    >
                                                        <a
                                                            class="btn btn-sm btn-primary"
                                                            href="javascript:void(0)"
                                                            v-if="
                                                                !isEditMode &&
                                                                ((getUser !=
                                                                    null &&
                                                                    getUser.user_type ==
                                                                        1) ||
                                                                    hasRole(
                                                                        'Admin'
                                                                    ))
                                                            "
                                                            v-on:click="
                                                                openSendAllArtworkToVendor()
                                                            "
                                                            >Send
                                                            to
                                                            vendor</a
                                                        >
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            class="filetitlesec info-file mb-1"
                                        >
                                            <div
                                                class="filetitleleft"
                                                v-if="
                                                    artwork.id &&
                                                    artwork.attach_link
                                                "
                                            >
                                                <div
                                                    class="ellipsis"
                                                >
                                                    <span
                                                        :title="
                                                            artwork.attach_link
                                                        "
                                                        >{{
                                                            artwork.attach_link
                                                                | truncate(
                                                                    isEditMode
                                                                        ? 30
                                                                        : 40
                                                                )
                                                        }}</span
                                                    >
                                                </div>
                                            </div>
                                            <div
                                                class="filetitleright"
                                            >
                                                <div
                                                    class="file-attachment-wrapper"
                                                    v-if="
                                                        (getUser !=
                                                            null &&
                                                            getUser.user_type ==
                                                                1) ||
                                                        hasRole(
                                                            'Admin'
                                                        )
                                                    "
                                                >
                                                    <vue-dropzone
                                                        :options="
                                                            dropzoneOptionsArtwork
                                                        "
                                                        :id="
                                                            'other-dropzone-' +
                                                            artworkIndex
                                                        "
                                                        :useCustomSlot="
                                                            true
                                                        "
                                                        :key="
                                                            artworkIndex
                                                        "
                                                        ref="allProductsArtworkFileVueDropzone"
                                                        v-on:vdropzone-success="
                                                            (
                                                                file,
                                                                response
                                                            ) =>
                                                                afterAllArtworkUploadComplete(
                                                                    file,
                                                                    response,
                                                                    artworkIndex
                                                                )
                                                        "
                                                        v-on:vdropzone-error="
                                                            (
                                                                file,
                                                                message,
                                                                xhr
                                                            ) =>
                                                                allArtworkUploadError(
                                                                    file,
                                                                    message,
                                                                    xhr,
                                                                    artworkIndex
                                                                )
                                                        "
                                                    >
                                                        <div
                                                            class="dropzone-custom-content"
                                                            v-if="
                                                                artwork.id &&
                                                                artwork.attach_link
                                                            "
                                                        >
                                                            <h3
                                                                class="dropzone-custom-title"
                                                                v-if="
                                                                    artwork.attach_link !=
                                                                    null
                                                                "
                                                            >
                                                                <i
                                                                    class="fa fa-upload"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                Replace
                                                            </h3>
                                                            <h3
                                                                class="dropzone-custom-title"
                                                                v-else
                                                            >
                                                                <i
                                                                    class="fa fa-upload"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                Drag
                                                                and
                                                                drop
                                                                to
                                                                upload
                                                                content!
                                                            </h3>
                                                        </div>
                                                    </vue-dropzone>
                                                </div>
                                            </div>
                                        </div>

                                        <span
                                            class="orderbtnsec d-file mb-1"
                                            v-if="
                                                artwork.id &&
                                                artwork.attach_link
                                            "
                                        >
                                            <a
                                                href="javascript:void(0)"
                                                v-if="
                                                    [
                                                        'png',
                                                        'jpg',
                                                        'jpeg',
                                                    ].some(
                                                        (
                                                            image
                                                        ) =>
                                                            artwork.attach_link
                                                                .toLowerCase()
                                                                .includes(
                                                                    image
                                                                )
                                                    )
                                                "
                                                @click="
                                                    imagePreview(
                                                        artwork.attach_link
                                                    )
                                                "
                                                class="downlodbtn fw-medium me-2"
                                                >Preview</a
                                            >
                                            <a
                                                href="javascript:void(0)"
                                                v-on:click="
                                                    download(
                                                        artwork
                                                    )
                                                "
                                                class="fw-medium me-2"
                                            >
                                                Download</a
                                            >
                                        </span>

                                        <div
                                            class="orderbtnsec-title v-info"
                                            v-if="
                                                artwork.id
                                            "
                                        >
                                            <div
                                                class="title-left d-flex justify-content-between me-2"
                                            >
                                                <span class="mb-0"
                                                    >V-{{
                                                        artwork.version_number
                                                    }} Uploaded
                                                    {{
                                                        artwork.updated_at
                                                    }}</span
                                                >
                                                <a
                                                    href="javascript:void(0)"
                                                    v-if="
                                                        (getUser !=
                                                            null &&
                                                            getUser.user_type ==
                                                                1) ||
                                                        hasRole(
                                                            'Admin'
                                                        )
                                                    "
                                                    v-on:click="
                                                        addNewAllProductArtwork()
                                                    "
                                                    class="add-versionbtn fw-medium text-warning"
                                                    >Add
                                                    version</a
                                                >
                                                <!-- <span class="fw-medium text-warning"
                                                    >Uploaded
                                                    {{
                                                        artwork.updated_at
                                                    }}</span
                                                > -->
                                            </div>
                                            <!-- <div
                                                class="title-btnsec"
                                            >
                                                <a
                                                    href="javascript:void(0)"
                                                    v-if="
                                                        (getUser !=
                                                            null &&
                                                            getUser.user_type ==
                                                                1) ||
                                                        hasRole(
                                                            'Admin'
                                                        )
                                                    "
                                                    v-on:click="
                                                        addNewAllProductArtwork()
                                                    "
                                                    class="add-versionbtn fw-medium text-warning"
                                                    >Add
                                                    version</a
                                                >
                                            </div> -->
                                        </div>

                                        <div class="d-file mb-1">
                                            <template v-if="artwork.id && artwork.attach_link">
                                                <template
                                                v-if="
                                                    order
                                                        .order
                                                        .latest_artwork &&
                                                    order
                                                        .order
                                                        .latest_artwork
                                                        .attach_link !=
                                                        null &&
                                                    order
                                                        .order
                                                        .latest_artwork
                                                        .attach_link !=
                                                        '' &&
                                                    !isEditMode
                                                "
                                            >
                                                <a
                                                    href="javascript:void(0)"
                                                    v-if="
                                                        (getUser !=
                                                            null &&
                                                            getUser.user_type ==
                                                                1) ||
                                                        hasRole(
                                                            'Admin'
                                                        )
                                                    "
                                                    @click="
                                                        openSendAllArtworkToCustomer(
                                                            true
                                                        )
                                                    "
                                                    class="btn btn-sm btn-primary"
                                                    >Send
                                                    to
                                                    customer</a
                                                >
                                            </template>


                                            </template>
                                            <template v-if="artwork.id">
                                                 <a
                                                v-if="
                                                    order.order.artworks.filter(
                                                        (
                                                            x
                                                        ) =>
                                                            x.id !=
                                                            null
                                                    )
                                                        .length
                                                "
                                                class="btn btn-sm btn-primary"
                                                @click="
                                                    openAllProductsArtworkVersionsModal()
                                                "
                                                href="javascript:void(0)"
                                                >Previous
                                                version</a
                                            >
                                            </template>
                                        </div>
                                        
                                        
                                    </td>
                                    <td>
                                        <template
                                            v-if="
                                                isEditMode
                                            "
                                        >
                                            <div
                                                class="input-group"
                                            >
                                                <ValidationProvider
                                                    name="ArtworkStatus"
                                                    rules="required"
                                                    v-slot="{
                                                        errors,
                                                    }"
                                                >
                                                    <select
                                                        class="form-control"
                                                        v-model="
                                                            order
                                                                .order
                                                                .artworks[
                                                                artworkIndex
                                                            ]
                                                                .artwork_status_id
                                                        "
                                                        @change="
                                                            artworkStatusChangeForAll
                                                        "
                                                    >
                                                        <option
                                                            :value="
                                                                null
                                                            "
                                                        >
                                                            Select
                                                        </option>
                                                        <option
                                                            v-for="(
                                                                status,
                                                                index
                                                            ) in artwork_statuses"
                                                            :value="
                                                                status.id
                                                            "
                                                        >
                                                            {{
                                                                status.name
                                                            }}
                                                        </option>
                                                    </select>
                                                    <div
                                                        class="error"
                                                        v-if="
                                                            errors.length
                                                        "
                                                    >
                                                        {{
                                                            errors[0]
                                                        }}
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </template>
                                        <template
                                            v-if="
                                                !isEditMode
                                            "
                                        >
                                            {{
                                                artwork.artwork_status
                                                    ? artwork
                                                          .artwork_status
                                                          .name
                                                    : null
                                            }}
                                            <span
                                                class="orderbtnsec"
                                                v-if="
                                                    artwork.id &&
                                                    artwork.attach_link
                                                "
                                            >
                                                <a
                                                    href="javascript:void(0)"
                                                    v-if="
                                                        artwork
                                                            .comments
                                                            .length &&
                                                        artwork.artwork_status_id ==
                                                            7
                                                    "
                                                    @click="
                                                        viewComments(
                                                            artwork
                                                        )
                                                    "
                                                    >View
                                                    Comments</a
                                                >
                                            </span>
                                        </template>
                                    </td>
                                    <td>
                                        <textarea
                                            v-if="
                                                isEditMode
                                            "
                                            class="form-control resize-ta"
                                            v-model="
                                                order
                                                    .order
                                                    .artworks[
                                                    artworkIndex
                                                ]
                                                    .comment
                                            "
                                            style="
                                                height: 66px;
                                                overflow-y: hidden;
                                            "
                                        ></textarea>
                                        <p
                                            v-if="
                                                !isEditMode
                                            "
                                            v-html="
                                                artwork.comment
                                            "
                                        ></p>
                                    </td>
                                    <td>
                                        <a
                                            href="javascript:void(0)"
                                            v-if="
                                                (getUser !=
                                                    null &&
                                                    getUser.user_type ==
                                                        1) ||
                                                hasRole(
                                                    'Admin'
                                                )
                                            "
                                            v-on:click="
                                                removeAllProductArtwork(
                                                    artworkIndex,
                                                    artwork.id
                                                )
                                            "
                                            class="trashBtn"
                                            ><i
                                                class="ri-delete-bin-6-line"
                                            ></i
                                        ></a>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <template
                            v-else
                        >
                            <tr>
                                <td>
                                    <template
                                        v-if="
                                            order
                                                .order
                                                .original_customer_file
                                        "
                                    >
                                        <span
                                            :title="
                                                order
                                                    .order
                                                    .original_customer_file
                                            "
                                            >{{
                                                order
                                                    .order
                                                    .original_customer_file
                                                    | truncate(
                                                        isEditMode
                                                            ? 22
                                                            : 30
                                                    )
                                            }}</span
                                        >
                                        <div
                                            class="filetitlesec"
                                        >
                                            <div
                                                class="filetitleleft"
                                            >
                                                <span
                                                    class="orderbtnsec"
                                                >
                                                    <a
                                                        href="javascript:void(0)"
                                                        v-on:click="
                                                            downloadOriginalArtwork(
                                                                order
                                                                    .order
                                                                    .original_customer_file
                                                            )
                                                        "
                                                        class="fw-medium me-2"
                                                        >Download</a
                                                    >
                                                </span>
                                            </div>
                                            <div
                                                class="filetitleright"
                                            >
                                                <span
                                                    class="orderbtnsec"
                                                >
                                                    <a
                                                        class="btn btn-sm btn-primary"
                                                        href="javascript:void(0)"
                                                        v-if="
                                                            !isEditMode &&
                                                            ((getUser !=
                                                                null &&
                                                                getUser.user_type ==
                                                                    1) ||
                                                                hasRole(
                                                                    'Admin'
                                                                ))
                                                        "
                                                        v-on:click="
                                                            openSendAllArtworkToVendor()
                                                        "
                                                        >Send
                                                        to
                                                        vendor</a
                                                    >
                                                </span>
                                            </div>
                                        </div>
                                    </template>

                                    <div
                                        class="filetitlesec"
                                    >
                                        <div
                                            class="file-attachment-wrapper"
                                            v-if="
                                                (getUser !=
                                                    null &&
                                                    getUser.user_type ==
                                                        1) ||
                                                hasRole(
                                                    'Admin'
                                                )
                                            "
                                        >
                                            <vue-dropzone
                                                :options="
                                                    dropzoneOptionsOriginalFile
                                                "
                                                :id="'item-original-file-1asd'"
                                                :useCustomSlot="
                                                    true
                                                "
                                                ref="allProductsOriginalFileVueDropzone"
                                                v-on:vdropzone-success="
                                                    (
                                                        file,
                                                        response
                                                    ) =>
                                                        afterAllProductsOriginalFileUploadComplete(
                                                            file,
                                                            response
                                                        )
                                                "
                                                v-on:vdropzone-error="
                                                    (
                                                        file,
                                                        message,
                                                        xhr
                                                    ) =>
                                                        allProductsOriginalFileUploadError(
                                                            file,
                                                            message,
                                                            xhr
                                                        )
                                                "
                                            >
                                                <div
                                                    class="dropzone-custom-content"
                                                >
                                                    <h3
                                                        class="dropzone-custom-title"
                                                        v-if="
                                                            order
                                                                .order
                                                                .original_customer_file !=
                                                            null
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-upload"
                                                            aria-hidden="true"
                                                        ></i>
                                                        Replace
                                                    </h3>
                                                    <h3
                                                        class="dropzone-custom-title"
                                                        v-else
                                                    >
                                                        <i
                                                            class="fa fa-upload"
                                                            aria-hidden="true"
                                                        ></i>
                                                        Drag
                                                        and
                                                        drop
                                                        to
                                                        upload
                                                        content!
                                                    </h3>
                                                </div>
                                            </vue-dropzone>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    colspan="4"
                                >
                                    <a
                                        href="javascript:void(0)"
                                        v-on:click="
                                            addNewAllProductArtwork()
                                        "
                                        v-if="
                                            isEditMode
                                        "
                                        class="addNew1"
                                        ><i
                                            class="fa fa-plus-circle"
                                            aria-hidden="true"
                                        ></i
                                    ></a>
                                </td>
                            </tr>
                        </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </template>
                                                

        <div class="d-flex justify-content-between align-items-center mt-4 mb-2">
            <div class="d-flex align-items-center">
                <h5 class="mb-0 me-3">Artworks</h5>
                <template v-if="eachProductsHasArtwork && order.products.length > 1 && !isEditMode">
            <a
                href="javascript:void(0)"
                v-if="
                    (getUser !=
                        null &&
                        getUser.user_type ==
                            1) ||
                    hasRole(
                        'Admin'
                    )
                "
                @click="
                    openSendAllArtworkToCustomer(
                        false
                    )
                "
                class="btn btn-sm btn-soft-primary fw-semibold"
                >Send all
                artworks to
                customer</a
            >
        </template>

                <!-- <a href="#" class="btn btn-sm btn-soft-primary fw-semibold">
                Send all artworks to customer</a> -->
            </div>

            <template v-if="showallArtwork">
                <a href="javascript:void(0)" @click="showArtwork(false)" class="btn btn-sm btn-primary">Hide</a>
            </template>
            <template v-else>
                <a href="javascript:void(0)" @click="showArtwork(true)" class="btn btn-sm btn-primary">View</a>    
            </template>



            
            
        </div>
        <template v-if="showallArtwork">
        <div class="table-responsive table-card mt-0 m-0">
            <table class="table table-bordered mb-3">
                <thead class="table-light text-muted">
                    <tr>
                        <th scope="col">Product Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Original customer file</th>
                        <th scope="col">Approved artwork</th>
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody  v-if="order.products.length > 0">
                    <template
                v-for="(
                    product,
                    index
                ) in order.products.filter(
                    (x) =>
                        x.id !=
                        null
                )"
            >
                <template
                    v-if="
                        product.artworks &&
                        product.artworks.filter(
                            (
                                art
                            ) =>
                                art.id ==
                                    null ||
                                (product.latest_artwork &&
                                    art.id ==
                                        product
                                            .latest_artwork
                                            .id)
                        )
                            .length >
                            0
                    "
                >
                    <template
                        v-for="(
                            artwork,
                            artworkIndex
                        ) in product.artworks"
                    >
                        <tr
                            v-if="
                                (product.latest_artwork &&
                                    artwork.id ==
                                        product
                                            .latest_artwork
                                            .id) ||
                                artwork.id ==
                                    null
                            "
                        >
                            <template
                                v-if="
                                    checkIfFirstRow(
                                        product,
                                        index,
                                        artwork,
                                        artworkIndex
                                    )
                                "
                            >
                                <td
                                    :rowspan="
                                        product.artworks.filter(
                                            (
                                                art
                                            ) =>
                                                art.id ==
                                                    null ||
                                                (product.latest_artwork &&
                                                    art.id ==
                                                        product
                                                            .latest_artwork
                                                            .id)
                                        )
                                            .length
                                    "
                                >
                                    {{
                                        product.product_name
                                    }}
                                </td>
                                <td
                                    :rowspan="
                                        product.artworks.filter(
                                            (
                                                art
                                            ) =>
                                                art.id ==
                                                    null ||
                                                (product.latest_artwork &&
                                                    art.id ==
                                                        product
                                                            .latest_artwork
                                                            .id)
                                        )
                                            .length
                                    "
                                >
                                    <p
                                        v-html="
                                            product.product_desc
                                        "
                                    ></p>
                                </td>
                                <td
                                    :rowspan="
                                        product.artworks.filter(
                                            (
                                                art
                                            ) =>
                                                art.id ==
                                                    null ||
                                                (product.latest_artwork &&
                                                    art.id ==
                                                        product
                                                            .latest_artwork
                                                            .id)
                                        )
                                            .length
                                    "
                                >
                                    <div
                                        class="filetitlesec info-file mb-1"
                                    >
                                        <div
                                            class="filetitleleft"
                                            v-if="
                                                product.id &&
                                                product
                                                    .order_product
                                                    .original_customer_file
                                            "
                                        >
                                            <div
                                                class="ellipsis"
                                            >
                                                <span
                                                    :title="
                                                        product
                                                            .order_product
                                                            .original_customer_file
                                                    "
                                                    >{{
                                                        product
                                                            .order_product
                                                            .original_customer_file
                                                            | truncate(
                                                                isEditMode
                                                                    ? 23
                                                                    : 30
                                                            )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="filetitleright"
                                        >
                                            <div
                                                v-if="
                                                    (getUser !=
                                                        null &&
                                                        getUser.user_type ==
                                                            1) ||
                                                    hasRole(
                                                        'Admin'
                                                    )
                                                "
                                                class="file-attachment-wrapper"
                                            >
                                                <vue-dropzone
                                                    :options="
                                                        dropzoneOptionsOriginalFile
                                                    "
                                                    :id="
                                                        'item-original-file-' +
                                                        index
                                                    "
                                                    :use-custom-slot="
                                                        true
                                                    "
                                                    :key="
                                                        index
                                                    "
                                                    ref="itemOriginalFileVueDropzones"
                                                    v-on:vdropzone-success="
                                                        (
                                                            file,
                                                            response
                                                        ) =>
                                                            afterItemOriginalFileUploadComplete(
                                                                file,
                                                                response,
                                                                index
                                                            )
                                                    "
                                                    v-on:vdropzone-error="
                                                        (
                                                            file,
                                                            message,
                                                            xhr
                                                        ) =>
                                                            itemOriginalFileUploadError(
                                                                file,
                                                                message,
                                                                xhr,
                                                                index
                                                            )
                                                    "
                                                >
                                                    <div
                                                        class="dropzone-custom-content"
                                                    >
                                                        <h3
                                                            class="dropzone-custom-title"
                                                            v-if="
                                                                product
                                                                    .order_product
                                                                    .original_customer_file !=
                                                                null
                                                            "
                                                        >
                                                            <i
                                                                class="fa fa-upload"
                                                                aria-hidden="true"
                                                            ></i>
                                                            Replace
                                                        </h3>
                                                        <h3
                                                            class="dropzone-custom-title"
                                                            v-else
                                                        >
                                                            <i
                                                                class="fa fa-upload"
                                                                aria-hidden="true"
                                                            ></i>
                                                            Drag
                                                            and
                                                            drop
                                                            to
                                                            upload
                                                            content!
                                                        </h3>
                                                    </div>
                                                </vue-dropzone>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="orderbtnsec2"
                                        v-if="
                                            product.id &&
                                            product
                                                .order_product
                                                .original_customer_file
                                        "
                                    >
                                        <div
                                            class="filetitlesec d-file"
                                        >
                                            <div
                                                class="filetitleleft"
                                            >
                                                <div
                                                    class="orderbtnsec"
                                                >
                                                    <a
                                                        href="javascript:void(0)"
                                                        @click="
                                                            downloadOriginalArtwork(
                                                                product
                                                                    .order_product
                                                                    .original_customer_file
                                                            )
                                                        "
                                                        class="downlodbtn"
                                                        >Download</a
                                                    >
                                                </div>
                                            </div>
                                            <div
                                                class="filetitleright"
                                            >
                                                <div
                                                    class="orderbtnsec"
                                                >
                                                    <a
                                                        class="btn btn-sm btn-primary"
                                                        href="javascript:void(0)"
                                                        v-if="
                                                            !isEditMode &&
                                                            ((getUser !=
                                                                null &&
                                                                getUser.user_type ==
                                                                    1) ||
                                                                hasRole(
                                                                    'Admin'
                                                                ))
                                                        "
                                                        @click="
                                                            openSendArtworkToVendor(
                                                                product
                                                            )
                                                        "
                                                        >Send
                                                        to
                                                        vendor</a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </template>

                            <td>
                                <div
                                    class="filetitlesec info-file mb-1"
                                >
                                    <div
                                        class="filetitleleft"
                                        v-if="
                                            artwork.id &&
                                            artwork.attach_link
                                        "
                                    >
                                        <div
                                            class="ellipsis"
                                        >
                                            <span
                                                :title="
                                                    artwork.attach_link
                                                "
                                                >{{
                                                    artwork.attach_link
                                                        | truncate(
                                                            isEditMode
                                                                ? 80
                                                                : 90
                                                        )
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                    <div
                                        class="filetitleright "
                                    >
                                        <div
                                            class="file-attachment-wrapper"
                                            v-if="
                                                (getUser !=
                                                    null &&
                                                    getUser.user_type ==
                                                        1) ||
                                                hasRole(
                                                    'Admin'
                                                )
                                            "
                                        >
                                            <vue-dropzone
                                                :options="
                                                    dropzoneOptionsArtwork
                                                "
                                                :id="
                                                    'item-dropzone-' +
                                                    index +
                                                    '-' +
                                                    artworkIndex
                                                "
                                                :use-custom-slot="
                                                    true
                                                "
                                                :key="
                                                    index
                                                "
                                                ref="itemArtworkFileVueDropzones"
                                                v-on:vdropzone-success="
                                                    (
                                                        file,
                                                        response
                                                    ) =>
                                                        afterItemArtworkUploadComplete(
                                                            file,
                                                            response,
                                                            index,
                                                            artworkIndex
                                                        )
                                                "
                                                v-on:vdropzone-error="
                                                    (
                                                        file,
                                                        message,
                                                        xhr
                                                    ) =>
                                                        itemArtworkUploadError(
                                                            file,
                                                            message,
                                                            xhr,
                                                            artworkIndex
                                                        )
                                                "
                                            >
                                                <div
                                                    class="dropzone-custom-content"
                                                >
                                                    <h3
                                                        class="dropzone-custom-title"
                                                        v-if="
                                                            artwork.attach_link !=
                                                            null
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-upload"
                                                            aria-hidden="true"
                                                        ></i>
                                                        Replace
                                                    </h3>
                                                    <h3
                                                        class="dropzone-custom-title"
                                                        v-else
                                                    >
                                                        <i
                                                            class="fa fa-upload"
                                                            aria-hidden="true"
                                                        ></i>
                                                        Drag
                                                        and
                                                        drop
                                                        to
                                                        upload
                                                        content!
                                                    </h3>
                                                </div>
                                            </vue-dropzone>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        artwork.id
                                    "
                                    class="orderbtnsec2"
                                >
                                    <div
                                        class="orderbtnsec2 d-file mb-1"
                                        v-if="
                                            artwork.id &&
                                            artwork.attach_link
                                        "
                                    >
                                        <div
                                            class="filetitlesec"
                                        >
                                            <div
                                                class="filetitleleft"
                                            >
                                                <span
                                                    class="orderbtnsec"
                                                >
                                                    <a
                                                        href="javascript:void(0)"
                                                        v-if="
                                                            [
                                                                'png',
                                                                'jpg',
                                                                'jpeg',
                                                            ].some(
                                                                (
                                                                    image
                                                                ) =>
                                                                    artwork.attach_link
                                                                        .toLowerCase()
                                                                        .includes(
                                                                            image
                                                                        )
                                                            )
                                                        "
                                                        @click="
                                                            imagePreview(
                                                                artwork.attach_link
                                                            )
                                                        "
                                                        class="downlodbtn"
                                                        >Preview</a
                                                    >
                                                    <a
                                                        href="javascript:void(0)"
                                                        v-on:click="
                                                            download(
                                                                artwork
                                                            )
                                                        "
                                                        class="downlodbtn"
                                                        >Download</a
                                                    >
                                                </span>
                                            </div>
                                            <div
                                                class="filetitleright"
                                            >
                                                <span
                                                    class="orderbtnsec"
                                                    ><a
                                                        class="btn btn-sm btn-primary"
                                                        href="javascript:void(0)"
                                                        @click="
                                                            openSendArtworkToCustomer(
                                                                product,
                                                                artwork
                                                            )
                                                        "
                                                        v-if="
                                                            artwork.id &&
                                                            artwork.attach_link &&
                                                            !isEditMode &&
                                                            ((getUser !=
                                                                null &&
                                                                getUser.user_type ==
                                                                    1) ||
                                                                hasRole(
                                                                    'Admin'
                                                                ))
                                                        "
                                                        >Send
                                                        to
                                                        customer</a
                                                    >
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="orderbtnsec-title v-info"
                                    >
                                        <div class="d-flex justify-content-between me-2">
                                            <p class="mb-0">V-{{artwork.version_number}} Uploaded {{artwork.updated_at}}</p>
                                            <a
                                                href="javascript:void(0)"
                                                v-if="
                                                    (getUser !=
                                                        null &&
                                                        getUser.user_type ==
                                                            1) ||
                                                    hasRole(
                                                        'Admin'
                                                    )
                                                "
                                                v-on:click="
                                                    addNewItemAttachVersion(
                                                        index
                                                    )
                                                "
                                                class="fw-medium text-warning"
                                                >Add
                                                version</a
                                            >
                                            
                                        </div>
                                        
                                        <div class="text-center mt-1">
                                        <a
                                            v-if="
                                                product
                                                    .artworks
                                                    .length
                                            "
                                            class="fw-medium"
                                            @click="
                                                openProductArtworkVersionsModal(
                                                    product
                                                )
                                            "
                                            href="javascript:void(0)"
                                            >Previous
                                            version</a
                                        >

                                            
                                        </div>
                                    </div>

                                    
                                </div>
                            </td>
                            <td>
                                <template
                                    v-if="
                                        isEditMode
                                    "
                                >
                                    <div
                                        class="input-group"
                                    >
                                        <ValidationProvider
                                            name="ArtworkStatus"
                                            rules="required"
                                            v-slot="{
                                                errors,
                                            }"
                                        >
                                            <select
                                                class="form-control"
                                                v-model="
                                                    order
                                                        .products[
                                                        index
                                                    ]
                                                        .artworks[
                                                        artworkIndex
                                                    ]
                                                        .artwork_status_id
                                                "
                                            >
                                                <option
                                                    :value="
                                                        null
                                                    "
                                                >
                                                    Select
                                                </option>
                                                <option
                                                    v-for="(
                                                        status,
                                                        index
                                                    ) in artwork_statuses"
                                                    :value="
                                                        status.id
                                                    "
                                                >
                                                    {{
                                                        status.name
                                                    }}
                                                </option>
                                            </select>
                                            <div
                                                class="error"
                                                v-if="
                                                    errors.length
                                                "
                                            >
                                                {{
                                                    errors[0]
                                                }}
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </template>
                                <template
                                    v-if="
                                        !isEditMode
                                    "
                                >
                                    {{
                                        artwork.artwork_status
                                            ? artwork
                                                  .artwork_status
                                                  .name
                                            : null
                                    }}
                                    <div
                                        class="orderbtnsec"
                                        v-if="
                                            artwork.id &&
                                            artwork.attach_link
                                        "
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            v-if="
                                                artwork
                                                    .comments
                                                    .length &&
                                                artwork.artwork_status_id ==
                                                    7
                                            "
                                            @click="
                                                viewComments(
                                                    artwork
                                                )
                                            "
                                            >View
                                            Comments</a
                                        >
                                    </div>
                                </template>
                            </td>
                            
                            <td
                                style="
                                    width: 20px;
                                "
                            >
                                <a
                                    href="javascript:void(0)"
                                    v-if="
                                        (getUser !=
                                            null &&
                                            getUser.user_type ==
                                                1) ||
                                        hasRole(
                                            'Admin'
                                        )
                                    "
                                    v-on:click="
                                        removeItemAttach(
                                            index,
                                            artworkIndex,
                                            product.id,
                                            artwork.id
                                        )
                                    "
                                    class="trashBtn"
                                    ><i
                                        class="ri-delete-bin-6-line"
                                    ></i
                                ></a>
                            </td>
                        </tr>
                    </template>
                </template>
                <template
                    v-if="
                        !product.artworks ||
                        product
                            .artworks
                            .length ==
                            0
                    "
                >
                    <tr>
                        <td
                            rowspan="1"
                        >
                            {{
                                product.product_name
                            }}
                        </td>
                        <td
                            rowspan="1"
                        >
                            <p
                                v-html="
                                    product.product_desc
                                "
                            ></p>
                        </td>

                        <td
                            colspan="7"
                        >
                            <a
                                href="javascript:void(0)"
                                v-if="
                                    (getUser !=
                                        null &&
                                        getUser.user_type ==
                                            1) ||
                                    hasRole(
                                        'Admin'
                                    )
                                "
                                @click="
                                    addNewItemAttach(
                                        index
                                    )
                                "
                                class="addNew1"
                            >
                                <i
                                    class="fa fa-plus-circle"
                                    aria-hidden="true"
                                ></i>
                            </a>
                        </td>
                    </tr>
                </template>
            </template>
                </tbody>
            </table>
        </div>

        </template>

        <h3
                                                    style="
                                                        text-transform: uppercase;
                                                    "
                                                >
                                                    OTHER ATTACHMENTS
                                                </h3>
                                                <div class="invoiceDetails">
                                                    <table
                                                        class="table table-bordered table-hover mb-0"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th
                                                                    style="
                                                                        width: 300px;
                                                                    "
                                                                >
                                                                    File
                                                                </th>
                                                                <th>
                                                                    Comments
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 120px;
                                                                    "
                                                                >
                                                                    Upload time
                                                                </th>
                                                                <th>
                                                                    Upload file
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 20px;
                                                                    "
                                                                >
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="(
                                                                    artwork,
                                                                    artworkIndex
                                                                ) in order.artworks"
                                                            >
                                                                <td>
                                                                    <input
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            order
                                                                                .artworks[
                                                                                artworkIndex
                                                                            ]
                                                                                .attach_type
                                                                        "
                                                                        id="searchQuotationInput"
                                                                    />
                                                                    <p
                                                                        v-if="
                                                                            !isEditMode
                                                                        "
                                                                        v-html="
                                                                            artwork.attach_type
                                                                        "
                                                                    ></p>
                                                                </td>
                                                                <td>
                                                                    <template
                                                                        v-if="
                                                                            artwork.id &&
                                                                            artwork.attach_link
                                                                        "
                                                                    >
                                                                    <template v-if="artwork.uploaded_media">
                                                                        <template v-if="(artwork.uploaded_media.file_ext == 'jpg' || artwork.uploaded_media.file_ext == 'png' || artwork.uploaded_media.file_ext == 'gif')">
                                                                            <a  href="javascript:void(0)" class="lightbox" 
                                                                                @click="imagePreview1(artwork.attach_link)">
                                                                                    <img data-v-26877d14="" :src="artwork.uploaded_media.image_url" 
                                                                                    style="width: 40px; height: 32px;">
                                                                                </a>
                                                                        </template>
                                                                        <template v-else>
                                                                        <span class="file-option-icon"><i :class="getFileIconForAttachment(artwork)"></i></span>
                                                                        </template>
                                                                    </template>
                                                                       
                                                                        <span
                                                                            :title="
                                                                                artwork.attach_link
                                                                            "
                                                                            >{{
                                                                                artwork.attach_link
                                                                                    | truncate(
                                                                                        100
                                                                                    )
                                                                            }}</span
                                                                        >

                                                                        <div
                                                                            class="orderbtnsec"
                                                                        >
                                                                            <a
                                                                                href="javascript:void(0)"
                                                                                v-on:click="
                                                                                    download1(
                                                                                        artwork
                                                                                    )
                                                                                "
                                                                                class="downlodbtn"
                                                                                >Download</a
                                                                            >
                                                                        </div>
                                                                        <br />
                                                                    </template>
                                                                    <template
                                                                        v-if="
                                                                            artwork.id
                                                                        "
                                                                    >
                                                                        V:
                                                                        {{
                                                                            artwork.version_number
                                                                        }}
                                                                    </template>
                                                                </td>
                                                                <td>
                                                                    <textarea
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        class="form-control resize-ta"
                                                                        v-model="
                                                                            order
                                                                                .artworks[
                                                                                artworkIndex
                                                                            ]
                                                                                .comment
                                                                        "
                                                                        style="
                                                                            height: 66px;
                                                                            overflow-y: hidden;
                                                                        "
                                                                    ></textarea>
                                                                    <p
                                                                        v-if="
                                                                            !isEditMode
                                                                        "
                                                                        v-html="
                                                                            artwork.comment
                                                                        "
                                                                    ></p>
                                                                </td>
                                                                <td>
                                                                    <template
                                                                        v-if="
                                                                            artwork.id
                                                                        "
                                                                    >
                                                                        {{
                                                                            artwork.updated_at
                                                                        }}
                                                                    </template>
                                                                </td>
                                                                <td width="10%">
                                                                    <div
                                                                        class="filetitlesec"
                                                                    >
                                                                        <div
                                                                            class="file-attachment-wrapper"
                                                                            v-if="
                                                                                (getUser !=
                                                                                    null &&
                                                                                    getUser.user_type ==
                                                                                        1) ||
                                                                                hasRole(
                                                                                    'Admin'
                                                                                )
                                                                            "
                                                                        >
                                                                            <vue-dropzone
                                                                                :options="
                                                                                    dropzoneOptions
                                                                                "
                                                                                :id="
                                                                                    'other-dropzone-' +
                                                                                    artworkIndex
                                                                                "
                                                                                :use-custom-slot="
                                                                                    true
                                                                                "
                                                                                :key="
                                                                                    artworkIndex
                                                                                "
                                                                                ref="otherAttachments"
                                                                                v-on:vdropzone-success="
                                                                                    (
                                                                                        file,
                                                                                        response
                                                                                    ) =>
                                                                                        afterArtworkUploadComplete(
                                                                                            file,
                                                                                            response,
                                                                                            artworkIndex
                                                                                        )
                                                                                "
                                                                                v-on:vdropzone-error="
                                                                                    (
                                                                                        file,
                                                                                        message,
                                                                                        xhr
                                                                                    ) =>
                                                                                        otherAttachmentUploadError(
                                                                                            file,
                                                                                            message,
                                                                                            xhr,
                                                                                            artworkIndex
                                                                                        )
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="dropzone-custom-content"
                                                                                >
                                                                                    <h3
                                                                                        class="dropzone-custom-title"
                                                                                        v-if="
                                                                                            artwork.attach_link !=
                                                                                            null
                                                                                        "
                                                                                    >
                                                                                        <i
                                                                                            class="fa fa-upload"
                                                                                            aria-hidden="true"
                                                                                        ></i>
                                                                                        Replace
                                                                                    </h3>
                                                                                    <h3
                                                                                        class="dropzone-custom-title"
                                                                                        v-else
                                                                                    >
                                                                                        <i
                                                                                            class="fa fa-upload"
                                                                                            aria-hidden="true"
                                                                                        ></i>
                                                                                        Drag
                                                                                        and
                                                                                        drop
                                                                                        to
                                                                                        upload
                                                                                        content!
                                                                                    </h3>
                                                                                </div>
                                                                            </vue-dropzone>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-if="
                                                                            (getUser !=
                                                                                null &&
                                                                                getUser.user_type ==
                                                                                    1) ||
                                                                            hasRole(
                                                                                'Admin'
                                                                            )
                                                                        "
                                                                        v-on:click="
                                                                            removeOtherAttach(
                                                                                artworkIndex,
                                                                                artwork.id
                                                                            )
                                                                        "
                                                                        class="trashBtn"
                                                                        ><i
                                                                            class="ri-delete-bin-6-line"
                                                                        ></i
                                                                    ></a>
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-on:click="
                                                                            addNewOtherAttach()
                                                                        "
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        class="addNew1"
                                                                        ><i
                                                                            class="ri-add-circle-line"
                                                                        ></i
                                                                    ></a>
                                                                </td>
                                                            </tr>

                                                            <tr
                                                                v-if="
                                                                    order
                                                                        .artworks
                                                                        .length ==
                                                                    0
                                                                "
                                                            >
                                                                <td colspan="6">
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-on:click="
                                                                            addNewOtherAttach()
                                                                        "
                                                                        
                                                                        class="addNew1"
                                                                        ><i
                                                                            class="ri-add-circle-line"
                                                                        ></i
                                                                    ></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                
                                            </div>
                                            <div class="tab-pane" id="arrow-order" role="tabpanel">
                                                <div class="table-responsive table-card mt-0 m-0">
                                                    <table class="table table-bordered align-middle mb-0">
                                                        <thead class="table-light text-muted">
                                                            <tr>
                                                                <th scope="col">SO #</th>
                                                                <th scope="col">Created</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Customer</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-if="order.order">
                                                            <tr>
                                                             <td>
                                                                <router-link
                                                                    class="fw-medium"
                                                                    :to="{
                                                                        name: 'orderShow',
                                                                        params: {
                                                                            id: order
                                                                                .order
                                                                                .id,
                                                                        },
                                                                    }"
                                                                    target="_blank"
                                                                >
                                                                    #{{
                                                                        order
                                                                            .order
                                                                            .order_number
                                                                    }}
                                                                </router-link>
                                                            </td>

                                                                
                                                                <td> {{order.order.order_date}}</td>
                                                                <td>{{
                                                                    order
                                                                        .order
                                                                        .order_status
                                                                        ? order
                                                                            .order
                                                                            .order_status
                                                                            .name
                                                                        : ""
                                                                }}</td>
                                                                <td>
                                                                    <div class="fw-semibold">Customer Name : 
                                                                    <router-link
                                                                        v-if="
                                                                            order
                                                                                .order
                                                                                .customer
                                                                        "
                                                                        :to="{
                                                                            name: 'customerDetails',
                                                                            params: {
                                                                                id: order
                                                                                    .order
                                                                                    .customer
                                                                                    .id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                        title="Details Customer"
                                                                    >
                                                                        {{
                                                                            order
                                                                                .order
                                                                                .customer
                                                                                .company_name
                                                                        }}</router-link
                                                                    ></div>
                                                                    <div>Address : {{
                                                                                order
                                                                                    .order
                                                                                    .customer
                                                                                    ? order
                                                                                        .order
                                                                                        .customer
                                                                                        .address
                                                                                    : ""
                                                                            }}</div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="tab-pane" id="arrow-ship" role="tabpanel">

                                            <OrderShipmentsNew
                                                    :order="order.order"
                                                    :po="order"
                                                    :bus="bus"
                                                    :loading="loading"
                                                    :shippingProducts="
                                                        shippingProducts
                                                    "
                                                    
                                                ></OrderShipmentsNew>

                                                


                                                <div class="d-flex  mt-4 mb-2">
                                                    <button class="btn btn-primary me-2"><i class="align-middle ri-add-line me-1"></i>
                                                    
                                                    <a
                                                    href="javascript:void(0);"
                                                    data-toggle="modal"
                                                    data-target="#addShippingModal"
                                                    class="btn create-btn"
                                                    >Create Shipment</a>
                                                    </button>
                                                    <button class="btn btn-info" data-toggle="modal"
                                                    data-target="#addShippingModalAddNew" style="margin-left: 10px;"><i class="align-middle ri-search-line me-1"></i>Search Shipment</button>
                                                </div>
                                                
                                            </div>
                                            <div class="tab-pane" id="arrow-invoice" role="tabpanel">
                                                <div class="bg-light p-3">
                                                    <div class="form-check mb-2">
                                                                <input
                                                                    type="radio"
                                                                    class="form-check-input"
                                                                    value="Y"
                                                                    v-model="
                                                                        order.flag_pre_deposit
                                                                    "
                                                                    name="optradio"
                                                                />
                                                        <!-- <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"> -->
                                                        <label class="form-check-label text-dark" for="flexRadioDefault1">Pre-Deposit required to start work</label>
                                                    </div>
                                                    <div class="form-check">
                                                                <input
                                                                    type="radio"
                                                                    class="form-check-input"
                                                                    value="N"
                                                                    v-model="
                                                                        order.flag_pre_deposit
                                                                    "
                                                                    name="optradio"
                                                                />

                                                        <!-- <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"> -->
                                                        <label class="form-check-label text-dark" for="flexRadioDefault2">Pre-Deposit doesnt NOT required to start work</label>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <h5 class="fw-semibold mt-3">Pre-Deposit Details</h5>
                                                        <div class="bg-light p-3">
                                                            <div class="mb-3">
                                                                <label>Pre-Deposit Percentage</label>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.percentage
                                                                        "
                                                                    />
                                                            </div>
                                                            <div class="mb-3">
                                                                <label>Pre-Deposit Amount</label>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.amount
                                                                        "
                                                                    />
                                                            </div>
                                                            <div class="mb-3">
                                                                <label>Pre-Deposit Paid</label>
                                                                <select
                                                                        class="form-select"
                                                                        v-model="
                                                                            customerPayment.status
                                                                        "
                                                                    >
                                                                        <option>
                                                                            Select
                                                                        </option>
                                                                        <option
                                                                            value="Yes"
                                                                        >
                                                                            Yes
                                                                        </option>
                                                                        <option
                                                                            value="No"
                                                                        >
                                                                            No
                                                                        </option>
                                                                    </select>
                                                                
                                                            </div>
                                                            <div class="mb-3">
                                                                <label>Pre-Deposit Date</label>
                                                                <input
                                                                        type="date"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.payment_date
                                                                        "
                                                                    />
                                                                
                                                            </div>
                                                            <div>
                                                                <label>Proof of pre-deposit</label>
                                                            </div>
                                                        </div>
                                                    </div>  
                                                    <div class="col-lg-6">
                                                        <h5 class="fw-semibold mt-3">Invoice Details</h5>
                                                        <div class="table-responsive table-card m-0">
                                                            <table class="table table-bordered align-middle mb-0">
                                                                <thead class="table-light text-muted">
                                                                    <tr>
                                                                        <th scope="col">Customer Invoice#</th>
                                                                        <th scope="col">Date</th>
                                                                        <th scope="col">Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <!-- <tr>
                                                                        <td><a href="#" class="fw-medium">#5014</a></td>
                                                                        <td>02/23/2022</td>
                                                                        <td>$1155.00</td>
                                                                    </tr> -->
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="col-xl-3 col-xxl-2" id="on-right">
    <div class="card two-tabs">
                                
                                    <ul class="nav nav-tabs nav-justified mb-0" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" data-toggle="tab" href="#base-justified-details" role="tab" aria-selected="false">
                                                Details
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-toggle="tab" href="#base-justified-task-label" role="tab" aria-selected="false">
                                                Task & More
                                            </a>
                                        </li>
                                    </ul>
                                    <!-- Tab panes -->
                                    <div class="tab-content">
                                        <div class="tab-pane active" id="base-justified-details" role="tabpanel">
                                            <div class="mb-1 card-body">
                                                <div class="two-header">
                                                   <div class="d-flex justify-content-between align-items-center has-line">
                                                        <h5 class="card-title mb-0">Consumer</h5>
                                                        <!-- <a href="#" class="rtn-edit" data-toggle="modal" data-target="#editConsumerModal"><i class="ri-edit-fill me-1"></i> Edit</a> -->
                                                   </div>
                                                </div>
                                                <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                                                    <router-link
                                                                :to="{
                                                                    name: 'customerDetails',
                                                                    params: {
                                                                        id: order
                                                                            .order
                                                                            .customer
                                                                            .id,
                                                                    },
                                                                }"
                                                                target="_blank"
                                                                title="Details Customer"
                                                                >{{
                                                                    order.order
                                                                        .customer
                                                                        .company_name
                                                                }}</router-link
                                                            ><br>
                                                            <template v-if="order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length">
                                                                    {{
                                                                order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length
                                                                    ? order
                                                                          .order
                                                                          .customer
                                                                          .customer_contacts[0]
                                                                          .contact_name
                                                                    : ""
                                                            }}<br>
                                                                    </template>
                                                            
                                                    <!-- <template v-if="order.order.customer.address != null">
                                                    {{ order.order.customer.address}}<br>
                                                    </template> -->
                                                    <template v-if="order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length">
                                                                    {{
                                                                        order.order
                                                                            .customer
                                                                            .customer_contacts
                                                                            .length
                                                                            ? order
                                                                                .order
                                                                                .customer
                                                                                .customer_contacts[0]
                                                                                .contact_no
                                                                            : ""
                                                                    }}<br>
                                                                    </template>
                                                    <template v-if="order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length">
                                                                    {{
                                                                order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length
                                                                    ? order
                                                                          .order
                                                                          .customer
                                                                          .customer_contacts[0]
                                                                          .email
                                                                    : ""
                                                            }}

                                                                    </template>
                                                    
                                                    
                                                </div>
                                            </div>
                                            <div class="mb-1 card-body">
                                                <div class="two-header">
                                                   <div class="d-flex justify-content-between align-items-center has-line">
                                                        <h5 class="card-title mb-0">Vendor</h5>
                                                        <!-- <a href="#" class="rtn-edit" data-toggle="modal" data-target="#editConsumerModal"><i class="ri-edit-fill me-1"></i> Edit</a> -->
                                                   </div>
                                                </div>
                                                <div class="flex-shrink-0 mt-sm-0 mt-3 fwefsa">
                                                    <router-link
                                                                :to="{
                                                                    name: 'vendorDetails',
                                                                    params: {
                                                                        id: order
                                                                            
                                                                            .vendor
                                                                            .id,
                                                                    },
                                                                }"
                                                                target="_blank"
                                                                title="Details Customer"
                                                                >{{
                                                                    order.vendor.company_name
                                                                }}</router-link
                                                            ><br>
                                                            <!-- <template v-if="order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length">
                                                                    {{
                                                                order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length
                                                                    ? order
                                                                          .order
                                                                          .customer
                                                                          .customer_contacts[0]
                                                                          .contact_name
                                                                    : ""
                                                            }}<br>
                                                                    </template> -->
                                                            
                                                    <template v-if="order.vendor.address != null">
                                                    {{ order.vendor.address}}<br>
                                                    </template>
                                                    <!-- <template v-if="order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length">
                                                                    {{
                                                                        order.order
                                                                            .customer
                                                                            .customer_contacts
                                                                            .length
                                                                            ? order
                                                                                .order
                                                                                .customer
                                                                                .customer_contacts[0]
                                                                                .contact_no
                                                                            : ""
                                                                    }}<br>
                                                                    </template>
                                                    <template v-if="order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length">
                                                                    {{
                                                                order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length
                                                                    ? order
                                                                          .order
                                                                          .customer
                                                                          .customer_contacts[0]
                                                                          .email
                                                                    : ""
                                                            }}

                                                                    </template> -->
                                                    
                                                    
                                                </div>
                                            </div>
                                            <OrderShippingNew
                                                @updatedShippingNewEvent="updatedShippingNewEvent"
                                                :order="order.order"
                                                :is-edit-mode="isEditMode"
                                                :loading="loading"
                                                :customerWarehouse="customerWarehouse"
                                                 :companyWarehouse="companyWarehouse"
                                            ></OrderShippingNew>

                                            
                                        </div>

                                        <OrderTaskNew
                                            :order="order"
                                            :loading="loading"
                                            :task-type="'po'"
                                            :bus="bus"
                                            @openTaskEditEvent="openTaskEditEvent"
                                            @sendPOToVendorEvent="sendPOToVendorEvent"
                                            @editModeEvent="changeEditMode(true)"
                                            @artworkSampleRequiredEvent="
                                                artworkSampleRequiredEvent()
                                            "
                                            @updatedTaskEvent="updatedTaskEvent"
                                            @depositSentEvent="depositSent"
                                            @openCheckAirFreightEvent="
                                                openCheckAirFreight
                                            "
                                            @openGetAReadyDateEvent="
                                                openGetAReadyDateEvent
                                            "
                                        ></OrderTaskNew>
                                        
                                    </div>
                                </div>

                                <div class="card she" v-if="isEditMode">
                                    <div class="card-header">
                                       <div class="d-flex justify-content-between align-items-center">
                                            <h5 class="card-title flex-grow-1 mb-0">Artwork / Deposit / Sample Required?</h5>
                                       </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="form-check mb-2">
                                        <input
                                            v-model="
                                                order.is_deposit_required
                                            "
                                            name="is_deposit_required"
                                            type="checkbox"
                                            class="form-check-input"
                                        />

                                            <!-- <input class="form-check-input" type="checkbox" id="formCheck1"> -->
                                            <label class="form-check-label" for="formCheck1">
                                                Is deposit required?
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                </div>

                            <!-- <OrderShippingNew
                                            :order="order.order"
                                            :is-edit-mode="isEditMode"
                                            :loading="loading"
                                        ></OrderShippingNew> -->
                           
                            
                        </div>

                         <div class="text-center pb-1 mb-3 she" v-if="isEditMode">


                                <!-- <button class="btn btn-primary w-md" id="edit-cancel">Cancel</button> -->
                                <!-- <button class="btn btn-success w-md">Save</button> -->

                                <button
                                v-if="isEditMode"
                                type="button"
                                :disabled="loading"
                                class="btn btn-primary w-md"
                                @click="
                                    isEditMode = false;
                                    getOrder();
                                "
                            >
                                Cancel
                            </button>

                                <button
                                v-if="isEditMode"
                                type="submit"
                                :disabled="loading"
                                class="btn btn-success w-md"
                            >
                                Save
                            </button>

                            </div>


                            </form>
        </ValidationObserver>
        <!-- <div
            class="alert alert-danger alert-dismissible"
            v-if="dueTasks && dueTasks.length"
        >
            <a href="#" class="close" data-dismiss="alert" aria-label="close"
                >&times;</a
            >
            <p class="text-sm" v-for="(task, index) in dueTasks">
                <template
                    v-if="
                        compareString(
                            task.title,
                            'Send Purchase Order to vendor'
                        )
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        data-toggle="modal"
                        data-target="#sendPOToVendorModal"
                        >Send to Vendor</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Get a ready date and set a follow up date'
                        )
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="openGetAReadyDate(task, 'eta')"
                        >Get a ready date</a
                    >
                </template>
                <template
                    v-else-if="compareString(task.title, 'Confirm ready date')"
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="openGetAReadyDate(task, 'confirm')"
                        >{{ task.title }}</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Get Shipping Schedule')
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="openGetAReadyDate(task, 'etd')"
                        >{{ task.title }}</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Approve PI from Vendor')
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="artworkSampleRequiredEvent()"
                        >Open Attachment</a
                    >
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="completeTask(task.id)"
                        >No PI provided</a
                    >
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="completeTask(task.id)"
                        >Approve PI</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Send deposit for vendor')
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="completeTask(task.id)"
                        >Deposit Sent</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(
                            task.title,
                            'Receive deposit from customer'
                        )
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="completeTask(task.id)"
                        >Deposit Received</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Customer to approve sample')
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="completeTask(task.id)"
                        >Sample Approved</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Vendor Deposit required')
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="completeTask(task.id)"
                        >Deposit sent</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Proceed with production')
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="completeTask(task.id)"
                        >Proceed</a
                    >
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Sent deposit to vendor')
                    "
                >
                    <span class="col-2">{{ task.title }}</span>
                    <span class="col-2">Amount</span>
                    <span class="col-6"
                        ><input style="width: 70px"
                            type="text"
                            v-on:keydown="checkDecimal($event, this)"
                            v-model="order.deposit_sent_amount"
                            placeholder=""
                            class="form-control-sm"
                    /></span>
                    <span class="col-2"
                        ><a
                            href="javascript:void(0);"
                            class="btn btn-primary btn-sm"
                            @click="depositSent(task)"
                            >Deposit Sent</a
                        ></span
                    >
                </template>
                <template
                    v-else-if="
                        compareString(task.title, 'Check for Air Freight')
                    "
                >
                    {{ task.title }}
                    <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm"
                        @click="openCheckAirFreight(task)"
                        >{{ task.title }}</a
                    >
                </template>
                <template v-else> {{ task.title }}</template>
            </p>
        </div> -->

        <div
            class="error mb-3"
            v-if="
                order.eta && order.follow_up && !order.is_ready_date_confirmed
            "
        >
            Factory Ready Date: {{ formatDate(order.eta) }} Follow up Date:
            {{ formatDate(order.follow_up) }}
            <a
                href="javascript:void(0);"
                class="error"
                @click="openGetAReadyDate(null)"
            >
                Edit Ready Date
            </a>
        </div>
        <template v-if="!hideHtml">
        <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
            <form
                @submit.prevent="handleSubmit(submitHandler)"
                enctype="multipart/form-data"
            >
                <div class="page-title page-title-full mb-3 order-row-custom">
                    <!--<div class="order-number-col">
                        <div class="d-flex align-items-center">
                            <div class="order-number">#{{ order.po_number }}</div>
                            <div class="cpreder">
                                <a href="javascript:void(0);" class=" btn btn-secondary" style="padding: 7px 16px;" v-on:click="changeEditMode(true)"><i class="ri-edit-box-line pe-1 align-middle"></i>Edit</a>

                            </div>
                        </div>
                    </div>-->

                    <div class="order-number-col">
                        <div class="d-flex align-items-center">
                            <div class="order-number" v-if="!isEditMode">
                                #{{ order.po_number }}
                            </div>
                            <div class="order-number-edit" v-if="isEditMode">
                                <input
                                    type="text"
                                    v-model="order.po_number"
                                    placeholder=""
                                    class="form-control"
                                />
                            </div>
                            <div class="cpreder">
                                <a
                                    v-if="
                                        !isEditMode &&
                                        ((getUser != null &&
                                            getUser.user_type == 1) ||
                                            hasRole('Admin') ||
                                            hasPerm('edit-purchase-order'))
                                    "
                                    href="javascript:void(0);"
                                    class="btn btn-secondary"
                                    
                                    v-on:click="changeEditMode(true)"
                                    ><i
                                        class="ri-edit-box-line pe-1 align-middle"
                                    ></i
                                    >Edit</a
                                >
                                <button
                                    v-if="isEditMode"
                                    type="submit"
                                    :disabled="loading"
                                    class="btn btn-success ml-1"
                                >
                                    Save
                                </button>
                                <button
                                    v-if="isEditMode"
                                    type="button"
                                    :disabled="loading"
                                    class="btn custom-btn ml-1"
                                    @click="
                                        isEditMode = false;
                                        getOrder();
                                    "
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="stepper">
                        <div
                            class="step"
                            :class="{
                                active: order.po_status_id == 1,
                                completed: order.po_status_id > 1,
                            }"
                        >
                            <div class="step-label"></div>
                            <div class="step-description">Open</div>
                        </div>
                        <div
                            class="step"
                            :class="{
                                active: order.po_status_id == 2,
                                completed: order.po_status_id > 2,
                            }"
                        >
                            <div class="step-label"></div>
                            <div class="step-description">Sent to Vendor</div>
                        </div>
                        <div
                            class="step"
                            :class="{
                                active: [3, 4, 5, 6, 7].includes(
                                    order.po_status_id
                                ),
                                completed: order.po_status_id > 7,
                            }"
                        >
                            <div class="step-label"></div>
                            <div class="step-description">
                                Artwork/Sample Approval
                            </div>
                        </div>
                        <div
                            class="step"
                            :class="{
                                active: order.po_status_id == 8,
                                completed: order.po_status_id > 8,
                            }"
                        >
                            <div class="step-label"></div>
                            <div class="step-description">In Production</div>
                        </div>
                        <div
                            class="step"
                            :class="{
                                active: [10, 12].includes(order.po_status_id),
                                completed: [9, 11, 12].includes(
                                    order.po_status_id
                                ),
                            }"
                        >
                            <div class="step-label"></div>
                            <div class="step-description">Pending shipping</div>
                        </div>
                        <div
                            class="step"
                            :class="{
                                active: [9, 11].includes(order.po_status_id),
                                completed: order.po_status_id == 11,
                            }"
                        >
                            <div class="step-label"></div>
                            <div class="step-description">Shipped</div>
                        </div>
                    </div> -->



                    

                    <!-- <div class="title-right float-right">
                        <template v-if="order.is_draft != 1">
                            <a
                                v-if="order.po_status_id == 1"
                                class="btn custom-btn"
                                href="javascript:void(0);"
                                data-toggle="modal"
                                data-target="#sendPOToVendorModal"
                                >Send to Vendor</a
                            >
                            <a
                                href="#"
                                class="btn custom-btn"
                                data-toggle="modal"
                                data-target="#notesModal"
                                >Notes</a
                            >

                            <div
                                class="btn-group customdropdown pull-right ms-1"
                            >
                                <button
                                    type="button"
                                    class="btn btn-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    style="
                                        padding: 0.3rem 0.65rem;
                                        font-size: 1.1rem;
                                    "
                                >
                                    <i
                                        class="ri-settings-4-fill align-bottom"
                                    ></i>
                                </button>
                                <div class="dropdown-menu">
                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        data-toggle="modal"
                                        data-target="#actionLogModal"
                                        ><i
                                            class="ri-history-line pe-1 align-middle"
                                        ></i>
                                        History</a
                                    >
                                    <a
                                        v-if="order.po_status_id == 1"
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        data-toggle="modal"
                                        data-target="#sendPOToVendorModal"
                                        ><i class="fas fa-paper-plane"></i> Send
                                        to Vendor</a
                                    >
                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        ><i
                                            class="ri-truck-line pe-1 align-middle"
                                        ></i>
                                        Create Shipments</a
                                    >
                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        ><i
                                            class="ri-file-text-line pe-1 align-middle"
                                        ></i>
                                        Create Invoice</a
                                    >
                                    <a
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        v-on:click="copyPoOrder()"
                                        ><i
                                            class="ri-file-copy-2-line pe-1 align-middle"
                                        ></i>
                                        Copy Order</a
                                    >
                                    
                                </div>
                            </div>
                        </template>
                    </div> -->
                </div>
                <div class="select-step">
                    <div class="row">
                        <div class="col-sm-9 col-md-9 col-xxl-10">
                            <div class="card order-show">
                                <div class="form-row form-row-purchase">
                                    <div class="form-group firstChild">
                                        <div class="inner-col">
                                            <label class="labeltext"
                                                >Status:
                                            </label>
                                            <template v-if="isEditMode">
                                                <div
                                                    v-if="isEditMode"
                                                    class="input-group"
                                                >
                                                    <ValidationProvider
                                                        name="Status"
                                                        rules="required"
                                                        v-slot="{ errors }"
                                                    >
                                                        <select
                                                            class="form-control"
                                                            v-model="
                                                                order.po_status_id
                                                            "
                                                        >
                                                            <option
                                                                :value="null"
                                                            >
                                                                Select
                                                            </option>
                                                            <option
                                                                v-for="(
                                                                    status,
                                                                    index
                                                                ) in statuses"
                                                                :value="
                                                                    status.id
                                                                "
                                                            >
                                                                {{
                                                                    status.name
                                                                }}
                                                            </option>
                                                        </select>
                                                        <div
                                                            class="error"
                                                            v-if="errors.length"
                                                        >
                                                            {{ errors[0] }}
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                            </template>
                                        </div>
                                        <div
                                            class="view-content"
                                            v-if="!isEditMode"
                                        >
                                            {{
                                                order.purchase_order_status
                                                    ? order
                                                          .purchase_order_status
                                                          .name
                                                    : ""
                                            }}
                                        </div>
                                    </div>
                                    <div class="form-group child2">
                                        <div class="inner-col">
                                            <label class="labeltext"
                                                >Sales Order:</label
                                            >
                                        </div>
                                        <div class="view-content">
                                            {{
                                                order.order
                                                    ? order.order.order_number
                                                    : ""
                                            }}
                                        </div>
                                    </div>

                                    <div class="form-group child3">
                                        <!--<div class="inner-col">
                                            <label class="labeltext">Quotation:</label>
                                            <input readonly="" type="text" class="form-control" placeholder="" v-model="quotation_number" id="searchQuotationInput">
                                        </div>
                                        <div class="view-content">Test Col</div>-->
                                        <div class="inner-col">
                                            <label class="labeltext"
                                                >PO date:</label
                                            >
                                            <div
                                                v-if="isEditMode"
                                                class="input-group date has-validation"
                                                data-date-format="mm/dd/yyyy"
                                            >
                                                <ValidationProvider
                                                    name="Created Date"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <date-picker
                                                        v-model="
                                                            order.order_date
                                                        "
                                                        format="MM/DD/YYYY"
                                                        valueType="format"
                                                    ></date-picker>
                                                    <div
                                                        class="error"
                                                        v-if="errors.length"
                                                    >
                                                        {{ errors[0] }}
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div
                                            v-if="!isEditMode"
                                            class="view-content"
                                        >
                                            {{ order.order_date }}
                                        </div>
                                    </div>
                                    <div class="form-group child4">
                                        <div class="inner-col">
                                            <label class="labeltext"
                                                >Customer PO:</label
                                            >
                                            <input
                                                v-if="isEditMode"
                                                type="text"
                                                class="form-control"
                                                placeholder=""
                                                v-model="order.vendor_po"
                                            />
                                        </div>
                                        <div
                                            v-if="!isEditMode"
                                            class="view-content"
                                        >
                                            {{ order.vendor_po }}
                                        </div>
                                    </div>

                                    <div class="form-group child5">
                                        <div class="inner-col">
                                            <label class="labeltext"
                                                >Vendor Terms:</label
                                            >

                                            <input
                                                v-if="isEditMode"
                                                type="text"
                                                class="form-control"
                                                placeholder=""
                                                v-model="order.vendor_terms"
                                            />
                                        </div>
                                        <div
                                            v-if="!isEditMode"
                                            class="view-content"
                                        >
                                            {{ order.vendor_terms }}
                                        </div>
                                    </div>

                                    <div class="form-group child6">
                                        <div class="inner-col">
                                            <label class="labeltext"
                                                >Factory Ready Date:</label
                                            >
                                            <div
                                                v-if="isEditMode"
                                                class="input-group date"
                                            >
                                                <ValidationProvider
                                                    name="ETA"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <date-picker
                                                        v-model="order.eta"
                                                        format="MM/DD/YYYY"
                                                        valueType="format"
                                                    ></date-picker>
                                                    <div
                                                        class="error"
                                                        v-if="errors.length"
                                                    >
                                                        {{ errors[0] }}
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div
                                            v-if="!isEditMode"
                                            class="view-content"
                                        >
                                            <template
                                                v-if="
                                                    order.date_histories &&
                                                    order.date_histories.length
                                                "
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn-primary btn-sm"
                                                    data-toggle="modal"
                                                    data-target="#dateHistoriesModal"
                                                >
                                                    {{ order.eta }}
                                                </a>
                                            </template>
                                            <template v-else>{{
                                                order.eta
                                            }}</template>
                                        </div>
                                    </div>
                                    <div class="form-group child7">
                                        <div class="inner-col">
                                            <label class="labeltext"
                                                >FOB:</label
                                            >
                                            <input
                                                v-if="isEditMode"
                                                type="text"
                                                class="form-control"
                                                placeholder=""
                                                v-model="order.vendor_fob"
                                            />
                                        </div>
                                        <div
                                            v-if="!isEditMode"
                                            class="view-content"
                                        >
                                            {{ order.vendor_fob }}
                                        </div>
                                    </div>

                                    <div class="form-group child8">
                                        <div
                                            class="inner-col"
                                            v-if="!isEditMode"
                                        >
                                            <label class="labeltext"
                                                >Added By:</label
                                            >
                                            <div
                                                class="quotation-col view-content"
                                                v-if="order.order_admins"
                                            >
                                                {{ order.added_by ? order.added_by.name : "" }}
                                                <template
                                                    v-for="(
                                                        added, index
                                                    ) in order.order_admins.filter(
                                                        (x) =>
                                                            x.admin &&
                                                            x.admin_id !=
                                                                order.added_by
                                                                    .id
                                                    )"
                                                >
                                                    , {{ added.admin.name }}
                                                </template>
                                            </div>
                                        </div>
                                        <div
                                            v-if="isEditMode"
                                            class="view-content"
                                        >
                                            <div class="form-group">
                                                <label>Added by</label>
                                                <select
                                                    class="form-control"
                                                    v-model="
                                                        order.new_admin_users
                                                    "
                                                    
                                                >
                                                    <option
                                                        v-for="item in admin_users"
                                                        :value="item.id"
                                                    >
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card tabs-col-box">
                                <div class="card-body">
                                    <!-- Nav tabs -->
                                    <ul
                                        class="nav nav-tabs arrow-navtabs nav-success mb-3"
                                    >
                                        <li class="nav-item">
                                            <a
                                                class="nav-link active"
                                                data-toggle="tab"
                                                href="#tabs1"
                                                >Products</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                class="nav-link"
                                                data-toggle="tab"
                                                ref="artworkRef"
                                                href="#tabs2"
                                                >Artworks/Attachments</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                class="nav-link"
                                                data-toggle="tab"
                                                href="#tabs3"
                                                >Shipments</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                class="nav-link"
                                                data-toggle="tab"
                                                href="#tabs4"
                                                >Invoice</a
                                            >
                                        </li>
                                        <li class="nav-item">
                                            <a
                                                class="nav-link"
                                                data-toggle="tab"
                                                href="#tabs5"
                                                >Sales Order</a
                                            >
                                        </li>
                                    </ul>

                                    <!-- Tab panes -->
                                    <div class="tab-content">
                                        <div class="tab-pane active" id="tabs1">
                                            <!--<div class="productSearch">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" placeholder="Search.." id="searchProductInput">
                                                </div>
                                                <div class="custom-browse">
                                                    <a href="javascript:void(0);" class="browseBtn" data-toggle="modal" data-target="#searchProductModal">Browse</a>
                                                </div>
                                            </div>-->
                                            <div class="table-responsive2">
                                                <table
                                                    class="table table-bordered table-hover mb-0"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                style="
                                                                    width: 15%;
                                                                "
                                                            >
                                                                Item Number
                                                            </th>
                                                            <th>
                                                                Product name
                                                                &amp;
                                                                Description
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 100px;
                                                                "
                                                            >
                                                                Quantity
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 100px;
                                                                "
                                                            >
                                                                UOM
                                                                <template v-if="isEditMode">
                                                                <select  class="form-control" v-model="changeUnitQuantity">
                                                                    <option value="null">Select</option>
                                                                    <template v-for="(quantityUnit,index) in quantityUnits">
                                                                        <option :value="quantityUnit.id">{{quantityUnit.name}}</option>
                                                                    </template>
                                                                    
                                                                </select>
                                                                </template>
                                                                
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 100px;
                                                                "
                                                            >
                                                                Unit Price
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 100px;
                                                                "
                                                            >
                                                                Total
                                                            </th>
                                                            <!--<th>Is Artwork Approved?</th>-->
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Quote Number
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Artwork Status
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Product Status
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                SO Number
                                                            </th>
                                                            <th
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                Profit
                                                            </th>
                                                            <th
                                                                style="
                                                                    width: 20px;
                                                                "
                                                            >
                                                                <div
                                                                    class="d-flex"
                                                                >
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-if="
                                                                            !productExtendedView
                                                                        "
                                                                        @click="
                                                                            productExtendedView = true
                                                                        "
                                                                        >Expand</a
                                                                    >
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-if="
                                                                            productExtendedView
                                                                        "
                                                                        @click="
                                                                            productExtendedView = false
                                                                        "
                                                                        >Hide</a
                                                                    >
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="(
                                                                product, index
                                                            ) in order.products"
                                                            :key="
                                                                'item-field-' +
                                                                index
                                                            "
                                                        >
                                                            <td>
                                                                <input
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    type="text"
                                                                    class="form-control"
                                                                    placeholder="Item#"
                                                                    v-model="
                                                                        order
                                                                            .products[
                                                                            index
                                                                        ]
                                                                            .product_num
                                                                    "
                                                                />
                                                                <template
                                                                    v-if="
                                                                        !isEditMode &&
                                                                        product.order_product
                                                                    "
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'productsDetails',
                                                                            params: {
                                                                                id: product
                                                                                    .order_product
                                                                                    .product_id,
                                                                            },
                                                                        }"
                                                                        title="Item Detail"
                                                                        target="_blank"
                                                                    >
                                                                        {{
                                                                            product.product_num
                                                                        }}
                                                                    </router-link>
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <ValidationProvider
                                                                    name="Product Name"
                                                                    rules="required"
                                                                    v-slot="{
                                                                        errors,
                                                                    }"
                                                                >
                                                                    <input
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        v-model="
                                                                            order
                                                                                .products[
                                                                                index
                                                                            ]
                                                                                .product_name
                                                                        "
                                                                        type="text"
                                                                        class="form-control form-custom mb-1"
                                                                        placeholder=""
                                                                    />
                                                                    <div
                                                                        class="error"
                                                                        v-if="
                                                                            errors.length
                                                                        "
                                                                    >
                                                                        {{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </ValidationProvider>
                                                                <ckeditor
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    v-model="
                                                                        order
                                                                            .products[
                                                                            index
                                                                        ]
                                                                            .product_desc
                                                                    "
                                                                    type="inline"
                                                                    :config="
                                                                        editorConfigMin
                                                                    "
                                                                ></ckeditor>

                                                                <template
                                                                    v-if="
                                                                        !isEditMode
                                                                    "
                                                                >
                                                                    <p>
                                                                        {{
                                                                            product.product_name
                                                                        }}
                                                                    </p>
                                                                    <p
                                                                        v-html="
                                                                            product.product_desc
                                                                        "
                                                                    ></p>
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Quantity"
                                                                        immediate
                                                                        rules="required|positive|min_value:1"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            class="form-control form-custom"
                                                                            v-on:keydown="
                                                                                checkNumber(
                                                                                    $event
                                                                                )
                                                                            "
                                                                            placeholder=""
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .quantity
                                                                            "
                                                                        />
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                <template v-if="product
                                                                                  .qty_unit
                                                                                  .name == 'M Bags'">
                                                                    {{
                                                                        numberWithCommas(product.quantity * 1000)
                                                                    }}
                                                                
                                                                </template>
                                                                <template v-else-if="product
                                                                                  .qty_unit
                                                                                  .name == 'M Impressions'">
                                                                {{
                                                                        numberWithCommas(product.quantity * 1000)
                                                                    }}
                                                                </template>
                                                                <template v-else>
                                                                {{
                                                                        product.quantity
                                                                    }}
                                                                </template>
                                                                    
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Quantity unit"
                                                                        rules="required"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                        <select
                                                                            class="form-control"
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .qty_unit_id
                                                                            "
                                                                        >
                                                                            <option
                                                                                value=""
                                                                            >
                                                                                Select
                                                                            </option>
                                                                            <option
                                                                                v-for="(
                                                                                    qtyUnit,
                                                                                    unitIndex
                                                                                ) in quantityUnits"
                                                                                :value="
                                                                                    qtyUnit.id
                                                                                "
                                                                            >
                                                                                {{
                                                                                    qtyUnit.name
                                                                                }}
                                                                            </option>
                                                                        </select>
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    {{
                                                                        product.qty_unit
                                                                            ? product
                                                                                  .qty_unit
                                                                                  .name
                                                                            : ""
                                                                    }}
                                                                </template>
                                                            </td>
                                                            <td>
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Price"
                                                                        rules="required|positive|min_value:1"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            class="form-control form-custom"
                                                                            placeholder=""
                                                                            v-on:keydown="
                                                                                checkDecimal(
                                                                                    $event,
                                                                                    this
                                                                                )
                                                                            "
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .price
                                                                            "
                                                                        />
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    {{
                                                                        numberWithCommas(
                                                                            product.price
                                                                        )
                                                                    }}
                                                                </template>
                                                            </td>

                                                            <td>
                                                                <template
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                >
                                                                    <ValidationProvider
                                                                        name="Cost"
                                                                        rules="required|positive|min_value:1"
                                                                        v-slot="{
                                                                            errors,
                                                                        }"
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            class="form-control form-custom"
                                                                            placeholder=""
                                                                            v-on:keydown="
                                                                                checkDecimal(
                                                                                    $event,
                                                                                    this
                                                                                )
                                                                            "
                                                                            v-model="
                                                                                order
                                                                                    .products[
                                                                                    index
                                                                                ]
                                                                                    .cost
                                                                            "
                                                                        />
                                                                        <div
                                                                            class="error"
                                                                            v-if="
                                                                                errors.length
                                                                            "
                                                                        >
                                                                            {{
                                                                                errors[0]
                                                                            }}
                                                                        </div>
                                                                    </ValidationProvider>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    {{
                                                                        numberWithCommas(
                                                                            product.cost
                                                                        )
                                                                    }}
                                                                </template>
                                                            </td>
                                                            <!--<td>
                                                            <a href="javascript:void(0)"
                                                            v-on:click="openProductArtworksModal(product)">
                                                                <template v-if="product.order_product && product.order_product.latest_artwork && product.order_product.latest_artwork.artwork_status_id == 8">
                                                                    Yes
                                                                </template>
                                                                <template v-else>No</template>
                                                            </a>
                                                        </td>-->
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                <template
                                                                    v-if="
                                                                        product.order_product &&
                                                                        product
                                                                            .order_product
                                                                            .quote_product &&
                                                                        product
                                                                            .order_product
                                                                            .quote_product
                                                                            .quotation
                                                                    "
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'viewQuote',
                                                                            params: {
                                                                                id: product
                                                                                    .order_product
                                                                                    .quote_product
                                                                                    .quotation
                                                                                    .id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                    >
                                                                        #{{
                                                                            product
                                                                                .order_product
                                                                                .quote_product
                                                                                .quotation
                                                                                .quotation_number
                                                                        }}
                                                                    </router-link>
                                                                </template>
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                <template
                                                                    v-if="
                                                                        product.order_product &&
                                                                        product
                                                                            .order_product
                                                                            .artworks &&
                                                                        product
                                                                            .order_product
                                                                            .artworks
                                                                            .length
                                                                    "
                                                                >
                                                                    {{
                                                                        product
                                                                            .order_product
                                                                            .artworks[
                                                                            product
                                                                                .order_product
                                                                                .artworks
                                                                                .length -
                                                                                1
                                                                        ]
                                                                            .artwork_status
                                                                            ? product
                                                                                  .order_product
                                                                                  .artworks[
                                                                                  product
                                                                                      .order_product
                                                                                      .artworks
                                                                                      .length -
                                                                                      1
                                                                              ]
                                                                                  .artwork_status
                                                                                  .name
                                                                            : null
                                                                    }}
                                                                    <!--<div v-for="(art) in product.order_product.artworks">
                                                                    V-{{art.version_number}}: {{art.artwork_status ? art.artwork_status.name : null}}
                                                                </div>-->
                                                                </template>
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                {{
                                                                    product.status
                                                                }}
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                <template
                                                                    v-if="
                                                                        order.order
                                                                    "
                                                                >
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'orderShow',
                                                                            params: {
                                                                                id: order.order_id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                    >
                                                                        #{{
                                                                            order
                                                                                .order
                                                                                .order_number
                                                                        }}
                                                                    </router-link>
                                                                </template>
                                                            </td>
                                                            <td
                                                                v-if="
                                                                    productExtendedView
                                                                "
                                                            >
                                                                {{
                                                                    numberWithCommas(
                                                                        product.calculated_profit
                                                                    )
                                                                }}
                                                            </td>
                                                            <td
                                                                class="text-center"
                                                            >
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    v-if="
                                                                        (getUser !=
                                                                            null &&
                                                                            getUser.user_type ==
                                                                                1) ||
                                                                        hasRole(
                                                                            'Admin'
                                                                        )
                                                                    "
                                                                    v-on:click="
                                                                        removeItem(
                                                                            product.id
                                                                        )
                                                                    "
                                                                    class="trashBtn"
                                                                    ><i
                                                                        class="ri-delete-bin-6-line"
                                                                    ></i
                                                                ></a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <!--
                                                <div class="newProductCol"><a href="javascript:void(0);" class="newBtn" data-toggle="modal" data-target="#newProductModal">New Product</a></div>
                                                <div class="addSection">
                                                    <a href="javascript:void(0)" v-on:click="addNewItem()" class="addNew1"><i class="fa fa-plus" aria-hidden="true"></i>
                                                    </a>
                                                </div>-->
                                            </div>
                                            <div
                                                class="table-responsive newTable mb-0"
                                            >
                                                <table
                                                    class="table table-borderless mb-0"
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <!--<textarea class="form-control" v-model="order.customer_notes" placeholder="" rows="2" style="height:66px;overflow-y:hidden;"></textarea>-->
                                                                <h5
                                                                    style="
                                                                        font-size: 14px;
                                                                        font-weight: 500;
                                                                        margin: 8px
                                                                            0
                                                                            8px;
                                                                    "
                                                                >
                                                                    Additional
                                                                    Notes
                                                                </h5>
                                                                <textarea
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    class="form-control"
                                                                    v-model="
                                                                        order.notes
                                                                    "
                                                                    placeholder=""
                                                                    rows="2"
                                                                    style="
                                                                        height: 66px;
                                                                        overflow-y: hidden;
                                                                    "
                                                                ></textarea>

                                                                <p
                                                                    v-if="
                                                                        !isEditMode
                                                                    "
                                                                    v-html="
                                                                        order.notes
                                                                    "
                                                                ></p>

                                                                <br />
                                                                <h5
                                                                    style="
                                                                        font-size: 14px;
                                                                        font-weight: 500;
                                                                        margin: 8px
                                                                            0
                                                                            8px;
                                                                    "
                                                                >
                                                                    Order Notes
                                                                </h5>
                                                                <textarea
                                                                    v-if="
                                                                        isEditMode
                                                                    "
                                                                    class="form-control"
                                                                    v-model="
                                                                        order.vendor_notes
                                                                    "
                                                                    placeholder=""
                                                                    rows="2"
                                                                    style="
                                                                        height: 66px;
                                                                        overflow-y: hidden;
                                                                    "
                                                                ></textarea>

                                                                <p
                                                                    v-if="
                                                                        !isEditMode
                                                                    "
                                                                    v-html="
                                                                        order.vendor_notes
                                                                    "
                                                                ></p>
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 310px;
                                                                "
                                                            >
                                                                <table
                                                                    class="table table-bordered2"
                                                                >
                                                                    <tbody>
                                                                        <tr
                                                                            class="border-none"
                                                                        >
                                                                            <td
                                                                                style="
                                                                                    width: 200px;
                                                                                "
                                                                            >
                                                                                <strong
                                                                                    >Sub
                                                                                    Total</strong
                                                                                >
                                                                            </td>
                                                                            <td
                                                                                style="
                                                                                    width: 100px;
                                                                                "
                                                                                class="text-right"
                                                                            >
                                                                                <strong
                                                                                    >${{
                                                                                        numberWithCommas(
                                                                                            sub_total_cost
                                                                                        )
                                                                                    }}</strong>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length ==
                                                                                        0
                                                                                    "
                                                                                    data-toggle="modal"
                                                                                    data-target="#purchaseOrderDiscountModal"
                                                                                    >Add
                                                                                    discount</a
                                                                                >
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    v-else
                                                                                    data-toggle="modal"
                                                                                    data-target="#purchaseOrderDiscountModal"
                                                                                    >Edit
                                                                                    discount</a
                                                                                >
                                                                                <p
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        order
                                                                                            .discounts[0]
                                                                                            .reason
                                                                                    }}
                                                                                </p>
                                                                            </td>
                                                                            <td
                                                                                class="text-right"
                                                                            >
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .discounts
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    -${{
                                                                                        getDiscountAmount()
                                                                                    }}
                                                                                </template>
                                                                                <template
                                                                                    v-else
                                                                                    >-</template
                                                                                >
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .charges
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    <p
                                                                                        v-for="(
                                                                                            charge,
                                                                                            index
                                                                                        ) in order.charges"
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0);"
                                                                                            v-on:click="
                                                                                                editCharge(
                                                                                                    charge
                                                                                                )
                                                                                            "
                                                                                            >{{
                                                                                                charge.cost_type
                                                                                            }}:</a
                                                                                        >
                                                                                        <template
                                                                                            v-if="
                                                                                                charge.quantity !=
                                                                                                    null &&
                                                                                                charge.quantity >
                                                                                                    0
                                                                                            "
                                                                                        >
                                                                                            ${{
                                                                                                charge.amount
                                                                                            }}
                                                                                            x{{
                                                                                                charge.quantity
                                                                                            }}
                                                                                        </template>
                                                                                    </p>
                                                                                </template>
                                                                                <a
                                                                                    href="javascript:void(0);"
                                                                                    data-toggle="modal"
                                                                                    data-target="#purchaseOrderExtraChargeModal"
                                                                                    >Additional
                                                                                    charge</a
                                                                                >
                                                                            </td>
                                                                            <td
                                                                                class="text-right"
                                                                            >
                                                                                <template
                                                                                    v-if="
                                                                                        order
                                                                                            .charges
                                                                                            .length >
                                                                                        0
                                                                                    "
                                                                                >
                                                                                    <p
                                                                                        v-for="(
                                                                                            charge,
                                                                                            index
                                                                                        ) in order.charges"
                                                                                    >
                                                                                    <template v-if="isNumber(charge.amount)">
                                                                                        ${{
                                                                                            charge.quantity !=
                                                                                                null &&
                                                                                            charge.quantity >
                                                                                                0
                                                                                                ? charge.amount *
                                                                                                  charge.quantity
                                                                                                : charge.amount
                                                                                        }}
                                                                                    </template>
                                                                                    <template v-else>
                                                                                    $0.00
                                                                                    </template>
                                                                                        
                                                                                    </p>
                                                                                </template>
                                                                                <template
                                                                                    v-else
                                                                                >
                                                                                    _</template
                                                                                >
                                                                            </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                <strong
                                                                                    >Total</strong
                                                                                >
                                                                            </td>
                                                                            <td
                                                                                class="text-right"
                                                                            >
                                                                                <strong
                                                                                    >${{
                                                                                        numberWithCommas(
                                                                                            getTotal()
                                                                                        )
                                                                                    }}</strong
                                                                                >
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <!--<tr>

                                                        <td>
                                                            <table class="table table-bordered2">
                                                                <tbody>



                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>-->
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="tabs2">
                                            <div class="invoiceBox">
                                                <!--
                                                <h3 style="text-transform: uppercase;">ARTWORKS
                                                    <template v-if="eachProductsHasArtwork">
                                                        <a href="javascript:void(0)" @click="openSendAllArtworkToCustomer()" class="pull-right cussendbtn">Send all artworks to customer</a>
                                                    </template>
                                                </h3>

                                                <div class="invoiceDetails">

                                                    <table class="table table-bordered table-hover">
                                                        <thead>
                                                        <tr>
                                                            <th>Product Name</th>
                                                            <th>Description</th>
                                                            <th>Original customer file</th>
                                                            <th>Comments</th>
                                                            <th>Approved artwork</th>
                                                            <th>Status</th>
                                                            <th style="width: 20px;">Actions</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody v-if="order.products.length > 0">
                                                        <template v-for="(product, index) in order.products.filter((x) => x.id != null)">
                                                            <template v-if="product.artworks && product.artworks.filter((art) => art.id == null || (product.order_product && product.order_product.latest_artwork && art.id == product.order_product.latest_artwork.id)).length > 0">
                                                                <tr v-for="(artwork, artworkIndex) in product.artworks.filter((art) => art.id == null || (product.order_product && product.order_product.latest_artwork && art.id == product.order_product.latest_artwork.id))">
                                                                    <template v-if="artworkIndex == 0">
                                                                        <td :rowspan="product.artworks.filter((art) => art.id == null || (product.order_product && product.order_product.latest_artwork && art.id == product.order_product.latest_artwork.id)).length">
                                                                            {{ product.product_name }}
                                                                        </td>
                                                                        <td :rowspan="product.artworks.filter((art) => art.id == null || (product.order_product && product.order_product.latest_artwork && art.id == product.order_product.latest_artwork.id)).length"><p
                                                                            v-html="product.product_desc"></p></td>
                                                                        <td :rowspan="product.artworks.filter((art) => art.id == null || (product.order_product && product.order_product.latest_artwork && art.id == product.order_product.latest_artwork.id)).length">
                                                                            <template v-if="product.id && product.order_product && product.order_product.original_customer_file">
                                                                                <a href="javascript:void(0)" v-on:click="downloadOriginalArtwork(product.order_product.original_customer_file)">Download</a><br>
                                                                            </template>
                                                                        </td>

                                                                    </template>
                                                                    <td>
                                                                    <textarea v-if="isEditMode" class="form-control resize-ta"
                                                                            v-model="order.products[index].artworks[artworkIndex].comment"
                                                                            style="height:66px;overflow-y:hidden;"></textarea>
                                                                        <p v-if="!isEditMode" v-html="artwork.comment"></p>
                                                                    </td>
                                                                    <td>

                                                                        <div v-if="artwork.id && artwork.attach_link" >
                                                                            {{artwork.attach_link}}
                                                                            <a href="javascript:void(0)" v-if="['png', 'jpg', 'jpeg'].some( image => artwork.attach_link.toLowerCase().includes(image))" @click="imagePreview(artwork.attach_link)">Preview</a>
                                                                            <a href="javascript:void(0)" v-on:click="download(artwork)">Download</a> <br>

                                                                            <div>
                                                                                <span>V-{{ artwork.version_number }}</span>
                                                                                <span>Uploaded {{ artwork.updated_at }}</span>

                                                                            </div>
                                                                        </div>


                                                                        <div class="filetitlesec">
                                                                            <div class="file-attachment-wrapper" v-if="isEditMode && artwork.attach_link == null">
                                                                                <vue-dropzone :options="dropzoneOptions"
                                                                                            :id="'item-dropzone-'+index+ '-' + artworkIndex"
                                                                                            v-on:vdropzone-success="(file, response) => afterItemArtworkUploadComplete(file, response, index, artworkIndex)">
                                                                                </vue-dropzone>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="artwork.id">
                                                                            <a href="javascript:void(0)" v-on:click="addNewItemAttachVersion(index)">Add version</a>
                                                                            <a class="previous-vsbtn" v-if="product.artworks.length > 1" @click="openProductArtworkVersionsModal(product)" href="javascript:void(0)">Previous version</a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <template v-if="isEditMode">
                                                                            <div class="input-group">
                                                                                <ValidationProvider name="ArtworkStatus" rules="required" v-slot="{ errors }">
                                                                                    <select class="form-control" v-model="order.products[index].artworks[artworkIndex].artwork_status_id">
                                                                                        <option :value="null">Select</option>
                                                                                        <option v-for="(status, index) in artwork_statuses" :value="status.id">
                                                                                            {{ status.name }}
                                                                                        </option>
                                                                                    </select>
                                                                                    <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                                                                </ValidationProvider>
                                                                            </div>
                                                                        </template>
                                                                        <template v-if="!isEditMode">
                                                                            {{artwork.artwork_status ? artwork.artwork_status.name : null }}
                                                                        </template>
                                                                    </td>
                                                                    <td style="width: 20px;">

                                                                        <a href="javascript:void(0)"
                                                                        v-on:click="removeItemAttach(index, artworkIndex, product.id, artwork.id)"
                                                                        class="trashBtn"><i class="ri-delete-bin-6-line"></i></a>
                                                                        <a href="javascript:void(0)" v-if="isEditMode"
                                                                        v-on:click="addNewItemAttach(index)" class="addNew1"><i class="ri-add-circle-line"></i></a> <br>
                                                                        <a href="javascript:void(0)" @click="openSendArtworkToCustomer(product.order_product, artwork)"  v-if="artwork.id && artwork.attach_link">Send to customer</a>
                                                                    </td>
                                                                </tr>
                                                            </template>

                                                            <template v-if="!product.artworks || product.artworks.length == 0">
                                                                <tr>
                                                                    <td rowspan="1">{{ product.product_name }}</td>
                                                                    <td rowspan="1"><p v-html="product.product_desc"></p></td>

                                                                    <td colspan="7"><a href="javascript:void(0)" v-if="isEditMode"
                                                                                    v-on:click="addNewItemAttach(index)"
                                                                                    class="addNew1"><i class="ri-add-circle-line"></i></a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>

                                                        </tbody>
                                                    </table>

                                                </div>
                                                -->
                                                <template
                                                    v-if="
                                                        order.products.length >
                                                        1
                                                    "
                                                >
                                                    <h3
                                                        style="
                                                            text-transform: uppercase;
                                                        "
                                                    >
                                                        All Artworks
                                                    </h3>
                                                    <div class="invoiceDetails">
                                                        <table
                                                            class="table table-bordered table-hover"
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th
                                                                        style="
                                                                            width: 280px;
                                                                        "
                                                                    >
                                                                        Original
                                                                        customer
                                                                        file
                                                                    </th>
                                                                    <th
                                                                        style="
                                                                            width: 350px;
                                                                        "
                                                                    >
                                                                        Artwork
                                                                        Proof
                                                                    </th>
                                                                    <th>
                                                                        Artwork
                                                                        Status
                                                                    </th>
                                                                    <th>
                                                                        Comments
                                                                    </th>
                                                                    <th
                                                                        style="
                                                                            width: 20px;
                                                                        "
                                                                    ></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template
                                                                    v-if="
                                                                        order
                                                                            .order
                                                                            .artworks
                                                                            .length >
                                                                        0
                                                                    "
                                                                >
                                                                    <template
                                                                        v-for="(
                                                                            artwork,
                                                                            artworkIndex
                                                                        ) in order
                                                                            .order
                                                                            .artworks"
                                                                    >
                                                                        <tr
                                                                            v-if="
                                                                                (order
                                                                                    .order
                                                                                    .latest_artwork &&
                                                                                    artwork.id ==
                                                                                        order
                                                                                            .order
                                                                                            .latest_artwork
                                                                                            .id) ||
                                                                                artwork.id ==
                                                                                    null
                                                                            "
                                                                        >
                                                                            <td>
                                                                                <div
                                                                                    class="filetitlesec"
                                                                                >
                                                                                    <div
                                                                                        class="filetitleleft"
                                                                                        v-if="
                                                                                            order
                                                                                                .order
                                                                                                .original_customer_file
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="ellipsis"
                                                                                        >
                                                                                            <span
                                                                                                :title="
                                                                                                    order
                                                                                                        .order
                                                                                                        .original_customer_file
                                                                                                "
                                                                                                >{{
                                                                                                    order
                                                                                                        .order
                                                                                                        .original_customer_file
                                                                                                        | truncate(
                                                                                                            isEditMode
                                                                                                                ? 22
                                                                                                                : 30
                                                                                                        )
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="filetitleright"
                                                                                    >
                                                                                        <div
                                                                                            class="file-attachment-wrapper"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            <vue-dropzone
                                                                                                :options="
                                                                                                    dropzoneOptionsOriginalFile
                                                                                                "
                                                                                                :id="
                                                                                                    'item-original-file-' +
                                                                                                    artworkIndex
                                                                                                "
                                                                                                :useCustomSlot="
                                                                                                    true
                                                                                                "
                                                                                                ref="allProductsOriginalFileVueDropzone"
                                                                                                v-on:vdropzone-success="
                                                                                                    (
                                                                                                        file,
                                                                                                        response
                                                                                                    ) =>
                                                                                                        afterAllProductsOriginalFileUploadComplete(
                                                                                                            file,
                                                                                                            response
                                                                                                        )
                                                                                                "
                                                                                                v-on:vdropzone-error="
                                                                                                    (
                                                                                                        file,
                                                                                                        message,
                                                                                                        xhr
                                                                                                    ) =>
                                                                                                        allProductsOriginalFileUploadError(
                                                                                                            file,
                                                                                                            message,
                                                                                                            xhr
                                                                                                        )
                                                                                                "
                                                                                            >
                                                                                                <div
                                                                                                    class="dropzone-custom-content"
                                                                                                >
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-if="
                                                                                                            order
                                                                                                                .order
                                                                                                                .original_customer_file !=
                                                                                                            null
                                                                                                        "
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Replace
                                                                                                    </h3>
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-else
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Drag
                                                                                                        and
                                                                                                        drop
                                                                                                        to
                                                                                                        upload
                                                                                                        content!
                                                                                                    </h3>
                                                                                                </div>
                                                                                            </vue-dropzone>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div
                                                                                    class="orderbtnsec2"
                                                                                    v-if="
                                                                                        order
                                                                                            .order
                                                                                            .original_customer_file
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="filetitlesec"
                                                                                    >
                                                                                        <div
                                                                                            class="filetitleleft"
                                                                                        >
                                                                                            <span
                                                                                                class="orderbtnsec"
                                                                                            >
                                                                                                <a
                                                                                                    href="javascript:void(0)"
                                                                                                    v-on:click="
                                                                                                        downloadOriginalArtwork(
                                                                                                            order
                                                                                                                .order
                                                                                                                .original_customer_file
                                                                                                        )
                                                                                                    "
                                                                                                    class="downlodbtn"
                                                                                                    >Download</a
                                                                                                >
                                                                                            </span>
                                                                                        </div>
                                                                                        <div
                                                                                            class="filetitleright"
                                                                                        >
                                                                                            <span
                                                                                                class="orderbtnsec"
                                                                                            >
                                                                                                <a
                                                                                                    href="javascript:void(0)"
                                                                                                    v-if="
                                                                                                        !isEditMode &&
                                                                                                        ((getUser !=
                                                                                                            null &&
                                                                                                            getUser.user_type ==
                                                                                                                1) ||
                                                                                                            hasRole(
                                                                                                                'Admin'
                                                                                                            ))
                                                                                                    "
                                                                                                    v-on:click="
                                                                                                        openSendAllArtworkToVendor()
                                                                                                    "
                                                                                                    >Send
                                                                                                    to
                                                                                                    vendor</a
                                                                                                >
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div
                                                                                    class="filetitlesec"
                                                                                >
                                                                                    <div
                                                                                        class="filetitleleft"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="ellipsis"
                                                                                        >
                                                                                            <span
                                                                                                :title="
                                                                                                    artwork.attach_link
                                                                                                "
                                                                                                >{{
                                                                                                    artwork.attach_link
                                                                                                        | truncate(
                                                                                                            isEditMode
                                                                                                                ? 30
                                                                                                                : 40
                                                                                                        )
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="filetitleright"
                                                                                    >
                                                                                        <div
                                                                                            class="file-attachment-wrapper"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            <vue-dropzone
                                                                                                :options="
                                                                                                    dropzoneOptionsArtwork
                                                                                                "
                                                                                                :id="
                                                                                                    'other-dropzone-' +
                                                                                                    artworkIndex
                                                                                                "
                                                                                                :useCustomSlot="
                                                                                                    true
                                                                                                "
                                                                                                :key="
                                                                                                    artworkIndex
                                                                                                "
                                                                                                ref="allProductsArtworkFileVueDropzone"
                                                                                                v-on:vdropzone-success="
                                                                                                    (
                                                                                                        file,
                                                                                                        response
                                                                                                    ) =>
                                                                                                        afterAllArtworkUploadComplete(
                                                                                                            file,
                                                                                                            response,
                                                                                                            artworkIndex
                                                                                                        )
                                                                                                "
                                                                                                v-on:vdropzone-error="
                                                                                                    (
                                                                                                        file,
                                                                                                        message,
                                                                                                        xhr
                                                                                                    ) =>
                                                                                                        allArtworkUploadError(
                                                                                                            file,
                                                                                                            message,
                                                                                                            xhr,
                                                                                                            artworkIndex
                                                                                                        )
                                                                                                "
                                                                                            >
                                                                                                <div
                                                                                                    class="dropzone-custom-content"
                                                                                                    v-if="
                                                                                                        artwork.id &&
                                                                                                        artwork.attach_link
                                                                                                    "
                                                                                                >
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-if="
                                                                                                            artwork.attach_link !=
                                                                                                            null
                                                                                                        "
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Replace
                                                                                                    </h3>
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-else
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Drag
                                                                                                        and
                                                                                                        drop
                                                                                                        to
                                                                                                        upload
                                                                                                        content!
                                                                                                    </h3>
                                                                                                </div>
                                                                                            </vue-dropzone>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <span
                                                                                    class="orderbtnsec"
                                                                                    v-if="
                                                                                        artwork.id &&
                                                                                        artwork.attach_link
                                                                                    "
                                                                                >
                                                                                    <a
                                                                                        href="javascript:void(0)"
                                                                                        v-if="
                                                                                            [
                                                                                                'png',
                                                                                                'jpg',
                                                                                                'jpeg',
                                                                                            ].some(
                                                                                                (
                                                                                                    image
                                                                                                ) =>
                                                                                                    artwork.attach_link
                                                                                                        .toLowerCase()
                                                                                                        .includes(
                                                                                                            image
                                                                                                        )
                                                                                            )
                                                                                        "
                                                                                        @click="
                                                                                            imagePreview(
                                                                                                artwork.attach_link
                                                                                            )
                                                                                        "
                                                                                        class="downlodbtn"
                                                                                        >Preview</a
                                                                                    >
                                                                                    <a
                                                                                        href="javascript:void(0)"
                                                                                        v-on:click="
                                                                                            download(
                                                                                                artwork
                                                                                            )
                                                                                        "
                                                                                        class="downlodbtn"
                                                                                    >
                                                                                        Download</a
                                                                                    >
                                                                                </span>

                                                                                <div
                                                                                    class="orderbtnsec-title"
                                                                                    v-if="
                                                                                        artwork.id
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="title-left"
                                                                                    >
                                                                                        <span
                                                                                            >V-{{
                                                                                                artwork.version_number
                                                                                            }}</span
                                                                                        >
                                                                                        <span
                                                                                            >Uploaded
                                                                                            {{
                                                                                                artwork.updated_at
                                                                                            }}</span
                                                                                        >
                                                                                    </div>
                                                                                    <div
                                                                                        class="title-btnsec"
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                            v-on:click="
                                                                                                addNewAllProductArtwork()
                                                                                            "
                                                                                            class="add-versionbtn"
                                                                                            >Add
                                                                                            version</a
                                                                                        >
                                                                                    </div>
                                                                                </div>
                                                                                <span
                                                                                    class="orderbtnsec"
                                                                                    v-if="
                                                                                        artwork.id &&
                                                                                        artwork.attach_link
                                                                                    "
                                                                                >
                                                                                    <template
                                                                                        v-if="
                                                                                            order
                                                                                                .order
                                                                                                .latest_artwork &&
                                                                                            order
                                                                                                .order
                                                                                                .latest_artwork
                                                                                                .attach_link !=
                                                                                                null &&
                                                                                            order
                                                                                                .order
                                                                                                .latest_artwork
                                                                                                .attach_link !=
                                                                                                '' &&
                                                                                            !isEditMode
                                                                                        "
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                            @click="
                                                                                                openSendAllArtworkToCustomer(
                                                                                                    true
                                                                                                )
                                                                                            "
                                                                                            class="pull-right cussendbtn"
                                                                                            >Send
                                                                                            to
                                                                                            customer</a
                                                                                        >
                                                                                    </template>
                                                                                </span>
                                                                                <div
                                                                                    v-if="
                                                                                        artwork.id
                                                                                    "
                                                                                >
                                                                                    <a
                                                                                        v-if="
                                                                                            order.order.artworks.filter(
                                                                                                (
                                                                                                    x
                                                                                                ) =>
                                                                                                    x.id !=
                                                                                                    null
                                                                                            )
                                                                                                .length
                                                                                        "
                                                                                        class="previous-vsbtn"
                                                                                        @click="
                                                                                            openAllProductsArtworkVersionsModal()
                                                                                        "
                                                                                        href="javascript:void(0)"
                                                                                        >Previous
                                                                                        version</a
                                                                                    >
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <template
                                                                                    v-if="
                                                                                        isEditMode
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="input-group"
                                                                                    >
                                                                                        <ValidationProvider
                                                                                            name="ArtworkStatus"
                                                                                            rules="required"
                                                                                            v-slot="{
                                                                                                errors,
                                                                                            }"
                                                                                        >
                                                                                            <select
                                                                                                class="form-control"
                                                                                                v-model="
                                                                                                    order
                                                                                                        .order
                                                                                                        .artworks[
                                                                                                        artworkIndex
                                                                                                    ]
                                                                                                        .artwork_status_id
                                                                                                "
                                                                                                @change="
                                                                                                    artworkStatusChangeForAll
                                                                                                "
                                                                                            >
                                                                                                <option
                                                                                                    :value="
                                                                                                        null
                                                                                                    "
                                                                                                >
                                                                                                    Select
                                                                                                </option>
                                                                                                <option
                                                                                                    v-for="(
                                                                                                        status,
                                                                                                        index
                                                                                                    ) in artwork_statuses"
                                                                                                    :value="
                                                                                                        status.id
                                                                                                    "
                                                                                                >
                                                                                                    {{
                                                                                                        status.name
                                                                                                    }}
                                                                                                </option>
                                                                                            </select>
                                                                                            <div
                                                                                                class="error"
                                                                                                v-if="
                                                                                                    errors.length
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    errors[0]
                                                                                                }}
                                                                                            </div>
                                                                                        </ValidationProvider>
                                                                                    </div>
                                                                                </template>
                                                                                <template
                                                                                    v-if="
                                                                                        !isEditMode
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        artwork.artwork_status
                                                                                            ? artwork
                                                                                                  .artwork_status
                                                                                                  .name
                                                                                            : null
                                                                                    }}
                                                                                    <span
                                                                                        class="orderbtnsec"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            v-if="
                                                                                                artwork
                                                                                                    .comments
                                                                                                    .length &&
                                                                                                artwork.artwork_status_id ==
                                                                                                    7
                                                                                            "
                                                                                            @click="
                                                                                                viewComments(
                                                                                                    artwork
                                                                                                )
                                                                                            "
                                                                                            >View
                                                                                            Comments</a
                                                                                        >
                                                                                    </span>
                                                                                </template>
                                                                            </td>
                                                                            <td>
                                                                                <textarea
                                                                                    v-if="
                                                                                        isEditMode
                                                                                    "
                                                                                    class="form-control resize-ta"
                                                                                    v-model="
                                                                                        order
                                                                                            .order
                                                                                            .artworks[
                                                                                            artworkIndex
                                                                                        ]
                                                                                            .comment
                                                                                    "
                                                                                    style="
                                                                                        height: 66px;
                                                                                        overflow-y: hidden;
                                                                                    "
                                                                                ></textarea>
                                                                                <p
                                                                                    v-if="
                                                                                        !isEditMode
                                                                                    "
                                                                                    v-html="
                                                                                        artwork.comment
                                                                                    "
                                                                                ></p>
                                                                            </td>
                                                                            <td>
                                                                                <a
                                                                                    href="javascript:void(0)"
                                                                                    v-if="
                                                                                        (getUser !=
                                                                                            null &&
                                                                                            getUser.user_type ==
                                                                                                1) ||
                                                                                        hasRole(
                                                                                            'Admin'
                                                                                        )
                                                                                    "
                                                                                    v-on:click="
                                                                                        removeAllProductArtwork(
                                                                                            artworkIndex,
                                                                                            artwork.id
                                                                                        )
                                                                                    "
                                                                                    class="trashBtn"
                                                                                    ><i
                                                                                        class="ri-delete-bin-6-line"
                                                                                    ></i
                                                                                ></a>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                                <template
                                                                    v-else
                                                                >
                                                                    <tr>
                                                                        <td>
                                                                            <template
                                                                                v-if="
                                                                                    order
                                                                                        .order
                                                                                        .original_customer_file
                                                                                "
                                                                            >
                                                                                <span
                                                                                    :title="
                                                                                        order
                                                                                            .order
                                                                                            .original_customer_file
                                                                                    "
                                                                                    >{{
                                                                                        order
                                                                                            .order
                                                                                            .original_customer_file
                                                                                            | truncate(
                                                                                                isEditMode
                                                                                                    ? 22
                                                                                                    : 30
                                                                                            )
                                                                                    }}</span
                                                                                >
                                                                                <div
                                                                                    class="filetitlesec"
                                                                                >
                                                                                    <div
                                                                                        class="filetitleleft"
                                                                                    >
                                                                                        <span
                                                                                            class="orderbtnsec"
                                                                                        >
                                                                                            <a
                                                                                                href="javascript:void(0)"
                                                                                                v-on:click="
                                                                                                    downloadOriginalArtwork(
                                                                                                        order
                                                                                                            .order
                                                                                                            .original_customer_file
                                                                                                    )
                                                                                                "
                                                                                                class="downlodbtn"
                                                                                                >Download</a
                                                                                            >
                                                                                        </span>
                                                                                    </div>
                                                                                    <div
                                                                                        class="filetitleright"
                                                                                    >
                                                                                        <span
                                                                                            class="orderbtnsec"
                                                                                        >
                                                                                            <a
                                                                                                href="javascript:void(0)"
                                                                                                v-if="
                                                                                                    !isEditMode &&
                                                                                                    ((getUser !=
                                                                                                        null &&
                                                                                                        getUser.user_type ==
                                                                                                            1) ||
                                                                                                        hasRole(
                                                                                                            'Admin'
                                                                                                        ))
                                                                                                "
                                                                                                v-on:click="
                                                                                                    openSendAllArtworkToVendor()
                                                                                                "
                                                                                                >Send
                                                                                                to
                                                                                                vendor</a
                                                                                            >
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </template>

                                                                            <div
                                                                                class="filetitlesec"
                                                                            >
                                                                                <div
                                                                                    class="file-attachment-wrapper"
                                                                                    v-if="
                                                                                        (getUser !=
                                                                                            null &&
                                                                                            getUser.user_type ==
                                                                                                1) ||
                                                                                        hasRole(
                                                                                            'Admin'
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <vue-dropzone
                                                                                        :options="
                                                                                            dropzoneOptionsOriginalFile
                                                                                        "
                                                                                        :id="'item-original-file-1asd'"
                                                                                        :useCustomSlot="
                                                                                            true
                                                                                        "
                                                                                        ref="allProductsOriginalFileVueDropzone"
                                                                                        v-on:vdropzone-success="
                                                                                            (
                                                                                                file,
                                                                                                response
                                                                                            ) =>
                                                                                                afterAllProductsOriginalFileUploadComplete(
                                                                                                    file,
                                                                                                    response
                                                                                                )
                                                                                        "
                                                                                        v-on:vdropzone-error="
                                                                                            (
                                                                                                file,
                                                                                                message,
                                                                                                xhr
                                                                                            ) =>
                                                                                                allProductsOriginalFileUploadError(
                                                                                                    file,
                                                                                                    message,
                                                                                                    xhr
                                                                                                )
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="dropzone-custom-content"
                                                                                        >
                                                                                            <h3
                                                                                                class="dropzone-custom-title"
                                                                                                v-if="
                                                                                                    order
                                                                                                        .order
                                                                                                        .original_customer_file !=
                                                                                                    null
                                                                                                "
                                                                                            >
                                                                                                <i
                                                                                                    class="fa fa-upload"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                                Replace
                                                                                            </h3>
                                                                                            <h3
                                                                                                class="dropzone-custom-title"
                                                                                                v-else
                                                                                            >
                                                                                                <i
                                                                                                    class="fa fa-upload"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                                Drag
                                                                                                and
                                                                                                drop
                                                                                                to
                                                                                                upload
                                                                                                content!
                                                                                            </h3>
                                                                                        </div>
                                                                                    </vue-dropzone>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td
                                                                            colspan="4"
                                                                        >
                                                                            <a
                                                                                href="javascript:void(0)"
                                                                                v-on:click="
                                                                                    addNewAllProductArtwork()
                                                                                "
                                                                                v-if="
                                                                                    isEditMode
                                                                                "
                                                                                class="addNew1"
                                                                                ><i
                                                                                    class="fa fa-plus-circle"
                                                                                    aria-hidden="true"
                                                                                ></i
                                                                            ></a>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </template>

                                                <div class="artwork-title">
                                                    <h3
                                                        style="
                                                            text-transform: uppercase;
                                                        "
                                                    >
                                                        ARTWORKS
                                                        <template
                                                            v-if="
                                                                eachProductsHasArtwork &&
                                                                order.products
                                                                    .length >
                                                                    1 &&
                                                                !isEditMode
                                                            "
                                                        >
                                                            <a
                                                                href="javascript:void(0)"
                                                                v-if="
                                                                    (getUser !=
                                                                        null &&
                                                                        getUser.user_type ==
                                                                            1) ||
                                                                    hasRole(
                                                                        'Admin'
                                                                    )
                                                                "
                                                                @click="
                                                                    openSendAllArtworkToCustomer(
                                                                        false
                                                                    )
                                                                "
                                                                class="pull-right cussendbtn"
                                                                >Send all
                                                                artworks to
                                                                customer</a
                                                            >
                                                        </template>
                                                    </h3>
                                                    <a
                                                        href="javascript:void(0)"
                                                        class="pull-right cussendbtn2"
                                                        >View</a
                                                    >
                                                </div>
                                                <div class="invoiceDetails">
                                                    <table
                                                        class="table table-bordered table-hover"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    style="
                                                                        width: 120px;
                                                                    "
                                                                >
                                                                    Product Name
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 200px;
                                                                    "
                                                                >
                                                                    Description
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 260px;
                                                                    "
                                                                >
                                                                    Original
                                                                    Customer
                                                                    File
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 230px;
                                                                    "
                                                                >
                                                                    Approved
                                                                    Artwork
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 120px;
                                                                    "
                                                                >
                                                                    Artwork
                                                                    Status
                                                                </th>
                                                                <!--<th style="width: 180px;">Comments</th>-->
                                                                <th
                                                                    style="
                                                                        width: 20px;
                                                                    "
                                                                >
                                                                    <!--Actions-->
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody
                                                            v-if="
                                                                order.products
                                                                    .length > 0
                                                            "
                                                        >
                                                            <template
                                                                v-for="(
                                                                    product,
                                                                    index
                                                                ) in order.products.filter(
                                                                    (x) =>
                                                                        x.id !=
                                                                        null
                                                                )"
                                                            >
                                                                <template
                                                                    v-if="
                                                                        product.artworks &&
                                                                        product.artworks.filter(
                                                                            (
                                                                                art
                                                                            ) =>
                                                                                art.id ==
                                                                                    null ||
                                                                                (product.latest_artwork &&
                                                                                    art.id ==
                                                                                        product
                                                                                            .latest_artwork
                                                                                            .id)
                                                                        )
                                                                            .length >
                                                                            0
                                                                    "
                                                                >
                                                                    <template
                                                                        v-for="(
                                                                            artwork,
                                                                            artworkIndex
                                                                        ) in product.artworks"
                                                                    >
                                                                        <tr
                                                                            v-if="
                                                                                (product.latest_artwork &&
                                                                                    artwork.id ==
                                                                                        product
                                                                                            .latest_artwork
                                                                                            .id) ||
                                                                                artwork.id ==
                                                                                    null
                                                                            "
                                                                        >
                                                                            <template
                                                                                v-if="
                                                                                    checkIfFirstRow(
                                                                                        product,
                                                                                        index,
                                                                                        artwork,
                                                                                        artworkIndex
                                                                                    )
                                                                                "
                                                                            >
                                                                                <td
                                                                                    :rowspan="
                                                                                        product.artworks.filter(
                                                                                            (
                                                                                                art
                                                                                            ) =>
                                                                                                art.id ==
                                                                                                    null ||
                                                                                                (product.latest_artwork &&
                                                                                                    art.id ==
                                                                                                        product
                                                                                                            .latest_artwork
                                                                                                            .id)
                                                                                        )
                                                                                            .length
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        product.product_name
                                                                                    }}
                                                                                </td>
                                                                                <td
                                                                                    :rowspan="
                                                                                        product.artworks.filter(
                                                                                            (
                                                                                                art
                                                                                            ) =>
                                                                                                art.id ==
                                                                                                    null ||
                                                                                                (product.latest_artwork &&
                                                                                                    art.id ==
                                                                                                        product
                                                                                                            .latest_artwork
                                                                                                            .id)
                                                                                        )
                                                                                            .length
                                                                                    "
                                                                                >
                                                                                    <p
                                                                                        v-html="
                                                                                            product.product_desc
                                                                                        "
                                                                                    ></p>
                                                                                </td>
                                                                                <td
                                                                                    :rowspan="
                                                                                        product.artworks.filter(
                                                                                            (
                                                                                                art
                                                                                            ) =>
                                                                                                art.id ==
                                                                                                    null ||
                                                                                                (product.latest_artwork &&
                                                                                                    art.id ==
                                                                                                        product
                                                                                                            .latest_artwork
                                                                                                            .id)
                                                                                        )
                                                                                            .length
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="filetitlesec"
                                                                                    >
                                                                                        <div
                                                                                            class="filetitleleft"
                                                                                            v-if="
                                                                                                product.id &&
                                                                                                product
                                                                                                    .order_product
                                                                                                    .original_customer_file
                                                                                            "
                                                                                        >
                                                                                            <div
                                                                                                class="ellipsis"
                                                                                            >
                                                                                                <span
                                                                                                    :title="
                                                                                                        product
                                                                                                            .order_product
                                                                                                            .original_customer_file
                                                                                                    "
                                                                                                    >{{
                                                                                                        product
                                                                                                            .order_product
                                                                                                            .original_customer_file
                                                                                                            | truncate(
                                                                                                                isEditMode
                                                                                                                    ? 23
                                                                                                                    : 30
                                                                                                            )
                                                                                                    }}</span
                                                                                                >
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            class="filetitleright"
                                                                                        >
                                                                                            <div
                                                                                                v-if="
                                                                                                    (getUser !=
                                                                                                        null &&
                                                                                                        getUser.user_type ==
                                                                                                            1) ||
                                                                                                    hasRole(
                                                                                                        'Admin'
                                                                                                    )
                                                                                                "
                                                                                                class="file-attachment-wrapper"
                                                                                            >
                                                                                                <vue-dropzone
                                                                                                    :options="
                                                                                                        dropzoneOptionsOriginalFile
                                                                                                    "
                                                                                                    :id="
                                                                                                        'item-original-file-' +
                                                                                                        index
                                                                                                    "
                                                                                                    :use-custom-slot="
                                                                                                        true
                                                                                                    "
                                                                                                    :key="
                                                                                                        index
                                                                                                    "
                                                                                                    ref="itemOriginalFileVueDropzones"
                                                                                                    v-on:vdropzone-success="
                                                                                                        (
                                                                                                            file,
                                                                                                            response
                                                                                                        ) =>
                                                                                                            afterItemOriginalFileUploadComplete(
                                                                                                                file,
                                                                                                                response,
                                                                                                                index
                                                                                                            )
                                                                                                    "
                                                                                                    v-on:vdropzone-error="
                                                                                                        (
                                                                                                            file,
                                                                                                            message,
                                                                                                            xhr
                                                                                                        ) =>
                                                                                                            itemOriginalFileUploadError(
                                                                                                                file,
                                                                                                                message,
                                                                                                                xhr,
                                                                                                                index
                                                                                                            )
                                                                                                    "
                                                                                                >
                                                                                                    <div
                                                                                                        class="dropzone-custom-content"
                                                                                                    >
                                                                                                        <h3
                                                                                                            class="dropzone-custom-title"
                                                                                                            v-if="
                                                                                                                product
                                                                                                                    .order_product
                                                                                                                    .original_customer_file !=
                                                                                                                null
                                                                                                            "
                                                                                                        >
                                                                                                            <i
                                                                                                                class="fa fa-upload"
                                                                                                                aria-hidden="true"
                                                                                                            ></i>
                                                                                                            Replace
                                                                                                        </h3>
                                                                                                        <h3
                                                                                                            class="dropzone-custom-title"
                                                                                                            v-else
                                                                                                        >
                                                                                                            <i
                                                                                                                class="fa fa-upload"
                                                                                                                aria-hidden="true"
                                                                                                            ></i>
                                                                                                            Drag
                                                                                                            and
                                                                                                            drop
                                                                                                            to
                                                                                                            upload
                                                                                                            content!
                                                                                                        </h3>
                                                                                                    </div>
                                                                                                </vue-dropzone>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div
                                                                                        class="orderbtnsec2"
                                                                                        v-if="
                                                                                            product.id &&
                                                                                            product
                                                                                                .order_product
                                                                                                .original_customer_file
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="filetitlesec"
                                                                                        >
                                                                                            <div
                                                                                                class="filetitleleft"
                                                                                            >
                                                                                                <div
                                                                                                    class="orderbtnsec"
                                                                                                >
                                                                                                    <a
                                                                                                        href="javascript:void(0)"
                                                                                                        @click="
                                                                                                            downloadOriginalArtwork(
                                                                                                                product
                                                                                                                    .order_product
                                                                                                                    .original_customer_file
                                                                                                            )
                                                                                                        "
                                                                                                        class="downlodbtn"
                                                                                                        >Download</a
                                                                                                    >
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                class="filetitleright"
                                                                                            >
                                                                                                <div
                                                                                                    class="orderbtnsec"
                                                                                                >
                                                                                                    <a
                                                                                                        href="javascript:void(0)"
                                                                                                        v-if="
                                                                                                            !isEditMode &&
                                                                                                            ((getUser !=
                                                                                                                null &&
                                                                                                                getUser.user_type ==
                                                                                                                    1) ||
                                                                                                                hasRole(
                                                                                                                    'Admin'
                                                                                                                ))
                                                                                                        "
                                                                                                        @click="
                                                                                                            openSendArtworkToVendor(
                                                                                                                product
                                                                                                            )
                                                                                                        "
                                                                                                        >Send
                                                                                                        to
                                                                                                        vendor</a
                                                                                                    >
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </template>

                                                                            <td>
                                                                                <div
                                                                                    class="filetitlesec"
                                                                                >
                                                                                    <div
                                                                                        class="filetitleleft"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="ellipsis"
                                                                                        >
                                                                                            <span
                                                                                                :title="
                                                                                                    artwork.attach_link
                                                                                                "
                                                                                                >{{
                                                                                                    artwork.attach_link
                                                                                                        | truncate(
                                                                                                            isEditMode
                                                                                                                ? 80
                                                                                                                : 90
                                                                                                        )
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="filetitleright"
                                                                                    >
                                                                                        <div
                                                                                            class="file-attachment-wrapper"
                                                                                            v-if="
                                                                                                (getUser !=
                                                                                                    null &&
                                                                                                    getUser.user_type ==
                                                                                                        1) ||
                                                                                                hasRole(
                                                                                                    'Admin'
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            <vue-dropzone
                                                                                                :options="
                                                                                                    dropzoneOptionsArtwork
                                                                                                "
                                                                                                :id="
                                                                                                    'item-dropzone-' +
                                                                                                    index +
                                                                                                    '-' +
                                                                                                    artworkIndex
                                                                                                "
                                                                                                :use-custom-slot="
                                                                                                    true
                                                                                                "
                                                                                                :key="
                                                                                                    index
                                                                                                "
                                                                                                ref="itemArtworkFileVueDropzones"
                                                                                                v-on:vdropzone-success="
                                                                                                    (
                                                                                                        file,
                                                                                                        response
                                                                                                    ) =>
                                                                                                        afterItemArtworkUploadComplete(
                                                                                                            file,
                                                                                                            response,
                                                                                                            index,
                                                                                                            artworkIndex
                                                                                                        )
                                                                                                "
                                                                                                v-on:vdropzone-error="
                                                                                                    (
                                                                                                        file,
                                                                                                        message,
                                                                                                        xhr
                                                                                                    ) =>
                                                                                                        itemArtworkUploadError(
                                                                                                            file,
                                                                                                            message,
                                                                                                            xhr,
                                                                                                            artworkIndex
                                                                                                        )
                                                                                                "
                                                                                            >
                                                                                                <div
                                                                                                    class="dropzone-custom-content"
                                                                                                >
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-if="
                                                                                                            artwork.attach_link !=
                                                                                                            null
                                                                                                        "
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Replace
                                                                                                    </h3>
                                                                                                    <h3
                                                                                                        class="dropzone-custom-title"
                                                                                                        v-else
                                                                                                    >
                                                                                                        <i
                                                                                                            class="fa fa-upload"
                                                                                                            aria-hidden="true"
                                                                                                        ></i>
                                                                                                        Drag
                                                                                                        and
                                                                                                        drop
                                                                                                        to
                                                                                                        upload
                                                                                                        content!
                                                                                                    </h3>
                                                                                                </div>
                                                                                            </vue-dropzone>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    v-if="
                                                                                        artwork.id
                                                                                    "
                                                                                    class="orderbtnsec2"
                                                                                >
                                                                                    <div
                                                                                        class="orderbtnsec2"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="filetitlesec"
                                                                                        >
                                                                                            <div
                                                                                                class="filetitleleft"
                                                                                            >
                                                                                                <span
                                                                                                    class="orderbtnsec"
                                                                                                >
                                                                                                    <a
                                                                                                        href="javascript:void(0)"
                                                                                                        v-if="
                                                                                                            [
                                                                                                                'png',
                                                                                                                'jpg',
                                                                                                                'jpeg',
                                                                                                            ].some(
                                                                                                                (
                                                                                                                    image
                                                                                                                ) =>
                                                                                                                    artwork.attach_link
                                                                                                                        .toLowerCase()
                                                                                                                        .includes(
                                                                                                                            image
                                                                                                                        )
                                                                                                            )
                                                                                                        "
                                                                                                        @click="
                                                                                                            imagePreview(
                                                                                                                artwork.attach_link
                                                                                                            )
                                                                                                        "
                                                                                                        class="downlodbtn"
                                                                                                        >Preview</a
                                                                                                    >
                                                                                                    <a
                                                                                                        href="javascript:void(0)"
                                                                                                        v-on:click="
                                                                                                            download(
                                                                                                                artwork
                                                                                                            )
                                                                                                        "
                                                                                                        class="downlodbtn"
                                                                                                        >Download</a
                                                                                                    >
                                                                                                </span>
                                                                                            </div>
                                                                                            <div
                                                                                                class="filetitleright"
                                                                                            >
                                                                                                <span
                                                                                                    class="orderbtnsec"
                                                                                                    ><a
                                                                                                        href="javascript:void(0)"
                                                                                                        @click="
                                                                                                            openSendArtworkToCustomer(
                                                                                                                product,
                                                                                                                artwork
                                                                                                            )
                                                                                                        "
                                                                                                        v-if="
                                                                                                            artwork.id &&
                                                                                                            artwork.attach_link &&
                                                                                                            !isEditMode &&
                                                                                                            ((getUser !=
                                                                                                                null &&
                                                                                                                getUser.user_type ==
                                                                                                                    1) ||
                                                                                                                hasRole(
                                                                                                                    'Admin'
                                                                                                                ))
                                                                                                        "
                                                                                                        >Send
                                                                                                        to
                                                                                                        customer</a
                                                                                                    >
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="orderbtnsec-title"
                                                                                    >
                                                                                        <div
                                                                                            class="title-left"
                                                                                        >
                                                                                            <span
                                                                                                >V-{{
                                                                                                    artwork.version_number
                                                                                                }}</span
                                                                                            >
                                                                                            <span
                                                                                                >Uploaded
                                                                                                {{
                                                                                                    artwork.updated_at
                                                                                                }}</span
                                                                                            >
                                                                                        </div>
                                                                                        <div
                                                                                            class="title-btnsec"
                                                                                        >
                                                                                            <a
                                                                                                href="javascript:void(0)"
                                                                                                v-if="
                                                                                                    (getUser !=
                                                                                                        null &&
                                                                                                        getUser.user_type ==
                                                                                                            1) ||
                                                                                                    hasRole(
                                                                                                        'Admin'
                                                                                                    )
                                                                                                "
                                                                                                v-on:click="
                                                                                                    addNewItemAttachVersion(
                                                                                                        index
                                                                                                    )
                                                                                                "
                                                                                                class="add-versionbtn"
                                                                                                >Add
                                                                                                version</a
                                                                                            >
                                                                                        </div>
                                                                                    </div>

                                                                                    <span
                                                                                        class="orderbtnsec"
                                                                                    >
                                                                                        <a
                                                                                            v-if="
                                                                                                product
                                                                                                    .artworks
                                                                                                    .length
                                                                                            "
                                                                                            class="previous-vsbtn"
                                                                                            @click="
                                                                                                openProductArtworkVersionsModal(
                                                                                                    product
                                                                                                )
                                                                                            "
                                                                                            href="javascript:void(0)"
                                                                                            >Previous
                                                                                            version</a
                                                                                        >
                                                                                    </span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <template
                                                                                    v-if="
                                                                                        isEditMode
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="input-group"
                                                                                    >
                                                                                        <ValidationProvider
                                                                                            name="ArtworkStatus"
                                                                                            rules="required"
                                                                                            v-slot="{
                                                                                                errors,
                                                                                            }"
                                                                                        >
                                                                                            <select
                                                                                                class="form-control"
                                                                                                v-model="
                                                                                                    order
                                                                                                        .products[
                                                                                                        index
                                                                                                    ]
                                                                                                        .artworks[
                                                                                                        artworkIndex
                                                                                                    ]
                                                                                                        .artwork_status_id
                                                                                                "
                                                                                            >
                                                                                                <option
                                                                                                    :value="
                                                                                                        null
                                                                                                    "
                                                                                                >
                                                                                                    Select
                                                                                                </option>
                                                                                                <option
                                                                                                    v-for="(
                                                                                                        status,
                                                                                                        index
                                                                                                    ) in artwork_statuses"
                                                                                                    :value="
                                                                                                        status.id
                                                                                                    "
                                                                                                >
                                                                                                    {{
                                                                                                        status.name
                                                                                                    }}
                                                                                                </option>
                                                                                            </select>
                                                                                            <div
                                                                                                class="error"
                                                                                                v-if="
                                                                                                    errors.length
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    errors[0]
                                                                                                }}
                                                                                            </div>
                                                                                        </ValidationProvider>
                                                                                    </div>
                                                                                </template>
                                                                                <template
                                                                                    v-if="
                                                                                        !isEditMode
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        artwork.artwork_status
                                                                                            ? artwork
                                                                                                  .artwork_status
                                                                                                  .name
                                                                                            : null
                                                                                    }}
                                                                                    <div
                                                                                        class="orderbtnsec"
                                                                                        v-if="
                                                                                            artwork.id &&
                                                                                            artwork.attach_link
                                                                                        "
                                                                                    >
                                                                                        <a
                                                                                            href="javascript:void(0)"
                                                                                            v-if="
                                                                                                artwork
                                                                                                    .comments
                                                                                                    .length &&
                                                                                                artwork.artwork_status_id ==
                                                                                                    7
                                                                                            "
                                                                                            @click="
                                                                                                viewComments(
                                                                                                    artwork
                                                                                                )
                                                                                            "
                                                                                            >View
                                                                                            Comments</a
                                                                                        >
                                                                                    </div>
                                                                                </template>
                                                                            </td>
                                                                            <!--<td>
                                                                        <textarea v-if="isEditMode"
                                                                                  class="form-control resize-ta"
                                                                                  v-model="order.products[index].artworks[artworkIndex].comment"
                                                                                  style="height:66px;overflow-y:hidden;"></textarea>
                                                                            <p v-if="!isEditMode"
                                                                               v-html="artwork.comment"></p>
                                                                        </td>-->
                                                                            <td
                                                                                style="
                                                                                    width: 20px;
                                                                                "
                                                                            >
                                                                                <a
                                                                                    href="javascript:void(0)"
                                                                                    v-if="
                                                                                        (getUser !=
                                                                                            null &&
                                                                                            getUser.user_type ==
                                                                                                1) ||
                                                                                        hasRole(
                                                                                            'Admin'
                                                                                        )
                                                                                    "
                                                                                    v-on:click="
                                                                                        removeItemAttach(
                                                                                            index,
                                                                                            artworkIndex,
                                                                                            product.id,
                                                                                            artwork.id
                                                                                        )
                                                                                    "
                                                                                    class="trashBtn"
                                                                                    ><i
                                                                                        class="ri-delete-bin-6-line"
                                                                                    ></i
                                                                                ></a>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </template>
                                                                <template
                                                                    v-if="
                                                                        !product.artworks ||
                                                                        product
                                                                            .artworks
                                                                            .length ==
                                                                            0
                                                                    "
                                                                >
                                                                    <tr>
                                                                        <td
                                                                            rowspan="1"
                                                                        >
                                                                            {{
                                                                                product.product_name
                                                                            }}
                                                                        </td>
                                                                        <td
                                                                            rowspan="1"
                                                                        >
                                                                            <p
                                                                                v-html="
                                                                                    product.product_desc
                                                                                "
                                                                            ></p>
                                                                        </td>

                                                                        <td
                                                                            colspan="7"
                                                                        >
                                                                            <a
                                                                                href="javascript:void(0)"
                                                                                v-if="
                                                                                    (getUser !=
                                                                                        null &&
                                                                                        getUser.user_type ==
                                                                                            1) ||
                                                                                    hasRole(
                                                                                        'Admin'
                                                                                    )
                                                                                "
                                                                                @click="
                                                                                    addNewItemAttach(
                                                                                        index
                                                                                    )
                                                                                "
                                                                                class="addNew1"
                                                                            >
                                                                                <i
                                                                                    class="fa fa-plus-circle"
                                                                                    aria-hidden="true"
                                                                                ></i>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <h3
                                                    style="
                                                        text-transform: uppercase;
                                                    "
                                                >
                                                    OTHER ATTACHMENTS
                                                </h3>
                                                <div class="invoiceDetails">
                                                    <table
                                                        class="table table-bordered table-hover mb-0"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>Type</th>
                                                                <th
                                                                    style="
                                                                        width: 300px;
                                                                    "
                                                                >
                                                                    File
                                                                </th>
                                                                <th>
                                                                    Comments
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 120px;
                                                                    "
                                                                >
                                                                    Upload time
                                                                </th>
                                                                <th>
                                                                    Upload file
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 20px;
                                                                    "
                                                                >
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="(
                                                                    artwork,
                                                                    artworkIndex
                                                                ) in order.artworks"
                                                            >
                                                                <td>
                                                                    <input
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            order
                                                                                .artworks[
                                                                                artworkIndex
                                                                            ]
                                                                                .attach_type
                                                                        "
                                                                        id="searchQuotationInput"
                                                                    />
                                                                    <p
                                                                        v-if="
                                                                            !isEditMode
                                                                        "
                                                                        v-html="
                                                                            artwork.attach_type
                                                                        "
                                                                    ></p>
                                                                </td>
                                                                <td>
                                                                    <template
                                                                        v-if="
                                                                            artwork.id &&
                                                                            artwork.attach_link
                                                                        "
                                                                    >
                                                                        <span
                                                                            :title="
                                                                                artwork.attach_link
                                                                            "
                                                                            >{{
                                                                                artwork.attach_link
                                                                                    | truncate(
                                                                                        100
                                                                                    )
                                                                            }}</span
                                                                        >

                                                                        <div
                                                                            class="orderbtnsec"
                                                                        >
                                                                            <a
                                                                                href="javascript:void(0)"
                                                                                v-on:click="
                                                                                    download(
                                                                                        artwork
                                                                                    )
                                                                                "
                                                                                class="downlodbtn"
                                                                                >Download</a
                                                                            >
                                                                        </div>
                                                                        <br />
                                                                    </template>
                                                                    <template
                                                                        v-if="
                                                                            artwork.id
                                                                        "
                                                                    >
                                                                        V:
                                                                        {{
                                                                            artwork.version_number
                                                                        }}
                                                                    </template>
                                                                </td>
                                                                <td>
                                                                    <textarea
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        class="form-control resize-ta"
                                                                        v-model="
                                                                            order
                                                                                .artworks[
                                                                                artworkIndex
                                                                            ]
                                                                                .comment
                                                                        "
                                                                        style="
                                                                            height: 66px;
                                                                            overflow-y: hidden;
                                                                        "
                                                                    ></textarea>
                                                                    <p
                                                                        v-if="
                                                                            !isEditMode
                                                                        "
                                                                        v-html="
                                                                            artwork.comment
                                                                        "
                                                                    ></p>
                                                                </td>
                                                                <td>
                                                                    <template
                                                                        v-if="
                                                                            artwork.id
                                                                        "
                                                                    >
                                                                        {{
                                                                            artwork.updated_at
                                                                        }}
                                                                    </template>
                                                                </td>
                                                                <td width="10%">
                                                                    <div
                                                                        class="filetitlesec"
                                                                    >
                                                                        <div
                                                                            class="file-attachment-wrapper"
                                                                            v-if="
                                                                                (getUser !=
                                                                                    null &&
                                                                                    getUser.user_type ==
                                                                                        1) ||
                                                                                hasRole(
                                                                                    'Admin'
                                                                                )
                                                                            "
                                                                        >
                                                                            <vue-dropzone
                                                                                :options="
                                                                                    dropzoneOptions
                                                                                "
                                                                                :id="
                                                                                    'other-dropzone-' +
                                                                                    artworkIndex
                                                                                "
                                                                                :use-custom-slot="
                                                                                    true
                                                                                "
                                                                                :key="
                                                                                    artworkIndex
                                                                                "
                                                                                ref="otherAttachments"
                                                                                v-on:vdropzone-success="
                                                                                    (
                                                                                        file,
                                                                                        response
                                                                                    ) =>
                                                                                        afterArtworkUploadComplete(
                                                                                            file,
                                                                                            response,
                                                                                            artworkIndex
                                                                                        )
                                                                                "
                                                                                v-on:vdropzone-error="
                                                                                    (
                                                                                        file,
                                                                                        message,
                                                                                        xhr
                                                                                    ) =>
                                                                                        otherAttachmentUploadError(
                                                                                            file,
                                                                                            message,
                                                                                            xhr,
                                                                                            artworkIndex
                                                                                        )
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="dropzone-custom-content"
                                                                                >
                                                                                    <h3
                                                                                        class="dropzone-custom-title"
                                                                                        v-if="
                                                                                            artwork.attach_link !=
                                                                                            null
                                                                                        "
                                                                                    >
                                                                                        <i
                                                                                            class="fa fa-upload"
                                                                                            aria-hidden="true"
                                                                                        ></i>
                                                                                        Replace
                                                                                    </h3>
                                                                                    <h3
                                                                                        class="dropzone-custom-title"
                                                                                        v-else
                                                                                    >
                                                                                        <i
                                                                                            class="fa fa-upload"
                                                                                            aria-hidden="true"
                                                                                        ></i>
                                                                                        Drag
                                                                                        and
                                                                                        drop
                                                                                        to
                                                                                        upload
                                                                                        content!
                                                                                    </h3>
                                                                                </div>
                                                                            </vue-dropzone>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-if="
                                                                            (getUser !=
                                                                                null &&
                                                                                getUser.user_type ==
                                                                                    1) ||
                                                                            hasRole(
                                                                                'Admin'
                                                                            )
                                                                        "
                                                                        v-on:click="
                                                                            removeOtherAttach(
                                                                                artworkIndex,
                                                                                artwork.id
                                                                            )
                                                                        "
                                                                        class="trashBtn"
                                                                        ><i
                                                                            class="ri-delete-bin-6-line"
                                                                        ></i
                                                                    ></a>
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-on:click="
                                                                            addNewOtherAttach()
                                                                        "
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        class="addNew1"
                                                                        ><i
                                                                            class="ri-add-circle-line"
                                                                        ></i
                                                                    ></a>
                                                                </td>
                                                            </tr>

                                                            <tr
                                                                v-if="
                                                                    order
                                                                        .artworks
                                                                        .length ==
                                                                    0
                                                                "
                                                            >
                                                                <td colspan="6">
                                                                    <a
                                                                        href="javascript:void(0)"
                                                                        v-on:click="
                                                                            addNewOtherAttach()
                                                                        "
                                                                        v-if="
                                                                            isEditMode
                                                                        "
                                                                        class="addNew1"
                                                                        ><i
                                                                            class="ri-add-circle-line"
                                                                        ></i
                                                                    ></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="tabs3">
                                            <div class="invoiceBox">
                                                <!-- <div class="form-group">
                                                    <label class="invgroupLeft"
                                                        >MBL Number
                                                    </label>
                                                    <div class="invgroupRight">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder=""
                                                            v-model="
                                                                order.mbl_number
                                                            "
                                                        />
                                                    </div>
                                                </div>

                                                <div class="form-group">
                                                    <a
                                                        href="javascript:void(0);"
                                                        @click="saveMblNumber"
                                                        class="btn create-btn"
                                                        >Save</a
                                                    >
                                                </div>

                                                <div class="form-group" v-if="order.mbl_number != null">
                                                    <a
                                                        href="javascript:void(0);"
                                                        @click="
                                                            getShippingDetails
                                                        "
                                                        class="btn create-btn"
                                                        >Get Details</a
                                                    >
                                                </div>

                                                <OrderShipmentData
                                                    v-if="showShimpment"
                                                    :bus="bus"
                                                    :loading="loading"
                                                    :shipmentDetails="
                                                        shipmentDetails
                                                    "
                                                ></OrderShipmentData> -->
                                                <OrderShipments
                                                    :order="order.order"
                                                    :po="order"
                                                    :bus="bus"
                                                    :loading="loading"
                                                    :shippingProducts="
                                                        shippingProducts
                                                    "
                                                ></OrderShipments>

                                                <a
                                                    href="javascript:void(0);"
                                                    data-toggle="modal"
                                                    data-target="#addShippingModal"
                                                    class="btn create-btn"
                                                    >Create Shipment</a
                                                >
                                                

                                                <a
                                                    href="javascript:void(0);"
                                                    data-toggle="modal"
                                                    data-target="#addShippingModalAddNew"
                                                    class="btn create-btn"
                                                    >Add to Shipment</a
                                                >
                                                
                                            </div>
                                            
                                            <!-- <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
                                                <form
                                                    @submit.prevent="handleSubmit(submitSearchShipment)"
                                                    enctype="multipart/form-data"
                                                >
                                                <div class="invoiceBox">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div
                                                            class="formSection"
                                                        >
                                                            
                                                            <div class="row">
                                                                <div class="col-lg-4">
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Shipment Number</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                       v-model="searchShipment.shipment_number"
                                                                    />
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div class="col-lg-4">
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Order Number</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="searchShipment.order_number"
                                                                    />
                                                                </div>
                                                            </div>
                                                            </div>
                                                            
                                                        <div class="col-lg-4">
                                                            <div
                                                                class="form-group"
                                                            >
                                                                 <label
                                                                    class="invgroupLeft"
                                                                    >&nbsp;</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                               
                                                                    <button type="submit" class="btn create-btn ">Search Shipment</button>
                                                                </div>
                                                            </div>
                                                            
                                                            
                                                        </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                
                                                    
                                                </form>
                                                </ValidationObserver>

                                                <OrderShipmentsOthers 
                                                    :orderShipmentSearch="orderShipmentSearch"
                                                    :companyWarehouse="companyWarehouse"
                                                    :customerWarehouse="customerWarehouse"
                                                    :order="order.order"
                                                    :po="order"
                                                    :loading="loading"
                                                    :shipping="shipping"
                                                    :carriers="carriersState"
                                                    @addedEvent="shippingAddedEvent"
                                                    @updatedEvent="shippingUpdatedEvent"

                                                    
                                                ></OrderShipmentsOthers> -->
                                                
                                                
                                        </div>
                                        <div class="tab-pane fade" id="tabs4">
                                            <div class="invoiceBox">
                                                <div
                                                    class="radioSec bg-light p-3 mb-3"
                                                >
                                                    <div class="radioSec">
                                                        <div class="form-check">
                                                            <label
                                                                class="form-check-label"
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    class="form-check-input"
                                                                    value="Y"
                                                                    v-model="
                                                                        order.flag_pre_deposit
                                                                    "
                                                                    name="optradio"
                                                                />Pre-Deposit
                                                                required to
                                                                start work
                                                            </label>
                                                        </div>
                                                        <div class="form-check">
                                                            <label
                                                                class="form-check-label"
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    class="form-check-input"
                                                                    value="N"
                                                                    v-model="
                                                                        order.flag_pre_deposit
                                                                    "
                                                                    name="optradio"
                                                                />Pre-Deposit
                                                                doesnt NOT
                                                                required to
                                                                start work
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <h3>Pre-Deposit Details</h3>
                                                <div class="row">
                                                    <div class="col-lg-8">
                                                        <div
                                                            class="formSection"
                                                        >
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Pre-Deposit
                                                                    Percentage</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.percentage
                                                                        "
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Pre-Deposit
                                                                    Amount</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.amount
                                                                        "
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Pre-Deposit
                                                                    Paid</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <select
                                                                        class="form-control"
                                                                        v-model="
                                                                            customerPayment.status
                                                                        "
                                                                    >
                                                                        <option>
                                                                            Select
                                                                        </option>
                                                                        <option
                                                                            value="Yes"
                                                                        >
                                                                            Yes
                                                                        </option>
                                                                        <option
                                                                            value="No"
                                                                        >
                                                                            No
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Pre-Deposit
                                                                    Date</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                >
                                                                    <input
                                                                        type="date"
                                                                        class="form-control"
                                                                        placeholder=""
                                                                        v-model="
                                                                            customerPayment.payment_date
                                                                        "
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    class="invgroupLeft"
                                                                    >Proof of
                                                                    pre-deposit</label
                                                                >
                                                                <div
                                                                    class="invgroupRight"
                                                                    style="
                                                                        max-width: 200px;
                                                                        max-height: 200px;
                                                                    "
                                                                >
                                                                    <!--<div class="file-attachment-wrapper">
                                                                        <label for="file-yZqVjS" class="relative invoice-upbtn block leading-tight bg-white hover:bg-gray-100 cursor-pointer inline-flex items-center transition duration-500 ease-in-out group overflow-hidden border-2 w-full rounded-lg border-dashed" wire:loading.class="pointer-events-none" :class="{ 'border-indigo-300': isFocused === true }">

                                                                            <input type="hidden" name="placeholder1" v-model="placeholder1" value="">

                                                                            <input type="file" id="file-yZqVjS" class="absolute inset-0 cursor-pointer opacity-0 text-transparent sr-only" accept="image/jpg,image/jpeg,image/png,application/pdf" :multiple="isMultiple" x-ref="input" x-on:change.prevent="handleFiles" x-on:focus="isFocused = true" x-on:blur="isFocused = false">


                                                                            <div wire:loading.flex="" wire:target="placeholder1" wire:loading.class="w-full">

                                                                                <div class="text-center flex-1 p-1">
                                                                                    <div class="upload-btn">Uploading...</div>
                                                                                    <div>
                                                                                        <div class="h-3 relative max-w-lg mx-auto rounded-full overflow-hidden">
                                                                                            <div class="w-full h-full bg-gray-200 absolute"></div>
                                                                                            <div class="h-full bg-green-500 absolute" x-bind:style="'width:' + progress + '%'" style="width:0%"></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="flex items-center justify-center flex-1" wire:loading.class="hidden" wire:target="placeholder1">
                                                                                <svg class="h-8 w-8 text-gray-300 group-hover:text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"></rect><path d="M168.001,100.00017v.00341a12.00175,12.00175,0,1,1,0-.00341ZM232,56V200a16.01835,16.01835,0,0,1-16,16H40a16.01835,16.01835,0,0,1-16-16V56A16.01835,16.01835,0,0,1,40,40H216A16.01835,16.01835,0,0,1,232,56Zm-15.9917,108.6936L216,56H40v92.68575L76.68652,112.0002a16.01892,16.01892,0,0,1,22.62793,0L144.001,156.68685l20.68554-20.68658a16.01891,16.01891,0,0,1,22.62793,0Z"></path></svg>

                                                                                <span class="text-gray-600">Add File  </span>
                                                                            </div>
                                                                        </label>


                                                                        <div wire:loading.delay="" wire:loading.flex="" wire:target="removeUpload" wire:loading.class="w-full">
                                                                            <div class="text-sm remove-file bg-red-100 flex-1 text-center rounded">
                                                                                Removing file...
                                                                            </div>
                                                                        </div>


                                                                        <div>
                                                                        </div>
                                                                    </div>-->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="invoiceDetails">
                                                    <h3>Invoice Details</h3>
                                                    <table
                                                        class="table table-bordered table-hover mb-0"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Customer
                                                                    Invoice#
                                                                </th>
                                                                <th>Date</th>
                                                                <th>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody></tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="tabs5">
                                            <div class="invoiceBox">
                                                <div class="invoiceDetails">
                                                    <table
                                                        class="table table-bordered table-hover mb-0"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>SO #</th>
                                                                <th>Created</th>
                                                                <th>Status</th>
                                                                <th>
                                                                    Customer
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody
                                                            v-if="order.order"
                                                        >
                                                            <tr>
                                                                <td>
                                                                    <router-link
                                                                        :to="{
                                                                            name: 'orderShow',
                                                                            params: {
                                                                                id: order
                                                                                    .order
                                                                                    .id,
                                                                            },
                                                                        }"
                                                                        target="_blank"
                                                                    >
                                                                        #{{
                                                                            order
                                                                                .order
                                                                                .order_number
                                                                        }}
                                                                    </router-link>
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        order
                                                                            .order
                                                                            .order_date
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        order
                                                                            .order
                                                                            .order_status
                                                                            ? order
                                                                                  .order
                                                                                  .order_status
                                                                                  .name
                                                                            : ""
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <p>
                                                                        <strong
                                                                            >Customer
                                                                            Name
                                                                            :
                                                                            <router-link
                                                                                v-if="
                                                                                    order
                                                                                        .order
                                                                                        .customer
                                                                                "
                                                                                :to="{
                                                                                    name: 'customerDetails',
                                                                                    params: {
                                                                                        id: order
                                                                                            .order
                                                                                            .customer
                                                                                            .id,
                                                                                    },
                                                                                }"
                                                                                target="_blank"
                                                                                title="Details Customer"
                                                                            >
                                                                                {{
                                                                                    order
                                                                                        .order
                                                                                        .customer
                                                                                        .company_name
                                                                                }}</router-link
                                                                            >
                                                                        </strong>
                                                                    </p>
                                                                    <p>
                                                                        Address
                                                                        :
                                                                        {{
                                                                            order
                                                                                .order
                                                                                .customer
                                                                                ? order
                                                                                      .order
                                                                                      .customer
                                                                                      .address
                                                                                : ""
                                                                        }}
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-3 col-md-3 col-xxl-2">
                            <div class="rightcolumn-custom">
                                <div class="card">
                                    <div class="right-header2">
                                        <div class="card-header">
                                            <h5
                                                class="card-title flex-grow-1 mb-0"
                                            >
                                                Customer
                                            </h5>
                                        </div>
                                        <!--<div class="searchSec">
                                            <div class="input-group">
                                                <input type="text" class="form-control" placeholder="Search" v-model="customerSearch">
                                                <div class="input-group-btn">
                                                    <button class="btn btn-default" type="button">
                                                        <i class="fa fa-search" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>-->
                                        <div class="card-body2">
                                            <div class="list-containerbox">
                                                <div class="listDetails">
                                                    <ul
                                                        v-if="
                                                            order.order !==
                                                                null &&
                                                            order.order.customer
                                                        "
                                                    >
                                                        <li>
                                                            <strong
                                                                >Company: </strong
                                                            ><router-link
                                                                :to="{
                                                                    name: 'customerDetails',
                                                                    params: {
                                                                        id: order
                                                                            .order
                                                                            .customer
                                                                            .id,
                                                                    },
                                                                }"
                                                                target="_blank"
                                                                title="Details Customer"
                                                                >{{
                                                                    order.order
                                                                        .customer
                                                                        .company_name
                                                                }}</router-link
                                                            >
                                                        </li>
                                                        <li>
                                                            <strong
                                                                >Contact Name:
                                                            </strong>
                                                            {{
                                                                order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length
                                                                    ? order
                                                                          .order
                                                                          .customer
                                                                          .customer_contacts[0]
                                                                          .contact_name
                                                                    : ""
                                                            }}
                                                        </li>
                                                        <li>
                                                            <strong
                                                                >Contact Email:
                                                            </strong>
                                                            {{
                                                                order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length
                                                                    ? order
                                                                          .order
                                                                          .customer
                                                                          .customer_contacts[0]
                                                                          .email
                                                                    : ""
                                                            }}
                                                        </li>
                                                        <li>
                                                            <strong
                                                                >Contact Phone:
                                                            </strong>
                                                            {{
                                                                order.order
                                                                    .customer
                                                                    .customer_contacts
                                                                    .length
                                                                    ? order
                                                                          .order
                                                                          .customer
                                                                          .customer_contacts[0]
                                                                          .contact_no
                                                                    : ""
                                                            }}
                                                        </li>
                                                        <li>
                                                            <strong
                                                                >Address:
                                                            </strong>
                                                            {{
                                                                order.order
                                                                    .customer
                                                                    .address
                                                            }}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--<a href="javascript:void(0)" class="newBtn" v-on:click="goToCreateCustomer"> New Customer</a>-->

                                    <div class="shiping-details">
                                        <OrderShipping
                                            :order="order.order"
                                            :is-edit-mode="isEditMode"
                                            :loading="loading"
                                        ></OrderShipping>
                                        <!--<div class="shiping-body">
                                                <h5 class="card-title flex-grow-1">Ship To</h5>
                                            <div class="listDetails">
                                                <div v-if="isEditMode" class="searchSec">
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" placeholder="Search"
                                                            @focus="findShippingAddress()" v-model="shipSearch">
                                                        <div class="input-group-btn">
                                                            <button class="btn btn-default" type="submit">
                                                                <i class="fa fa-search" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="listDetails">

                                                </div>
                                                <a v-if="isEditMode" href="javascript:void(0)" data-toggle="modal"
                                                data-target="#newShipModal" class="newBtn"> New Shipping</a>
                                            </div>
                                        </div>-->
                                    </div>

                                    <!-- <div class="address-list">
                                        <div class="shiping-details">
                                            <div class="shiping-body">
                                                <h5
                                                    class="card-title flex-grow-1"
                                                >
                                                    Vendor
                                                </h5>

                                                <div class="listDetails">
                                                    <ul
                                                        v-if="
                                                            order.vendor !==
                                                            null
                                                        "
                                                    >
                                                        <li>
                                                            <strong
                                                                >Company: </strong
                                                            ><router-link
                                                                :to="{
                                                                    name: 'vendorDetails',
                                                                    params: {
                                                                        id: order
                                                                            .vendor
                                                                            .id,
                                                                    },
                                                                }"
                                                                target="_blank"
                                                                >{{
                                                                    order.vendor
                                                                        .company_name
                                                                }}</router-link
                                                            >
                                                        </li>
                                                        <li>
                                                            <strong
                                                                >Contact Name:
                                                            </strong>
                                                            {{
                                                                order.vendor
                                                                    .contacts
                                                                    .length
                                                                    ? order
                                                                          .vendor
                                                                          .contacts[0]
                                                                          .contact_name
                                                                    : ""
                                                            }}
                                                        </li>
                                                        <li>
                                                            <strong
                                                                >Contact Email:
                                                            </strong>
                                                            {{
                                                                order.vendor
                                                                    .contacts
                                                                    .length
                                                                    ? order
                                                                          .vendor
                                                                          .contacts[0]
                                                                          .email
                                                                    : ""
                                                            }}
                                                        </li>
                                                        <li>
                                                            <strong
                                                                >Contact Phone:
                                                            </strong>
                                                            {{
                                                                order.vendor
                                                                    .contacts
                                                                    .length
                                                                    ? order
                                                                          .vendor
                                                                          .contacts[0]
                                                                          .contact_no
                                                                    : ""
                                                            }}
                                                        </li>
                                                        <li>
                                                            <strong
                                                                >Address:
                                                            </strong>
                                                            {{
                                                                order.vendor
                                                                    .address
                                                            }}
                                                        </li>
                                                    </ul>
                                                </div>

                                                
                                                <a
                                                    v-if="isEditMode"
                                                    href="javascript:void(0)"
                                                    data-toggle="modal"
                                                    data-target="#vendorAddModal"
                                                    class="newBtn"
                                                    >New Vendor</a
                                                >
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="card" v-if="isEditMode">
                                    <div class="right-header">
                                        <div class="right-header2">
                                            <div class="card-header">
                                                <div class="d-flex">
                                                    <h5
                                                        class="card-title flex-grow-1 mb-0"
                                                    >
                                                        Artwork/Deposit/Sample
                                                        Required?
                                                    </h5>

                                                    <div class="cpreder"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body2">
                                            <div class="list-containerbox">
                                                <div class="form-group">
                                                    <div class="form-check">
                                                        <input
                                                            v-model="
                                                                order.is_deposit_required
                                                            "
                                                            name="is_deposit_required"
                                                            type="checkbox"
                                                            class="form-check-input"
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            >Is deposit
                                                            required?</label
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <OrderTask
                                    :order="order"
                                    :loading="loading"
                                    :task-type="'po'"
                                    :bus="bus"
                                    @openTaskEditEvent="openTaskEditEvent"
                                    @sendPOToVendorEvent="sendPOToVendorEvent"
                                    @editModeEvent="changeEditMode(true)"
                                    @artworkSampleRequiredEvent="
                                        artworkSampleRequiredEvent()
                                    "
                                    @updatedTaskEvent="updatedTaskEvent"
                                    @depositSentEvent="depositSent"
                                    @openCheckAirFreightEvent="
                                        openCheckAirFreight
                                    "
                                    @openGetAReadyDateEvent="
                                        openGetAReadyDateEvent
                                    "
                                ></OrderTask>
                            </div>
                            <div class="card">
                                <div class="right-header">
                                    <div class="right-header2">
                                        <div class="card-header">
                                            <div class="d-flex">
                                                <h5
                                                    class="card-title flex-grow-1 mb-0"
                                                >
                                                    Label
                                                </h5>

                                                <div class="cpreder"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body2">
                                        <div class="form-group">
                                            <div
                                                class="blockquotenew custom-blockquote blockquote-info rounded mb-0 adm"
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                >
                                                    <div class="edit-section">
                                                        <a
                                                            class="fs-17 text-success"
                                                            href="javascript:void(0)"
                                                            v-on:click="
                                                                isEditLabelSection = true
                                                            "
                                                            ><i
                                                                class="ri-edit-box-line align-middle"
                                                            ></i
                                                        ></a>
                                                    </div>

                                                    <div
                                                        class="blockquote-ft mt-0 fs-14 fw-medium"
                                                    >
                                                        <span
                                                            class="quotation-col"
                                                            v-if="order.labels"
                                                        >
                                                            <!--<span :style="'color:' + label.color" v-for="(label, index) in order.labels.sort((a,b) => b.priority - a.priority)">{{label.name}}</span>-->
                                                            <span
                                                                :style="
                                                                    'color:' +
                                                                    label.color
                                                                "
                                                                v-for="(
                                                                    label, index
                                                                ) in order.labels"
                                                                >{{
                                                                    label.name
                                                                }}
                                                                &nbsp;</span
                                                            >
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                class="edit-quote"
                                                v-if="isEditLabelSection"
                                            >
                                                <div class="form-group">
                                                    <select
                                                        class="form-control"
                                                        v-model="newLabelId"
                                                        multiple="true"
                                                    >
                                                        <option
                                                            v-for="item in labels"
                                                            :value="item.id"
                                                        >
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="mt-2">
                                                    <button
                                                        type="button"
                                                        @click="saveLabelData"
                                                        :disabled="
                                                            newLabelId == null
                                                        "
                                                        class="btn btn-primary"
                                                    >
                                                        Save
                                                    </button>
                                                    <a
                                                        href="javascript:void(0);"
                                                        v-on:click="
                                                            isEditLabelSection = false
                                                        "
                                                        class="btn btn-danger"
                                                        >Close</a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btnrow text-right mb-2">
                        <!--<a v-if="isEditMode" href="javascript:void(0)" v-on:click="saveOrder($event)"
                            class="btn custom-btn ml-3" :class="[loading ? 'disabled':'']">Save</a>-->

                        <button
                            v-if="isEditMode"
                            type="submit"
                            :disabled="loading"
                            class="btn btn-success ml-1"
                        >
                            Save
                        </button>
                        <button
                            v-if="isEditMode"
                            type="button"
                            :disabled="loading"
                            class="btn custom-btn ml-1"
                            @click="
                                isEditMode = false;
                                getOrder();
                            "
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </ValidationObserver>
        </template>

        <!-- The Modal -->
        <div class="modal fade custom-right-modal" id="notesModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title card-title">Add Note</h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <form>
                            <div v-if="noteMessage">
                                <div class="alert alert-success">
                                    {{ noteMessage }}
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="exampleFormControlInput1"
                                    >Description</label
                                >
                                <textarea
                                    row="15"
                                    class="form-control"
                                    id="exampleFormControlInput1"
                                    placeholder=""
                                    v-model="order_note"
                                ></textarea>
                            </div>
                            <button
                                type="button"
                                :class="[loading ? 'disabled' : '']"
                                v-on:click="saveOrderNote()"
                                class="btn btn-primary close-modal"
                            >
                                Save
                            </button>
                        </form>
                        <hr />
                        
                        <div class="new-noteAdd" v-if="order.order_notes">
                            <div
                                class="task-bg"
                                v-for="(note, index) in order.order_notes"
                            >

                            <div class="card card-height-100 border mb-2">
                                        <div class="card-body">
                                            <div class="d-flex flex-column h-100">
                                                <p class="text-truncate-two-lines mb-2">{{ note.description }}</p>
                                                <p class="text-muted text-truncate-two-lines mb-0">
                                                <i class="ri-calendar-event-fill me-1 align-bottom"></i> {{ note.created_at }}</p>
                                            </div>

                                        </div>
                                        <!-- end card body -->
                                        <div class="card-footer bg-transparent border-top-dashed py-2">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1">
                                                    <div class="avatar-group">
                                                        <a href="javascript: void(0);" class="avatar-group-item"
                                                            data-bs-toggle="tooltip" data-bs-trigger="hover"
                                                            data-bs-placement="top" title="Darline Williams">
                                                            <div class="avatar-xxs">
                                                                <img src="assets/images/users/avatar-3.jpg" alt=""
                                                                    class="rounded-circle img-fluid">
                                                            </div>
                                                        </a> <span class="pt-1 ps-1 fw-medium">{{note.added_by? note.added_by.name: ""}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-shrink-0">
                                                    <a style="font-size: 18px"  href="javascript:void(0)" @click="edit_id = note.id"><i class="ri-edit-box-line me-1"></i></a>
                                                    <a  href="javascript:void(0)" @click="deleteNote(note.id)" class="text-danger" style="font-size: 18px"><i class="ri-delete-bin-6-line"></i></a>
                                                </div>

                                            </div>

                                        </div>
                                        <!-- end card footer -->
                                    </div>
                                    
                                

                                
                            </div>
                            <div
                                v-if="order.order_notes.length == 0"
                                class="modal-body note-no"
                            >
                                <center>No Note found</center>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>

        <div class="modal fade custom-right-modal" id="actionLogModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">History</h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="history-d" v-if="order.histories">
                            <div
                                class="task-bg"
                                v-for="(history, index) in order.histories"
                            >
                                <div class="small-heading">
                                    {{strip_html_tags(history.details)}}
                                </div>
                                <div class="small-heading">
                                    {{strip_html_tags(history.comments)}}
                                </div>
                                <!-- <span class="pull-right lght-clr">{{ history.created_at_date }}
                                    {{ history.created_at_time }}</span> -->
                                <!-- <div class="row">
                                    <div class="col-md-12">
                                        <div class="light-clr">
                                            Created By
                                            {{
                                                history.added_by
                                                    ? history.added_by.name
                                                    : ""
                                            }}
                                        </div>
                                    </div>
                                </div> -->

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="light-clr">Created By</div>
                                        <p class="number">{{
                                                history.added_by
                                                    ? history.added_by.name
                                                    : ""
                                            }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="light-clr">Updated Time</div>
                                        <p class="number">{{ history.created_at_date }}
                                    {{ history.created_at_time }}</p>
                                    </div>
                                </div>

                            </div>
                            <div
                                v-if="order.histories.length == 0"
                                class="modal-body note-no"
                            >
                                <center>No records found</center>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="dateHistoriesModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="new-noteAdd" v-if="order.date_histories">
                            <div
                                class="task-bg"
                                v-for="(history, index) in order.date_histories"
                            >
                                <div class="small-heading">
                                    On {{ formatDate(history.updated_at) }}
                                    {{
                                        history.added_by
                                            ? history.added_by.name
                                            : ""
                                    }}
                                    changed date from
                                    {{ formatDate(history.old_date_value) }} to
                                    {{ formatDate(history.date_value) }}.
                                </div>
                                <div class="small-heading">
                                    Reason: {{ history.reason }}
                                </div>
                            </div>
                            <div
                                v-if="order.date_histories.length == 0"
                                class="modal-body note-no"
                            >
                                <center>No records found</center>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
        <SendPurchaseOrderToVendor
            :order="order"
            @sentPurchaseOrderToVendor="sentPurchaseOrderToVendor"
        ></SendPurchaseOrderToVendor>

        <PurchaseOrderDiscountModal
            :order="order"
            :sub_total_cost="sub_total_cost"
            @discountUpdated="discountUpdated"
        ></PurchaseOrderDiscountModal>
        <PurchaseOrderExtraChargeModal
            :order="order"
            :sub_total_cost="sub_total_cost"
            :charge="charge"
            :bus="bus"
            ref="orderExtraCharge"
            @extraChargeUpdated="extraChargeUpdated"
        ></PurchaseOrderExtraChargeModal>

        <ProductArtworksModal
            :order="order.order"
            :product="product ? product.order_product : null"
            :artwork_statuses="artwork_statuses"
            @productArtworksUpdated="productArtworksUpdated"
            @openSendArtworkToCustomer="openSendArtworkToCustomer"
            @imagePreview="imagePreview"
            @openViewComments="viewComments"
            @openSendArtworkToVendor="openSendArtworkToVendor"
        ></ProductArtworksModal>

        <SendProductArtworkToCustomer
            :order="order.order"
            :product="product ? product.order_product : null"
            :artwork="artwork"
            :is_one_artwork_for_all="is_one_artwork_for_all"
            :po="order"
            @sendProductArtworkToCustomerEvent="vendorEmailSentEvent"
        ></SendProductArtworkToCustomer>
        <ProductArtworkVersionsModal
            :order="order.order"
            :product="product ? product.order_product : null"
            @imagePreview="imagePreview"
        ></ProductArtworkVersionsModal>
        <AllProductsArtworkVersionsModal
            :order="order.order"
        ></AllProductsArtworkVersionsModal>

        <ArtworkCommentModal
            :order="order.order"
            :artwork="targetArtwork"
            :is_edit="false"
        ></ArtworkCommentModal>

        <SendProductArtworkToVendor
            :order="order.order"
            :product="product ? product.order_product : null"
            :artwork="artwork"
            :po="order"
            :is_one_artwork_for_all="is_one_artwork_for_all"
            @vendorEmailSentEvent="vendorEmailSentEvent"
        ></SendProductArtworkToVendor>

        <LightBox
            :media="previewMedia"
            :showLightBox="false"
            :showThumbs="false"
            ref="lightbox"
        ></LightBox>
        <AddTask
            :task="task"
            :bus="bus"
            @addedEvent="taskAddedEvent"
            @updatedEvent="taskUpdatedEvent"
            @completedEvent="completedEvent"
        ></AddTask>

        <AddShippingModal
            :companyWarehouse="companyWarehouse"
            :customerWarehouse="customerWarehouse"
            :order="order.order"
            :po="order"
            :loading="loading"
            :shipping="shipping"
            :carriers="carriersState"
            @addedEvent="shippingAddedEvent"
            @updatedEvent="shippingUpdatedEvent"
        ></AddShippingModal>

        <AddShippingModalNew
            :companyWarehouse="companyWarehouse"
            :customerWarehouse="customerWarehouse"
            :order="order.order"
            :po="order"
            :loading="loading"
            :shipping="shipping"
            :carriers="carriersState"
            
        ></AddShippingModalNew>

        <footer class="footer">
            <div class="dropzone-previews custom-dropzone-preview"></div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">2022 © Superb.</div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <VendorAddModal @vendorDataSaved="vendorDataSaved"></VendorAddModal>
        <OrderDatesModal
            :task="task"
            :order="order"
            :orderType="'po'"
            :dateType="dateType"
            @orderDateUpdated="orderDateUpdated"
        ></OrderDatesModal>
        <CheckAirFreightModal
            :task="task"
            :order="order.order"
            :po="order"
            @checkAirFreightUpdated="checkAirFreightUpdated"
        ></CheckAirFreightModal>

        <!-- Label Popup -->

            <!-- Edit Label Modal -->
                <div class="modal fade" id="editLabelModal" tabindex="-1" aria-labelledby="editLabelModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editLabelModalLabel">Edit Label</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                            </div>
                            <div class="modal-body form-steps">
                                <div class="mb-3">

                                    <select
                                        class="form-select"
                                        v-model="newLabelId"
                                        multiple="true"
                                    >
                                        <option
                                            v-for="item in labels"
                                            :value="item.id"
                                        >
                                            {{ item.name }}
                                        </option>
                                    </select>

                                    
                                </div>

                                <div class="mt-3 text-end">
                                    <button class="btn btn-primary me-1 w-md"
                                    @click="saveLabelData"
                                    :disabled="newLabelId == null"
                                    >Save
                                    </button>
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Edit Label Modal -->
                
        <!-- Label Popup Ends Here  -->

        <!-- Edit Consumer Modal -->
                <div class="modal fade" id="editConsumerModal" tabindex="-1" aria-labelledby="editConsumerModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editConsumerModalLabel">Edit Consumer</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                            </div>
                            <div class="modal-body form-steps">
                                <select class="form-select choose-edit-address address-type">
                                    <option value="amazon">Amazon</option>
                                    <option value="flipkart">Flipkart</option>
                                    <option value="custom">Custom</option>
                                </select>
                                <textarea class="form-control append-edit-address mt-2" style="height: 140px">Superb Packaging
John Doe
123 Main St
Monroe NY 10950
845-783-4351
Email@email.com</textarea>

                                <div class="mt-3 text-end">
                                    <button class="btn btn-primary me-1 w-md">Save</button>
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Edit Customer Modal -->

        <div class="modal fade" id="editSalesOrderDetailsModal" tabindex="-1" aria-labelledby="editSalesOrderDetailsModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content border-0">
                            <div class="modal-header p-3 bg-soft-info">
                                <h5 class="modal-title" id="editSalesOrderDetailsModalLabel">Edit Purchase Order Details</h5>
                                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                                
                            </div>
                            <div class="modal-body form-steps">
                            <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
                            <form
                                @submit.prevent="handleSubmit(submitHandler)"
                                enctype="multipart/form-data"
                            >

                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label>Status</label>
                                        <div>
                                        <select
                                            class="form-select"
                                            v-model="
                                                order.po_status_id
                                            "
                                        >
                                            <option
                                                :value="null"
                                            >
                                                Select
                                            </option>
                                            <option
                                                v-for="(
                                                    status,
                                                    index
                                                ) in statuses"
                                                :value="
                                                    status.id
                                                "
                                            >
                                                {{
                                                    status.name
                                                }}
                                            </option>
                                        </select>

                                            <!-- <select class="form-select">
                                                <option selected>Select</option>
                                                <option value="1">Open</option>
                                                <option value="2">Sent to Vendor</option>
                                                <option value="3">Cancelled</option>
                                            </select> -->
                                        </div>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>PO Number</label>
                                        <input type="" v-model="order.po_number" name="" class="form-control" >
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>PO Date</label>
                                        <date-picker 
                                                        v-model="
                                                            order.order_date
                                                        "
                                                        format="MM/DD/YYYY"
                                                        valueType="format"
                                                    ></date-picker>
                                        
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Customer PO</label>
                                        <input type="" v-model="order.vendor_po" name="" class="form-control">
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Vendor Terms</label>
                                        <input type="" v-model="order.vendor_terms" name="" class="form-control" >
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Factory Ready Date</label>
                                        <date-picker
                                                        v-model="order.eta"
                                                        format="MM/DD/YYYY"
                                                        valueType="format"
                                                    ></date-picker>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>FOB</label>
                                        <input type="" v-model="order.vendor_fob" name="" class="form-control" >
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label>Added By</label>
                                        <div>
                                        <select
                                                    class="form-select"
                                                    v-model="
                                                        order.new_admin_users
                                                    "
                                                   
                                                >
                                                    <option
                                                        v-for="item in admin_users"
                                                        :value="item.id"
                                                    >
                                                        {{ item.name }}
                                                    </option>
                                                </select>

                                            <!-- <select class="form-select">
                                                <option>Devid John</option>
                                                <option>Milky Glick</option>
                                                <option>Rathindra</option>
                                            </select> -->
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-3 text-end">
                                    <button class="btn btn-primary me-1 w-md" type="submit">Save</button>
                                    
                                    <button class="btn btn-danger" data-dismiss="modal" aria-label="Close">Cancel</button>
                                </div>

                                </form>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>

    </div>


    
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ProductArtworksModal from "../../components/ProductArtworksModal";
import OrderExtraChargeModal from "../../components/OrderExtraChargeModal";
import Vue from "vue";
import {
    ValidationProvider,
    ValidationObserver,
    extend,
    configure,
} from "vee-validate";
import LightBox from "vue-it-bigger";
import PurchaseOrderDiscountModal from "../../components/PurchaseOrderDiscountModal";
import PurchaseOrderExtraChargeModal from "../../components/PurchaseOrderExtraChargeModal";
import SendPurchaseOrderToVendor from "../../components/SendPurchaseOrderToVendor";
import SendProductArtworkToCustomer from "../../components/SendProductArtworkToCustomer";
import ProductArtworkVersionsModal from "../../components/ProductArtworkVersionsModal";
import VendorAddModal from "../../components/VendorAddModal";
import AllProductsArtworkVersionsModal from "../../components/AllProductsArtworkVersionsModal";
import ArtworkCommentModal from "../../components/ArtworkCommentModal";
import SendProductArtworkToVendor from "../../components/SendProductArtworkToVendor";
import OrderTask from "../../components/OrderTask";
import OrderTaskNew from "../../components/OrderTaskNew";
import AddTask from "../../components/AddTask";
import OrderShipping from "../../components/OrderShipping";

import OrderShippingNew from "../../components/OrderShippingNew";

import AddShippingModal from "../../components/AddShippingModal";

import AddShippingModalNew from "../../components/AddShippingModalAddNew";

import OrderShipments from "../../components/OrderShipments";
import OrderShipmentsNew from "../../components/OrderShipmentsNew";
import OrderShipmentData from "../../components/OrderShipmentData";
import OrderDatesModal from "../../components/OrderDatesModal";
import CheckAirFreightModal from "../../components/CheckAirFreightModal";
import OrderShipmentsOthers from "../../components/OrderShipmentsOthers";
import { VueEditor } from "vue2-editor";

configure({
    classes: {
        valid: "is-valid",
        invalid: "is-invalid",
        dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
        // ...
    },
});

extend("positive", (value) => {
    if (value >= 0) {
        return true;
    }

    return "This field must be a positive number";
});

export default {
    name: "PurchaseOrderShow",
    components: {
        OrderShipmentData,
        DatePicker,
        vueDropzone: vue2Dropzone,
        ProductArtworksModal,
        ValidationObserver,
        ValidationProvider,
        PurchaseOrderDiscountModal,
        PurchaseOrderExtraChargeModal,
        SendPurchaseOrderToVendor,
        SendProductArtworkToCustomer,
        ProductArtworkVersionsModal,
        LightBox,
        VendorAddModal,
        AllProductsArtworkVersionsModal,
        ArtworkCommentModal,
        SendProductArtworkToVendor,
        OrderTask,
        OrderTaskNew,
        AddTask,
        OrderShipping,
        OrderShippingNew,
        AddShippingModal,
        AddShippingModalNew,
        OrderShipments,
        OrderShipmentsNew,
        OrderDatesModal,
        CheckAirFreightModal,
        OrderShipmentsOthers,
        VueEditor
    },
    created() {
        this.getOrderStatuses();
        this.getQuantityUnits();
        this.getOrder();
        
        
    },
    updated(){
        if(this.shipmentBackProduct == true){
            $('.nav a[href="#arrow-ship"]').tab('show');
            console.log("shipmentBackProduct",this.shipmentBackProduct)
            this.backShipmentState(false);
        }
    },
    mounted() {
        let self = this;
        this.getDueTasks();
        this.getShippings();
        $("#addTaskModal").on("hidden.bs.modal", function () {
            self.task = null;
        });
    },
    data() {
        return {
            hideHtml:true,
            showallArtwork:false,
            changeUnitQuantity:null,
            searchShipment:{
                shipment_number:null,
                order_number:null
            },
            orderShipmentSearch:[],
            companyWarehouse:[],
            customerWarehouse:[],
            shipmentDetails: [],
            showShimpment: false,
            shipmentId: null,
            bus: new Vue(),
            task: null,
            order: null,
            product: null,
            artwork: null,
            charge: null,
            isEditMode: false,
            statuses: [],
            salesReps: [],
            quantityUnits: [],
            vendorSearch: null,
            shipSearch: null,
            customerSearch: null,
            customerPayment: {
                payment_date: null,
                status: null,
                amount: null,
                percentage: null,
            },
            attachments: [],
            customerAttachments: [],
            submitted: false,
            sub_total_cost: 0,
            dropzoneOptions: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            dropzoneOptionsArtwork: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                acceptedFiles: "image/*,application/pdf",
                disablePreviews: true,
                previewsContainer: ".custom-dropzone-preview",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            dropzoneOptionsOriginalFile: {
                url: window.route("medias.store"),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                disablePreviews: true,
                previewsContainer: ".custom-dropzone-preview",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "X-CSRF-TOKEN":
                        document.head.querySelector("[name=csrf-token]")
                            .content,
                },
            },
            noteMessage: null,
            order_note: null,
            purchase_orders: [],
            editorConfig: {},
            editorConfigMin: {
                toolbar: [
                    //["Source", "-", "Bold", "Italic"],
                    //["Styles", "Format", "Font", "FontSize"],
                ],
            },
            artwork_statuses: [],
            quotations: [],
            previewMedia: [],
            productExtendedView: false,
            eachProductsHasArtwork: false,
            is_one_artwork_for_all: false,
            isChangeStatusForAllArtworks: true,
            targetArtwork: null,
            admin_users: [],
            dueTasks: [],
            shipping: null,
            shippingProducts: null,
            shippingProductDetailId: null,
            dateType: null,
            validationErrors: null,
            isEditLabelSection: false,
            newLabelId: [],
            labels: [],
        };
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
            "setNewPurchaseOrder",
            "backShipmentState"
        ]),

        getTotalShippingQty (product) {
            if (!product || !product.shippings) {
            return 0
            }

            return product.shippings.reduce((total, shipping) => {
            return total + (shipping.pivot ? Number(shipping.pivot.quantity) : 0)
            }, 0)
        },

        getFileIconForAttachment(attachment) {
            // ri-folder-zip-line, ri-file-ppt-2-line, bx bxs-file-pdf, bx bxs-file-doc, bx bx-image-alt
            //console.log(attachment.file_name.toLowerCase())
            if(attachment.attach_link.toLowerCase().includes(".pdf")) {
                return 'fas fa-file-pdf';
            } else if(attachment.attach_link.toLowerCase().includes(".doc")) {
                return 'fas fa-file-word';
            } else if(attachment.attach_link.toLowerCase().includes(".docx")) {
                return 'fas fa-file-word';
            } else if(attachment.attach_link.toLowerCase().includes(".xlx")) {
                return 'fas fa-file-word';
            } else if(attachment.attach_link.toLowerCase().includes(".xlsx")) {
                return 'fas fa-file-word';
            } else if(attachment.attach_link.toLowerCase().includes(".ppt")) {
                return 'ri-file-ppt-2-line';
            } else if(attachment.attach_link.toLowerCase().includes(".pptx")) {
                return 'ri-file-ppt-2-line';
            } else if(attachment.attach_link.toLowerCase().includes(".zip") || attachment.attach_link.toLowerCase().includes(".rar") ||
                attachment.attach_link.toLowerCase().includes(".7z") || attachment.attach_link.toLowerCase().includes(".gzip") ||
                attachment.attach_link.toLowerCase().includes(".gz")) {
                return 'ri-folder-zip-line';
            } else {
                return 'fas fa-file-image';
            }
        },

        strip_html_tags(str) {
            // Check if the input string is null or empty
           /* if ((str === null) || (str === '')) {
                // If so, return false
                return str;
            } else {
                // If not, convert the input string to a string type
                str = str.toString();
            }
            // Use a regular expression to replace all HTML tags with an empty string
            return str.replace(/<[^>]*>/g, '');*/

           if (!str) return '';
            const div = document.createElement('div');
            div.innerHTML = str;
            return div.textContent || div.innerText || '';

        },
        showArtwork(val){
            this.showallArtwork = val;
        },
        getQuillToolbar() {
            return [
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }],
            ]
        },
        getShippingDetails() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.getShppingNumberByMbl", {
                        id: this.order.id,
                    }),
                    { mbl_number: this.order.mbl_number },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        console.log("data shiipng number : ", data.data.data);
                        this.shipmentDetails = data.data.data;
                        this.showShimpment = true;
                        this.shipmentId = data.data.data.shipment_id;
                        console.log("this.shipmentId : ", this.shipmentId);

                        // this.setSuccessMessage(
                        //     "Label added to this order successfully!"
                        // );
                        //this.isEditLabelSection = false;
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        submitSearchShipment(){
            console.log("searc data ",this.searchShipment);
            
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("po.all-shipping-list-search",this.searchShipment),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {

                        console.log("data.data",data.data.data);
                       this.orderShipmentSearch = data.data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });

            //alert("dd");
        },
        saveMblNumber() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.addMblNumber", { id: this.order.id }),
                    { mbl_number: this.order.mbl_number },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(
                            "Label added to this order successfully!"
                        );
                        //this.isEditLabelSection = false;
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        saveLabelData() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.addLabel", { id: this.order.id }),
                    { newLabelId: this.newLabelId },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.setSuccessMessage(
                            "Label added to this order successfully!"
                        );
                        this.isEditLabelSection = false;
                        $('#editLabelModal').modal('hide');
                        //this.newLabelId = [];
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        openCreateShipment(mode) {
            this.$refs.shipmentRef.click();

            $("#addShippingModal").modal("show");
        },
        checkAirFreightUpdated() {
            this.task = null;
            this.getDueTasks();
            this.getOrder();
            setTimeout(() => {
                $("#checkAirFreightModal").modal("hide");
            }, 100);
        },
        openCheckAirFreight(task) {
            this.task = _.cloneDeep(task);
            setTimeout(() => {
                $("#checkAirFreightModal").modal("show");
            }, 100);
        },
        orderDateUpdated() {
            this.task = null;
            this.getDueTasks();
            this.getOrder();
            setTimeout(() => {
                $("#orderDatesModal").modal("hide");
            }, 100);
        },
        openGetAReadyDateEvent(event) {
            this.openGetAReadyDate(event.task, event.dateType);
        },
        openGetAReadyDate(task, dateType = "eta") {
            this.task = _.cloneDeep(task);
            this.dateType = dateType;
            setTimeout(() => {
                $("#orderDatesModal").modal("show");
            }, 100);
        },
        shippingAddedEvent(event) {
            this.getShippings();
            this.getDueTasks();
            this.getOrder();
            this.bus.$emit("triggerGetTasks");
            $("#addShippingModal").modal("hide");
        },
        shippingUpdatedEvent(event) {
            this.shipping = null;
            this.getShippings();
            this.getDueTasks();
            this.getOrder();
            this.bus.$emit("triggerGetTasks");
            $("#addShippingModal").modal("hide");
        },
        getShippings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios
                .get(
                    window.route("po.getShippings", {
                        id: this.$route.params.id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.shippingProducts = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        sentPurchaseOrderToVendor() {
            this.getDueTasks();
            this.getOrder();
        },
        depositSent(task) {
            task.deposit_sent_amount = this.order.deposit_sent_amount;
            task.assign_ids = task.admins.map((x) => x.id);
            task.order_id = this.order.id;
            task.order_type = "po";
            task.status = 1;

            let self = this;
            return axios
                .put(
                    window.route("dashboard.tasks.update", { id: task.id }),
                    task,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && Object.keys(data.errors).length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.getOrder();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        completeTask(id) {
            this.bus.$emit("triggerCompleteTask", id);
        },
        completedEvent() {
            this.bus.$emit("triggerGetTasks");
            this.getDueTasks();
        },
        openTaskEditEvent(task) {
            this.task = _.cloneDeep(task);
            setTimeout(() => {
                $("#addTaskModal").modal("show");
            }, 100);
        },
        updatedShippingNewEvent(){
            this.getOrder();
        },
        taskAddedEvent(event) {
            this.bus.$emit("triggerGetTasks");
            $("#addTaskModal").modal("hide");
        },
        taskUpdatedEvent(event) {
            this.task = null;
            this.bus.$emit("triggerGetTasks");
            $("#addTaskModal").modal("hide");
        },
        sendPOToVendorEvent() {
            $("#sendPOToVendorModal").modal("show");
        },
        getDueTasks() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let url = window.route("po.tasks.due", {
                id: this.$route.params.id,
            });

            return axios
                .get(url, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.dueTasks = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        checkIfFirstRow(product, index, artwork, artworkIndex) {
            if (!product.latest_artwork) {
                return artworkIndex == 0;
            }
            let arts = product.artworks.filter(
                (art) =>
                    art.id == null ||
                    (product.latest_artwork &&
                        art.id == product.latest_artwork.id)
            );
            if (arts.length) {
                return arts[0].id != null && artwork.id == arts[0].id;
            }
            return false;
        },
        artworkStatusChangeForAll(event) {
            if (event.target.value) {
                this.order.products.forEach((product, index) => {
                    if (
                        product.latest_artwork &&
                        !this.isChangeStatusForAllArtworks
                    ) {
                        product.artworks
                            .filter(
                                (x) =>
                                    x.id == null ||
                                    x.id == product.latest_artwork.id
                            )
                            .forEach((artwork, artworkIndex) => {
                                artwork.artwork_status_id = event.target.value;
                            });
                    } else {
                        product.artworks.forEach((artwork, artworkIndex) => {
                            artwork.artwork_status_id = event.target.value;
                        });
                    }
                });
            }
        },
        viewComments(artwork) {
            this.targetArtwork = _.cloneDeep(artwork);
            setTimeout(() => {
                $("#artworkCommentModal").modal("show");
            }, 100);
        },
        vendorEmailSentEvent(event) {
            this.getOrder();
        },
        customerEmailSentEvent(event) {
            this.getOrder();
        },
        vendorDataSaved(vendor) {
            $("#vendorAddModal").modal("hide");
        },
        imagePreview(src) {
            let url = window.route("medias.view", {
                path: "so_attachments",
                id: this.order.order_id,
                name: src,
            });
            this.previewMedia = [
                {
                    thumb: url,
                    src: url,
                    caption: "", // Optional
                    //srcset: '...' // Optional for displaying responsive images
                },
            ];
            this.$refs.lightbox.showImage(0);
        },
        imagePreview1(src) {
            let url = window.route("medias.view", {
                path: "po_attachments",
                id: this.order.id,
                name: src,
            });
            this.previewMedia = [
                {
                    thumb: url,
                    src: url,
                    caption: "", // Optional
                    //srcset: '...' // Optional for displaying responsive images
                },
            ];
            this.$refs.lightbox.showImage(0);
        },
        openSendArtworkToCustomer(product, artwork) {
            //this.product = _.cloneDeep(this.order.products.find((x) => x.order_product_id == product.id))
            this.product = _.cloneDeep(product);
            this.artwork = _.cloneDeep(artwork);
            this.is_one_artwork_for_all = true;
            $("#sendProductArtworkToCustomer").modal("show");
        },
        openSendArtworkToVendor(product) {
            this.product = _.cloneDeep(product);
            this.is_one_artwork_for_all = false;
            setTimeout(() => {
                $("#sendProductArtworkToVendor").modal("show");
            }, 50);
        },
        openSendAllArtworkToVendor() {
            this.product = null;
            this.artwork = null;
            this.is_one_artwork_for_all = true;
            $("#sendProductArtworkToVendor").modal("show");
        },
        openSendAllArtworkToCustomer(is_one_artwork_for_all) {
            this.product = null;
            this.artwork = null;
            this.is_one_artwork_for_all = is_one_artwork_for_all;
            $("#sendProductArtworkToCustomer").modal("show");
        },
        submitHandler() {
            /*this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }
                this.saveOrder();
            });*/
            this.$refs.formValidation.validateWithInfo().then((data) => {
                console.log(
                    "success",
                    data.isValid,
                    data.errors,
                    data.flags,
                    data.fields
                );
                this.validationErrors = data;
                if (!data.isValid) {
                    return;
                }
                this.saveOrder();
            });
        },
        productArtworksUpdated(event) {
            this.getOrder();
        },
        openProductArtworksModal(product) {
            this.product = _.cloneDeep(product);
            setTimeout(() => {
                $("#productArtworksModal").modal("show");
            }, 100);
        },
        openProductArtworkVersionsModal(product) {
            this.product = _.cloneDeep(product);
            $("#productArtworkVersionsModal").modal("show");
        },
        openAllProductsArtworkVersionsModal() {
            $("#allProductsArtworkVersionsModal").modal("show");
        },
        getTotal() {
            let total =
                this.sub_total_cost +
                parseFloat(this.getTotalExtraAmount()) -
                parseFloat(this.getDiscountAmount());
            return total.toFixed(2);
        },
        isNumber(val) {
            return !isNaN(parseFloat(val)) && isFinite(val);
        },
        getTotalExtraAmount() {
            let total = 0;
            if (this.order && this.order.charges.length > 0) {
                this.order.charges.forEach((x) => {
                    if (
                        x.quantity != null &&
                        x.quantity != "" &&
                        x.quantity > 0
                    ) {
                        if(this.isNumber(x.quantity)){
                            total += x.amount * x.quantity;
                        }
                        
                    } else {
                        if(this.isNumber(x.quantity)){
                            total += x.amount;
                        }
                        
                    }
                });
            }
            return total;
        },
        editCharge(charge) {
            this.charge = _.cloneDeep(charge);
            //console.log(this.charge)
            this.bus.$emit("setChargeData", charge);
            $("#purchaseOrderExtraChargeModal").modal("show");
        },
        extraChargeUpdated(event) {
            if (event.oldData) {
                let index = this.order.charges.findIndex(
                    (x) => x.id == event.newData.id
                );
                if (index > -1) {
                    this.order.charges[index] = _.cloneDeep(event.newData);
                }
            } else {
                this.order.charges.push(_.cloneDeep(event.newData));
            }
            this.getOrder();
        },
        discountUpdated(event) {
            this.order.discounts = [_.cloneDeep(event)];
            this.getOrder();
        },
        getDiscountAmount() {
            if (this.order && this.order.discounts.length > 0) {
                if (
                    this.order.discounts[0].isPercentage == "1" ||
                    this.order.discounts[0].isPercentage == 1
                ) {
                    return (
                        (this.sub_total_cost * this.order.discounts[0].amount) /
                        100
                    );
                } else {
                    return this.order.discounts[0].amount;
                }
            }
            return 0;
        },
        saveOrderNote() {
            let self = this;
            this.noteMessage = null;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("ps.notes.store", { id: this.order.id }),
                    {
                        so_id: this.order.id,
                        note_description: this.order_note,
                    },
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.noteMessage = "Note saved successfully";
                        this.order_note = null;
                        self.getOrder();
                        setTimeout(() => {
                            this.noteMessage = null;
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        addNewItem() {},
        removeItem(id) {
            let self = this;
            Vue.$confirm({
                title: "Are you sure?",
                message: "Are you sure you want to delete?",
                button: {
                    yes: "Yes",
                    no: "Cancel",
                },
                callback: (confirm) => {
                    if (confirm) {
                        self.setLoading(true);
                        self.setCommonErrors([]);
                        self.setErrorMessage(null);
                        return axios
                            .delete(
                                window.route("po.products.destroy", {
                                    id: self.order.id,
                                    product_id: id,
                                }),
                                {
                                    validateStatus: function (status) {
                                        return status < 500; // Resolve only if the status code is less than 500
                                    },
                                }
                            )
                            .then(({ data }) => {
                                if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                    if (data.errors) {
                                        self.setCommonErrors(data.errors);
                                    }
                                } else {
                                    self.setSuccessMessage(
                                        "Product deleted from order!"
                                    );
                                    this.order.products.splice(
                                        this.order.products.indexOf(
                                            (x) => x.id == id
                                        ),
                                        1
                                    );
                                    setTimeout(() => {
                                        self.setSuccessMessage(null);
                                    }, 5000);
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(
                                    error.response &&
                                        error.response.errorMessage
                                        ? error.response.errorMessage
                                        : error.message
                                );
                            })
                            .finally(() => {
                                self.setLoading(false);
                            });
                    }
                },
            });
        },
        dropzoneSendingEvent(index) {
            let dropzoneOptions = _.cloneDeep(this.dropzoneOptions);
            dropzoneOptions.prodIndex = index;
            return dropzoneOptions;
        },
        allArtworkUploadError(file, message, xhr, artworkIndex) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        afterAllArtworkUploadComplete(file, response, artworkIndex) {
            this.order.order.artworks[artworkIndex].media = _.cloneDeep(
                response.data.media
            );
            this.order.order.artworks[artworkIndex].media_id =
                response.data.media.id;

            if (this.order.order.artworks[artworkIndex].id == null) {
                this.order.products.forEach((product, pIndex) => {
                    this.order.products[pIndex].artworks.push({
                        id: null,
                        is_approve: 0,
                        attach_link: null,
                        comment: null,
                        updated_at: null,
                        media_id: response.data.media.id,
                        artwork_status_id: 4,
                    });
                });
            }
            this.saveOrder();
        },
        afterAllProductsOriginalFileUploadComplete(file, response) {
            this.order.order.media = _.cloneDeep(response.data.media);
            this.order.order.original_media_id = response.data.media.id;
            if (this.order.order.artworks.length) {
                this.order.order.artworks[
                    this.order.order.artworks.length - 1
                ].customer_file_media_id = response.data.media.id;
            } else {
                this.order.order.artworks.push({
                    id: null,
                    is_approve: 0,
                    attach_link: null,
                    comment: null,
                    updated_at: null,
                    media_id: null,
                    artwork_status_id: 3,
                    customer_file_media_id: response.data.media.id,
                });
            }
            this.saveOrder();
        },
        allProductsOriginalFileUploadError(file, message, xhr) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        afterItemOriginalFileUploadComplete(file, response, index) {
            this.order.products[index].media = _.cloneDeep(response.data.media);
            this.order.products[index].media_id = response.data.media.id;
            if (this.order.products[index].artworks.length) {
                this.order.products[index].artworks[
                    this.order.products[index].artworks.length - 1
                ].customer_file_media_id = response.data.media.id;
            } else {
                this.order.products[index].artworks.push({
                    id: null,
                    is_approve: 0,
                    attach_link: null,
                    comment: null,
                    updated_at: null,
                    media_id: null,
                    artwork_status_id: 3,
                    customer_file_media_id: response.data.media.id,
                });
            }
            this.saveOrder();
        },
        itemOriginalFileUploadError(file, message, xhr, index) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        afterArtworkUploadComplete(file, response, artworkIndex) {
            this.order.artworks[artworkIndex].media = _.cloneDeep(
                response.data.media
            );
            this.order.artworks[artworkIndex].media_id = response.data.media.id;
            //this.isEditMode = true;
            this.saveOrder();
        },
        otherAttachmentUploadError(file, message, xhr, artworkIndex) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        afterItemArtworkUploadComplete(file, response, index, artworkIndex) {
            this.order.products[index].artworks[artworkIndex].media =
                _.cloneDeep(response.data.media);
            this.order.products[index].artworks[artworkIndex].media_id =
                response.data.media.id;
            this.saveOrder();
        },
        itemArtworkUploadError(file, message, xhr, artworkIndex) {
            this.$bvToast.toast(message, {
                title: "Invalid file",
                autoHideDelay: 60000,
                appendToast: true,
                variant: "danger",
                solid: true,
                toaster: "b-toaster-top-center",
            });
        },
        addNewAllProductArtwork() {
            this.order.order.artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
        },
        removeAllProductArtwork(artworkIndex, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route("orders.artworks.destroy", {
                                        id: self.order.order.id,
                                        artwork_id: artwork_id,
                                    }),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        self.order.order.artworks.splice(
                                            artworkIndex,
                                            1
                                        );
                                        if (self.order.order.artworks.length) {
                                            self.order.order.latest_artwork =
                                                _.cloneDeep(
                                                    self.order.order.artworks[
                                                        self.order.order
                                                            .artworks.length - 1
                                                    ]
                                                );
                                        } else {
                                            self.order.order.latest_artwork =
                                                null;
                                        }
                                        self.getOrder();
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.order.artworks.splice(artworkIndex, 1);
            }
        },
        addNewItemAttachVersion(index) {
            this.order.products[index].artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
            this.isEditMode = true;
        },
        addNewItemAttach(index) {
            this.order.products[index].artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null,
                artwork_status_id: 1,
            });
        },
        removeItemAttach(index, artworkIndex, product_id, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route(
                                        "po.products.artworks.destroy",
                                        {
                                            id: self.order.id,
                                            product_id: product_id,
                                            artwork_id: artwork_id,
                                        }
                                    ),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        this.getOrder();
                                        self.order.products[
                                            index
                                        ].artworks.splice(artworkIndex, 1);
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.products[index].artworks.splice(artworkIndex, 1);
            }
        },
        goToCreateVendor() {},
        findShippingAddress() {},
        goToCreateCustomer() {},
        addNewOtherAttach() {
            this.isEditMode = true;
            this.order.artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                artwork_status_id: 1,
            });
        },
        removeOtherAttach(artworkIndex, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: "Are you sure?",
                    message: "Are you sure you want to delete?",
                    button: {
                        yes: "Yes",
                        no: "Cancel",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios
                                .delete(
                                    window.route("po.artworks.destroy", {
                                        id: self.order.id,
                                        artwork_id: artwork_id,
                                    }),
                                    {
                                        validateStatus: function (status) {
                                            return status < 500; // Resolve only if the status code is less than 500
                                        },
                                    }
                                )
                                .then(({ data }) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage(
                                            "Artwork deleted!"
                                        );
                                        this.getOrder();
                                        self.order.artworks.splice(
                                            artworkIndex,
                                            1
                                        );
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(
                                        error.response &&
                                            error.response.errorMessage
                                            ? error.response.errorMessage
                                            : error.message
                                    );
                                })
                                .finally(() => {
                                    self.setLoading(false);
                                });
                        }
                    },
                });
            } else {
                this.order.artworks.splice(artworkIndex, 1);
            }
        },
        addNewCustomerAttach() {},
        removeCustomerAttach(id) {},
        saveOrder(e) {
            let self = this;
            this.submitted = true;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .put(
                    window.route("purchase-orders.update", {
                        id: this.order.id,
                    }),
                    this.order,
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {

                    $('#editSalesOrderDetailsModal').modal('hide');
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage("Order saved successfully!");
                        self.isEditMode = false;
                        self.getOrder();
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        copyPoOrder() {
            let newOrder = {
                vendor: null,
                order_id: null,
                vendor_id: null,
                is_draft: 0,
                po_number: null,
                order_date: null,
                vendor_terms: null,
                vendor_po: null,
                vendor_fob: null,
                eta: null,
                delivery_date: null,
                notes: null,
                vendor_notes: null,
                po_status_id: 1,
                products: [],
                selectedProducts: [],
                quote_num: null,
            };

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(
                    window.route("po.clone", { id: this.order.id }),
                    {},
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        newOrder = _.cloneDeep(data.data.order);
                        this.setNewPurchaseOrder(newOrder);
                        this.$router.push({ name: "purchaseSelectProducts" });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        changeEditMode(mode) {
            this.isEditMode = mode;
        },
        artworkSampleRequiredEvent() {
            //this.changeEditMode(true);
           // this.$refs.artworkRef.click();
           $('.nav a[href="#arrow-attach"]').tab('show');
        },

        getOrderStatuses() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("purchase-orders-status.index", {}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.statuses = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        getCompanyWarehouse() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("getWarehouses.company", {}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        console.log("company warehouse ",data);
                        this.companyWarehouse = data.data;
                        //this.statuses = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },

        getCustomerWarehouse() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("getWarehouses.customer", {customer_id:this.order.order.customer_id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerWarehouse = data.data;
                         console.log("customer warehouse ",data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getQuantityUnits() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("so-quantity-units.index"), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.quantityUnits = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        getOrder() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(
                    window.route("purchase-orders.show", {
                        id: this.$route.params.id,
                    }),
                    {
                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        },
                    }
                )
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.labels = _.cloneDeep(data.labels);
                        this.admin_users = _.cloneDeep(data.admin_users);
                        data.data.new_admin_users = [];
                        if (data.data.admin_users) {
                            data.data.admin_users.forEach((x) => {
                                data.data.new_admin_users.push(x.admin);
                            });
                        }

                        if (
                            data.data.order.artworks &&
                            data.data.order.artworks.length > 0 &&
                            data.data.order.latest_artwork == null
                        ) {
                            data.data.order.latest_artwork = _.cloneDeep(
                                data.data.order.artworks[
                                    data.data.order.artworks.length - 1
                                ]
                            );
                        }

                        data.data.products.forEach((x) => {
                            if (
                                x.order_product.artworks &&
                                x.order_product.artworks.length > 0 &&
                                x.order_product.latest_artwork == null
                            ) {
                                x.order_product.latest_artwork = _.cloneDeep(
                                    x.order_product.artworks[
                                        x.order_product.artworks.length - 1
                                    ]
                                );
                            }
                        });

                        this.order = data.data;
                        if(this.order.pdf_note == null || this.order.pdf_note == ''){
                            
                            this.order.pdf_note = data.default_po_pdf_note
                        }
                        
                        
                        
                        this.artwork_statuses = data.artwork_statuses;
                        this.quotations = data.quotations;
                        this.eachProductsHasArtwork = false;

                        this.newLabelId = [];
                        this.order.labels.forEach((l) => {
                            this.newLabelId.push(l.id);
                        });

                        if (
                            this.order.order.original_customer_file &&
                            this.order.order.customer_file_media_id &&
                            this.order.order.artworks.length == 0
                        ) {
                            this.order.order.artworks.push({
                                id: null,
                                is_approve: 0,
                                attach_link: null,
                                comment: null,
                                updated_at: null,
                                media_id: null,
                                artwork_status_id: 1,
                                customer_file_media_id:
                                    this.order.order.customer_file_media_id,
                            });
                        }

                        if (this.order.products && this.order.products.length) {
                            this.eachProductsHasArtwork =
                                this.order.products.filter(
                                    (x) =>
                                        x.id &&
                                        x.order_product &&
                                        x.order_product.artworks &&
                                        x.order_product.artworks.filter(
                                            (y) => y.id && y.attach_link != null
                                        ).length > 0
                                ).length > 0;
                            this.sub_total_cost = 0;
                            this.order.products.forEach((x, index) => {
                                if (!isNaN(parseInt(x.cost))) {
                                    this.sub_total_cost += parseInt(x.cost);
                                }
                                if (
                                    x.order_product &&
                                    x.order_product.artworks &&
                                    x.order_product.artworks.length
                                ) {
                                    this.order.products[index].artworks =
                                        _.cloneDeep(x.order_product.artworks);
                                    this.order.products[index].latest_artwork =
                                        _.cloneDeep(
                                            x.order_product.latest_artwork
                                        );

                                    if (
                                        x.order_product
                                            .original_customer_file &&
                                        x.order_product.uploaded_media_id &&
                                        this.order.products[index].artworks
                                            .length == 0
                                    ) {
                                        x.artworks.push({
                                            id: null,
                                            is_approve: 0,
                                            attach_link: null,
                                            comment: null,
                                            updated_at: null,
                                            media_id: null,
                                            artwork_status_id: 1,
                                            customer_file_media_id:
                                                x.order_product
                                                    .uploaded_media_id,
                                        });
                                    }
                                }
                            });
                        }
                        this.getCompanyWarehouse();
                        this.getCustomerWarehouse();
                        this.getDueTasks();
                        this.bus.$emit("triggerGetTasks");
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        download(artwork) {
            let url = window.route("medias.download", {
                path: "po_attachments",
                id: this.order.order_id,
                name: artwork.attach_link,
                pdf_to_image: 0,
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", artwork.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        download1(artwork) {
            let url = window.route("medias.download", {
                path: "po_attachments",
                id: this.order.id,
                name: artwork.attach_link,
                pdf_to_image: 0,
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", artwork.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        downloadOriginalArtwork(original_customer_file) {
            let url = window.route("medias.download", {
                path: "po_attachments",
                id: this.order.order.id,
                name: original_customer_file,
                pdf_to_image: 0,
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", original_customer_file);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        updatedTaskEvent() {
            this.getOrder();
        },
        downloadPdf() {
            let url = window.route("po.download", { id: this.order.id });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(url, {
                    responseType: "blob",
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute(
                        "download",
                        "po_" + this.order.po_number + ".pdf"
                    );
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
    },
    watch: {
        shipmentId: {
            handler: function (after, before) {
                if (after != null) {
                    alert("changed data " + after);
                }

                // if(after !== before) {
                //     this.saveOrder();
                // }
                this.shipmentId = null;
            },
        },
        changeUnitQuantity:{
            handler: function (after, before) {
                if (after != null) {
                    console.log("order Products ",this.order.products);
                    this.order.products.forEach((x, index) => {
                        this.order.products[index].qty_unit_id = after;

                    })
                   // alert("changed data " + after);
                }

                
            },
        }

        /*"order.is_artwork_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        },
        "order.is_deposit_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        },
        "order.is_sample_required": {
            handler: function (after, before) {
                if(after !== before) {
                    this.saveOrder();
                }
            }
        }*/
    },
    computed: {
        ...mapState(["userState", "purchaseOrderState"]),
        ...mapGetters([
            "isAuth",
            "getAuthUser",
            "commonErrors",
            "errorMessage",
            "successMessage",
            "loading",
            "carriersState",
            "shipmentBackProduct",
        ]),
    },
};
</script>

<style scoped>
.error {
    color: red;
}
.dropzone-previews {
    display: none !important;
}
</style>
